import React, { Component } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import MQSGUtil from "../mqsgUtil";
import ReactTooltip from "react-tooltip";
import highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import DatePicker from "react-datepicker";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import nodata from "highcharts/modules/no-data-to-display";
import "./warranthedgingtool.css";
nodata(highcharts);
class TermsSummary extends Component {
    getData(data, fieldName) {
        if (data !== null && fieldName in data) {
            return data[fieldName];
        }
        return "";
    }

    // Returning either "upval", "downval", or "" as the CSS class for displaying these up, down or no-change value
    getUpDownClass(nc) {
        if (nc) {
            let ncstring = nc.toString();
            let ncval = Number(nc);

            // Check if 0
            if (ncval === 0) {
                return "";
            }
            // If -nnn ?
            else if (ncstring.length > 1 && ncstring.startsWith("-")) {
                return "val down";
            }
            // If +nnn ?
            else if ((ncstring.length > 1 && ncstring.startsWith("+")) || ncval > 0) {
                return "val up";
            }
        }

        // Any other case, return ""
        return "";
    }

    render() {
        let show = 'table';
        if (this.props.tabNum == false) {
            show = 'none'
        }
        let warrantdata = this.props.warrantdata;
        let ticker =
            this.getData(warrantdata, "dsply_nmll") +
            " (" +
            this.getData(warrantdata, "ticker") +
            ")";
        let bidval = this.getData(warrantdata, "BID");
        let bidchg = this.getData(warrantdata, "BID_NETCHNG");
        let bidchgupdown = this.getUpDownClass(bidchg);
        let bidpchg = this.getData(warrantdata, "BID_PCTCHNG") + "%";
        let bidpchgupdown = this.getUpDownClass(bidpchg);

        return (
            <div id="dwsummary" style={{ position: "relative" }}>
                <div className="ricbar">
                    <div id="ticker" className="tickerbar bgcolor-03">
                        {ticker}
                    </div>
                 
                </div>
                <table id="pricetbl" className="uppertbl" style={{ display: show }}>
                    <colgroup>
                        <col style={{ backgroundColor: "#E7E8E8", padding: "3px" }} />
                        <col
                            style={{
                                backgroundColor: "#F5F6F7",
                                padding: "3px",
                                textAlign: "left",
                            }}
                        />
                        <col
                            style={{
                                backgroundColor: "#F5F6F7",
                                padding: "3px",
                                textAlign: "right",
                            }}
                        />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td className="uppertbl-col-bid" rowSpan="2" style={{ textAlign: 'left' }}>
                                <div className="bidprice lbl">Bid price</div>
                                <div id="bidval" className="bidprice val">
                                    {bidval}
                                </div>
                            </td>
                            <td className="uppertbl-col-chglbl">Change</td>
                            <td id="bidchg" className={"uppertbl-col-chgval " + bidchgupdown}>
                                {bidchg}
                            </td>
                        </tr>
                        <tr>
                            <td className="uppertbl-col-pchglbl">%Change</td>
                            <td
                                id="bidpchg"
                                className={"uppertbl-col-pchgval " + bidpchgupdown}
                            >
                                {bidpchg}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
class LiveMatrixPriceTable extends Component {
    render() {
        let ricdata = this.props.ricdata;
        // let underlyingticker = MQSGUtil.getData(ricdata, "underlying_ticker");
        let underlyingticker =
            MQSGUtil.getUnderlyingTickerDisplayName(MQSGUtil.getData(ricdata, "underlying_ric"), MQSGUtil.getData(ricdata, "underlying_ticker"));
        let effectivegearing = MQSGUtil.getData(ricdata, "effective_gearing");
        let type = MQSGUtil.getData(ricdata, "type");
        let delta = MQSGUtil.getData(ricdata, "delta");
        let exerciseprice = MQSGUtil.getData(ricdata, "exercise_price");
        let impliedvolatility = MQSGUtil.getData(ricdata, "implied_volatility");
        let wrntpershare = MQSGUtil.getData(ricdata, "wrnt_per_share");
        let lasttradingdate = MQSGUtil.getData(ricdata, "last_trading_date");

        return (
            <table className="pricetbl table tableSize">
                <tbody>
                    <tr>
                        <th className="srtable-leftlbl bgcolor-01">Underlying</th>
                        <td
                            id="underlying_ticker"
                            className="srtable-leftval bgcolor-01"
                            style={{ border: 0 }}
                        >
                            {underlyingticker}
                        </td>
                        <th className="srtable-rightlbl bgcolor-02" style={{ border: 0 }}>
                            Effective gearing(X)
                        </th>
                        <td id="effective_gearing" className="srtable-rightval bgcolor-02">
                            {effectivegearing}
                        </td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td id="type">{type}</td>
                        <th>Delta(%)</th>
                        <td id="delta">{delta}</td>
                    </tr>
                    <tr>
                        <th className="bgcolor-01">Strike</th>
                        <td
                            id="exercise_price"
                            className="bgcolor-01"
                            style={{ border: 0 }}
                        >
                            {exerciseprice}
                        </td>
                        <th className="bgcolor-02">Volatility(%)</th>
                        <td id="implied_volatility" className="bgcolor-02">
                            {impliedvolatility}
                        </td>
                    </tr>
                    <tr>
                        <th>Exercise ratio</th>
                        <td id="wrnt_per_share">{wrntpershare}</td>
                        <th>Last trading date</th>
                        <td id="last_trading_date">{lasttradingdate}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}
function LiveMatrixMarketHourTable() {
    return (
        <table
            className="markethourtbl table table-striped table-left"
            style={{ tableLayout: "auto", backgroundColor: "unset" }}
        >
            <tbody style={{ textAlign: 'left' }}>
                <tr>
                    <th>Hong Kong stock warrants: </th>
                    <td>
                        9.30am to 11.58am,
                        <br className="visible-xs" /><br className="visible-minpc" /> 1.00pm to 3.58pm{" "}
                    </td>
                </tr>
                <tr>
                    <th>HSI warrants:</th>
                    <td>
                        9.15am to 11.58am,
                        <br className="visible-xs" /><br className="visible-minpc" /> 1.00pm to 4.28pm
                    </td>
                </tr>
                <tr>
                    <th>Nikkei225 warrants:</th>
                    <td>
                        9:00am to 11:58am,
                        <br className="visible-xs" /><br className="visible-minpc" /> 1:00pm to 2:53pm,
                        <br className="visible-xs" /><br className="visible-pc" /> 3:10pm to 4:58pm
                    </td>
                </tr>
                <tr>
                    <th>US index warrants:</th>
                    <td>
                        9.00am to 11:58am,
                        <br className="visible-xs" /><br className="visible-minpc" /> 1:00pm to 4:58pm
                    </td>
                </tr>
                <tr>
                    <th>Singapore stocks:</th>
                    <td>
                        9.00am to 11:58am,
                        <br className="visible-xs" /><br className="visible-minpc" /> 1:00pm to 4:58pm
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

class TextDescription extends Component {
    render() {
        return (
            <div>
                <div id="lmatrix_tbl_f" className="hidden-sm hidden-xs">
                    <ol>
                        <li>
                            The warrant prices in the live matrix are indicative. The actual
                            price of the warrants in the market may be different from the
                            prices displayed on the website due to factors such as 1) the
                            liquidity and the volatility of the warrant and the underlying as
                            well as the relevant market conditions 2) the buying and the
                            selling that is driven by the supply and the demand in the market
                            3) the delay in displaying the price 4) the various rights of the
                            underlying and other factors that are beyond the control of
                            derivative warrant’s issuer, the market maker, the relevant
                            parties or the unexpected situations. Macquarie reserves the
                            rights to consider the terms and the conditions on buying back or
                            selling warrants on case-by-case basis, at its sole discretion.
                        </li>
                        <li>
                            There may be occasional delays in the data feed and any
                            information in the live matrix. Only continuous trading session
                            prices are shown.
                        </li>
                        <li>
                            The warrant price are provided for your personal use and is
                            intended for information purpose only and does not constitute an
                            offer, a solicitation, an advice, a recommendation or an
                            indication to buy or sell the underlying securities or warrant.
                            Macquarie shall not be liable for the accuracy or completeness of
                            any information or for any loss or damage however caused arising
                            in connection with any information, including without limitation
                            any direct, indirect, special or consequential loss and loss of
                            profits whether in part or in full.
                        </li>
                    </ol>
                    <hr />
                    <p className="small">
                        All market data is delayed 15 mins unless otherwise indicated by
                        timestamp.
                    </p>
                </div>

                <div
                    className="panel-group visible-xs-block visible-sm-block"
                    id="defination"
                >
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <a
                                data-toggle="collapse"
                                data-parent="#defination"
                                href="#collapse_dwcompare3"
                            >
                                <span className="glyphicon glyphicon glyphicon-question-sign pull-right"></span>
                                <div
                                    id="collapse_title3"
                                    className="panel-title text-center color-primary"
                                >
                                    Definition &amp; disclaimer
                                </div>
                            </a>
                        </div>
                        <div id="collapse_dwcompare3" className="panel-collapse collapse">
                            <div id="lmatrix_tbl_f">
                                <ol>
                                    <li>
                                        The warrant prices in the live matrix are indicative. The
                                        actual price of the warrants in the market may be different
                                        from the prices displayed on the website due to factors such
                                        as 1) the liquidity and the volatility of the warrant and
                                        the underlying as well as the relevant market conditions 2)
                                        the buying and the selling that is driven by the supply and
                                        the demand in the market 3) the delay in displaying the
                                        price 4) the various rights of the underlying and other
                                        factors that are beyond the control of derivative warrant’s
                                        issuer, the market maker, the relevant parties or the
                                        unexpected situations. Macquarie reserves the rights to
                                        consider the terms and the conditions on buying back or
                                        selling warrants on case-by-case basis, at its sole
                                        discretion.
                                    </li>
                                    <li>
                                        There may be occasional delays in the data feed and any
                                        information in the live matrix. Only continuous trading
                                        session prices are shown.
                                    </li>
                                    <li>
                                        The warrant price are provided for your personal use and is
                                        intended for information purpose only and does not
                                        constitute an offer, a solicitation, an advice, a
                                        recommendation or an indication to buy or sell the
                                        underlying securities or warrant. Macquarie shall not be
                                        liable for the accuracy or completeness of any information
                                        or for any loss or damage however caused arising in
                                        connection with any information, including without
                                        limitation any direct, indirect, special or consequential
                                        loss and loss of profits whether in part or in full.
                                    </li>
                                </ol>
                                <hr />
                                <p className="small">
                                    All market data is delayed 15 mins unless otherwise indicated
                                    by timestamp.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
class LiveMatrixTodayTable extends Component {
    getTableContent(page) {
        if (this.props.logic !== null && typeof this.props.logic.getTableContent === 'function') {
            return this.props.logic.getTableContent(this.props.page);
        }
        return null;
    }
    getRicData() {
        if (this.props.logic !== null) {
            if ("ric_data" in this.props.logic) {
                return this.state.livematrixdata.ric_data;
            }
        }
        return null;
    }

    getLastUpdate() {
        if (this.props.date !== null) {
            return this.props.date;
        }
        return "-";
    }
    getPrintRow() {
        if (this.isHome()) {
            return null;
        }
        const title = `Live matrix | Singapore Warrants | Macquarie`;
        return (
            <tr>
                <th
                    colSpan="4"
                    className="th-left"
                    style={{
                        borderBottom: "0px",
                        padding: "0px 0px",
                        textAlign: "left",
                    }}
                >
                    {/* <ReactToPrint
              content={() => this.tableRef}
              documentTitle={title}
              trigger={() => (
                <img
                  className="printimg"
                  src="/img/bullet/print.png"
                  alt="print live matrix"
                  // onClick={this.print}
                />
              )}
            /> */}
                    <img
                        className="printimg"
                        src="/img/bullet/print.png"
                        alt="print live matrix"
                        onClick={this.print}
                        style={{
                            width: '20px',
                            marginTop: '-8px',
                            cursor: 'pointer'
                        }}
                    />
                </th>
            </tr>
        );
    }
    print() {
        // let oldHtml = document.body.innerHTML;
        // let newHtml = document.getElementById("lmtablecontainer").innerHTML;
        // document.body.innerHTML = newHtml;
        // window.print();
        // document.body.innerHTML = oldHtml;
        // window.location.reload();
        $("#lmtablecontainer").printThis({
            pageTitle: $(document).find("title").text() + " | " + $("#ticker").html(),
            loadCSS: ["/src/pages/tools/livematrix/livematrix.css", "/css/global.css"],
            // importStyle: ["<style>html{background:'#fff'}}</style>"]
        });


      
    }
    isHome() {
        if (this.props.page !== undefined && this.props.page !== null) {
            if (this.props.page === "home") {
                return true;
            }
        }
        return false;
    }
    getCurrency(symbol){
        if(symbol === null){
            return null;
        }
        const symbolSname = symbol.underlying_ticker;
        if (
        symbol.underlying_ric && symbol.underlying_ric.endsWith(".HK")  && symbolSname !== "2823"  && symbolSname !== "3067"
        ) {
            return "HK";
        } else if (
        symbolSname === "HSI" ||
        symbolSname === "N225" ||
        symbolSname === "S&P500" ||
        symbolSname === "STI" ||
        symbolSname === "HANG SENG TECH INDEX" ||
        symbolSname === "SiMSCI" ||
        symbolSname === "SEA" ||
        symbolSname === "NDX" ||
        symbolSname === "DJI"
        ) {
            return symbolSname;
        }
            return "SG";
    }
    cleanHtmlContent(html) {
        if (!html) return '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const body = doc.body;

        // 如果 body 中只有一个子元素且是 <p>，则提取其 innerHTML
        if (body.children.length === 1 && body.children[0].tagName === 'P') {
            return body.children[0].innerHTML;
        }
        // 否则保留原内容（可能包含多个段落或复杂结构）
        return html;
    }
    getMsgForSelectValue() {
        if (this.props.symbols == null || this.isHome()===true) return [];
        var getMessage = this.props.symbols.find((item) => item["ric"] == this.props.selected?.value);
        if (getMessage?.status == undefined || getMessage?.status === '0') {
            return [];
        }
        if(this.props.logic !== null){
            let data = this.props.logic?.livematrix;
            let ric_data = this.props.logic?.ricdata;
            let messages = [];
            let message1 = false;
            // ========== Message1 逻辑 ==========
            let currency = this.getCurrency(ric_data);
            if(currency !== null){
                for(let i = 0; i<data.length;i++){
                    let message1Hit = false;
                    let results = (data[i].underlying_ask - data[i].underlying_bid).toFixed(4);
                    if(currency === 'HSI'){
                        if(results <= 1){
                            message1Hit = true;
                        }
                    }else if(currency === 'N225'){
                        if(results <= 5){
                            message1Hit = true;
                        }
                    }else if(currency === 'S&P500' || currency === 'NDX'){
                        if(results <= 0.25){
                            message1Hit = true;
                        }
                    }else if(currency === 'SiMSCI'){
                        if(results <= 0.05){
                            message1Hit = true;
                        }
                    }else if(currency === 'HK'){
                        if(data[i].underlying_bid >=0.50 && data[i].underlying_bid < 20){
                            if(results <= 0.01){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=20 && data[i].underlying_bid < 50){
                            if(results <= 0.02){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=50 && data[i].underlying_bid < 100){
                            if(results <= 0.05){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=100 && data[i].underlying_bid < 200){
                            if(results <= 0.10){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=200 && data[i].underlying_bid < 500){
                            if(results <= 0.20){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=500 && data[i].underlying_bid < 1000){
                            if(results <= 0.50){
                                message1Hit = true;
                            }
                        }else if(data[i].underlying_bid >=1000){
                            if(results <= 1.00){
                                message1Hit = true;
                            }
                        }
                    }else if(currency === 'SG'){
                            if(data[i].underlying_bid <= 1){
                                if(results <= 0.005){
                                    message1Hit = true;
                                }
                            }else if(data[i].underlying_bid <= 3){
                                if(results <= 0.01){
                                    message1Hit = true;
                                }
                            }else if(data[i].underlying_bid <= 5){
                                if(results <= 0.02){
                                    message1Hit = true;
                                }
                            }else if(data[i].underlying_bid <= 10){
                                if(results <= 0.05){
                                    message1Hit = true;
                                }
                            }else if(data[i].underlying_bid > 10){
                                if(results <= 0.10){
                                    message1Hit = true;
                                }
                            }
                    }
                    if(message1Hit){
                        if (data[i].bid >= 0.2) {
                            if ((data[i].ask - data[i].bid).toFixed(3) > 0.01) {
                                message1 = true;
                                break;
                            }
                        } else {
                            if ((data[i].ask - data[i].bid).toFixed(4) > 0.002) {
                                message1 = true;
                                break;
                            }
                        }
                    }
                }
            }
            if (message1) {
                messages.push(1);
            }
            // ========== Message2 逻辑 ==========
            // Message2 BID <= 0.001 时追加 2
            if (ric_data?.BID <= 0.001) {
                messages.push(2);
            }
            // ========== Message3 逻辑 ==========
            // maturity 落在当前时刻到未来30天窗口内时追加 3
            let today = new Date().getTime();
            let maturity = new Date(ric_data?.maturity).getTime(); 
            let thirtyDaysLater = today + 30 * 24 * 60 * 60 * 1000; // 30天的毫秒数
            if (maturity >= today && maturity <= thirtyDaysLater) {
                messages.push(3);
            }
            // ========== Message4 逻辑 ==========
            // RIC 在 dw_hot_list 中时追加 4
            if (ric_data?.HOTLIST?.length>0 && ric_data?.HOTLIST.includes(ric_data?.ric)) {
                messages.push(4);
            }
            messages.push(5);
            if(messages.length>0){
                let value = [];
                for(let i = 0; i<messages.length;i++){
                for(let j=0;j<(this.props.messageList?.length || 0);j++){
                    let msgItem = this.props.messageList?.[j];
                    if(messages[i] == msgItem?.id && msgItem?.visible==true){
                    value.push({ id: messages[i], html: msgItem?.en_msg })
                    }
                }
                }
                return value;
            }else{
                return [];
            }
        }
    }
    render() {
        let isLoading = this.props.isLoading;
        let className = '';
        if (isLoading) {
            className += " selector-loadingindicator";
        }
        let printRow = this.getPrintRow();
        let showAll = true;
        let show = false;
        if (
            this.getTableContent(this.props.page)
        ) {
            if (this.getTableContent(this.props.page)?.length === 0) {
                if (this.isHome() === true) {
                    showAll = false;
                } else {
                    showAll = true;
                    if (isLoading) {
                        show = false;
                    } else {
                        show = true;
                    }

                }
            }

        } else {
            if (this.isHome() === true) {
                showAll = false;
            } else {
                showAll = true;
                if (isLoading) {
                    show = false;
                } else {
                    show = true;
                }

            }
        }
        let isSti = false;
        if (this.props.logic !== null) {
            if (this.props.logic?.isSTI) {
                isSti = true;
            } else {
                isSti = false;
            }
        }
        let isWarrantsShow = false;
        let isUnderyingShow = false;
        let future_dsply_name = '';
        if (
            typeof this.props.selected !== "undefined" &&
            this.props.selected !== null
        ) {
            let label = this.props.selected?.label || '';
            if (
                label.indexOf('S&P') !== -1 ||
                label.indexOf('DJI') !== -1 ||
                label.indexOf('HSI') !== -1 ||
                label.indexOf('HSTECH') !== -1 ||
                label.indexOf('NKY') !== -1 ||
                label.indexOf('SIMSCI') !== -1 ||
                label.indexOf('Sea') !== -1 ||
                label.indexOf('NASDAQ') !== -1
            ) {
                isWarrantsShow = true;
            } else {
                let futureDsplyName = this.props.selected?.future_dsply_name;
                if (futureDsplyName && futureDsplyName !== '' && futureDsplyName !== '-') {
                    isUnderyingShow = true;
                    future_dsply_name = futureDsplyName;
                }
            }
        }
        return (
            <div>
                {this.props.logic && !this.isHome() && <div id="dwterms">
                    <TermsSummary
                        warrantdata={this.props.logic?.ricdata}
                        tabNum={false}
                    />
                </div>}
                <div >
                    <p style={{ marginTop: '10px', marginBottom: '0px', display: isWarrantsShow ? 'block' : 'none' }}>
                        Refer to <Link to="/education/Indexfuturesrollover" style={{ color: "#0675C2" }}>Index futures rollover</Link> page to find out the relevant index futures contract that the warrants are tracking.
                    </p>
                    <p id="p-contract" style={{ marginTop: '10px', marginBottom: '0px', display: isUnderyingShow ? 'block' : 'none' }}>Underlying price below refers to the relevant Index Futures contract

                        <span> over</span>
                        <span className="text-bold"> {future_dsply_name}</span>
                    </p>
                </div>
                <div
                    id="lmtablecontainer"
                    ref={(el) => (this.tableRef = el)}
                    className={className}
                    style={{ paddingTop: "10px", overflowX: 'auto' }}
                >
                    {/* startprint */}
                    <div style={{ display: this.props.tabNum == 3 ? 'block' : 'none' }}>
                        <p style={{ marginTop: '10px', marginBottom: '0px', display: isWarrantsShow ? 'block' : 'none' }}>
                            Refer to <Link to="/education/Indexfuturesrollover" style={{ color: "#0675C2" }}>Index futures rollover</Link> page to find out the relevant index futures contract that the warrants are tracking.
                        </p>
                        <p id="p-contract" style={{ marginTop: '10px', marginBottom: '0px', display: isUnderyingShow ? 'block' : 'none' }}>Underlying price below refers to the relevant Index Futures contract

                            <span> over</span>
                            <span className="text-bold"> {future_dsply_name}</span>
                        </p>
                    </div>
                    {
                        (() => {
                        const messages = this.getMsgForSelectValue();
                        if (!messages || messages.length === 0) return null;
                        const msgPrefix = {
                            1: 'Spread warning - ',
                            2: 'Price warning - ',
                            3: 'Expiry warning - ',
                            4: 'Trending warrant - '
                        };
                        const msgIcon = {
                            1: '/img/bullet/Spread.png',
                            2: '/img/bullet/price.png',
                            3: '/img/bullet/expiry.fw.png',
                            4: '/img/bullet/hot.fw.png'
                        };
                        return (
                        <div style={{
                            marginBottom: '10px',
                            border: '1px solid #E0E0E0',
                            borderRadius: '4px',
                            overflow: 'hidden'
                        }}>
                            {
                                messages.map((item, k, arr) => {
                                    const prefix = msgPrefix[item.id] || '';
                                    const iconSrc = msgIcon[item.id];
                                    return (
                                        <div
                                            key={k}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                backgroundColor: '#F5F6F7',
                                                padding: '10px 15px',
                                                borderBottom: k === arr.length - 1 ? 'none' : '1px solid #E0E0E0',
                                                fontSize: '14px',
                                                textAlign: 'left'
                                            }}
                                        >
                                            {iconSrc && <img src={iconSrc} alt="" style={{ width: '20px', height: '20px', flexShrink: 0, marginRight: '15px' }} />}
                                            <span style={{ flex: 1 }}>
                                                {prefix && <strong>{prefix}</strong>}
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: this.cleanHtmlContent(item.html)
                                                    }}
                                                >
                                                </span>
                                            </span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        );
                        })()
                    }
                    <table
                        id="today_table"
                        className="table lbtable"
                        style={{
                            position: "relative",
                            width: '100%'
                        }}
                    >
                        <thead
                            style={{
                                position: "relative",
                                display: showAll ? "revert" : "none",
                            }}
                        >
                            {printRow}
                            <tr>
                                <th width="30%">
                                    <span className="th-left th-callbid">{this.props.logic && this.props.logic.ricdata?.type == 'PUT' ? 'Underlying offer' : 'Underlying bid'}</span>
                                </th>
                                <th width="20%">
                                    <span className="th-left">Warrant bid</span>
                                </th>
                                <th width="20%">
                                    <span className="th-right">Warrant offer</span>
                                </th>
                                <th width="20%">
                                    <span className="th-right th-calloffer">{this.props.logic && this.props.logic.ricdata?.type !== 'PUT' ? 'Underlying offer' : 'Underlying bid'}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>{this.getTableContent(this.props.page)}</tbody>
                        <tbody
                            style={{
                                display: show ? "revert" : "none",
                            }}
                        >
                            <tr>
                                <td
                                    colSpan="6"
                                    className="text-content"
                                    style={{ fontSize: "16px" }}
                                >
                                    There is no matrix available for this warrant, as the warrant
                                    has no value at current levels in the underlying

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {/* endprint */}
                </div>
                {
                    !this.isHome() && (
                        <div>
                            <div style={{ clear: "both" }}></div>
                            <div id="bottom_area" className="livematrix_valid">
                                <div id="srtable" style={{ overflowX: 'unset' }}>
                                    {/* <div style={{ display: this.state.tabNum == 4 || this.state.tabNum == 3 ? 'none' : 'block', overflowX: 'auto' }}>
                            <LiveMatrixPriceTable ricdata={this.getRicData()} />
                        </div> */}
                                    <div id="last_update">
                                        Last update: <span>{this.getLastUpdate()}</span>
                                    </div>
                                    <p>
                                        The above price matrix is a direct live feed from
                                        Macquarie’s market making system. It indicates where the
                                        market maker’s bids and offers may be based on various
                                        price points in the stock or index, and as at the last
                                        updated time stamp. Please manually refresh the live
                                        matrix for the latest prices. Note that the live matrix
                                        may not be accurate outside of market making hours. These
                                        are:
                                    </p>
                                    <div style={{ overflowX: 'auto' }}>
                                        <LiveMatrixMarketHourTable />
                                    </div>
                                </div>
                                {/* 文字说明 */}
                                <TextDescription />
                            </div>
                        </div>
                    )
                }

            </div>
        );
    }
}
class IndtableShow extends Component {
    // 打开条款说明书
    changeTermSheetLink() {
        let ric = this.getData("ric");
        window.open(`https://www.warrants.com.sg/apimqsg/pdf?type=termsheet&id=` + ric, "_blank");
    }

    getData(fieldName, dp = null) {
        if (
            this.props.warrantdata !== null &&
            fieldName in this.props.warrantdata
        ) {
            let value = this.props.warrantdata[fieldName];
            if (dp !== null) {
                return Number(value).toFixed(dp);
            }
            return value;
        }
        return "";
    }

    getTheta() {
        // "last_trading_date": "23 Feb 21"
        let lasttradingdate = this.getData("last_trading_date");
        let currDate = new Date();
        let currDateMS = currDate.getTime();
        if (lasttradingdate.length > 0) {
            let lasttradingdateMS = Date.parse(lasttradingdate);
            let diff = currDateMS - lasttradingdateMS;
            // check if expired
            if (diff <= 24 * 60 * 60 * 1000) {
                return this.getData("theta", 4);
            }
        }
        return "-";
    }

    getMoneynessClass(nc) {
        let cnm = "";
        let value = Number(nc);
        if (!isNaN(value)) {
            if (value === 1) {
                cnm = "val mny up";
            } else if (value === 2) {
                cnm = "val mny down";
            }
        }
        return cnm;
    }

    getMoneynessName(nc) {
        let nm = "";
        let value = Number(nc);
        if (!isNaN(value)) {
            if (value === 1) {
                return "ITM";
            } else if (value === 2) {
                return "OTM";
            } else {
                return "ATM";
            }
        }
        return nm;
    }

    render() {
        let hstclose = this.getData("HST_CLOSE");
        let trdprc1 = this.getData("TRDPRC_1");
        let openprc = this.getData("OPEN_PRC");
        let acvol1scaled = this.getData("ACVOL_1_SCALED");
        let high1 = this.getData("HIGH_1");
        let turnoverscaled = this.getData("TURNOVER_SCALED");
        let low1 = this.getData("LOW_1");
        // #1365
        let underlyingprice = this.getData("showUnderlying_price");
        let ticker = this.getData("ticker");
        let effectivegearing = this.getData("effective_gearing");
        let underlying_ticker = this.getData("underlying_ticker");
        let underlyingticker =
            MQSGUtil.getUnderlyingTickerDisplayName(this.getData("underlying_ric"), this.getData("underlying_ticker"));
        let delta = this.getData("delta");
        let type = this.getData("type");
        let deltaperwrnt = this.getData("delta_per_wrnt");
        let issuername = this.getData("issuer_name");
        let sensitivity = this.getData("sensitivity");
        // let exerciseprice = this.getData("exercise_price");
        let breakevenprice = this.getData("breakeven_price");
        let tradedate = this.getData("TRADE_DATE");
        let premium = this.getData("premium");
        let maturity = this.getData("maturity");
        let impliedvolatility = this.getData("implied_volatility");
        let lasttradingdate = this.getData("last_trading_date");
        let theta = this.getTheta();
        let daystomaturity = this.getData("days_to_maturity") + " days";
        let intrinsicvalue = this.getData("intrinsic_value");
        let convratio = this.getData("conv_ratio");
        let exerciseprice = this.getData("exercise_price");
        let displayName = this.getData("dsply_name");
        if (this.props.warrantdata && displayName && displayName.indexOf('Tencent') !== -1) {
            convratio = this.getData("conv_ratio_cal").toFixed(3);
            exerciseprice = this.getData("exercise_price_cal").toFixed(3);
        } else if (
            this.props.warrantdata &&
            displayName &&
            (displayName.indexOf('SembInd') !== -1 ||
                displayName.indexOf('CityDev') !== -1 ||
                displayName.indexOf('KepCorp') !== -1 ||
                displayName.indexOf('Singtel') !== -1
            )
        ) {
            // convratio = this.getData("conv_ratio_cal").toFixed(5);
            convratio = Math.floor(this.getData("conv_ratio_cal") * 100) / 100;
        }
        let moneyness = this.getData("moneyness");
        let moneynessClass = this.getMoneynessClass(moneyness);
        let moneynessdisplaystring =
            this.getData("percent_moneyness") +
            "% " +
            this.getMoneynessName(moneyness);

        return (
            <div>
                {this.props.warrantdata && <div id="dwterms">
                    <TermsSummary
                        warrantdata={this.props.warrantdata}
                        tabNum={true}
                    />
                </div>}
                <div id="srtable" style={{ position: "relative" }}>
                    <table className="table priorTable">
                        <tbody>
                            <tr>
                                <th
                                    className="srtable-leftlbl bgcolor-01"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    Prior
                                </th>
                                <td
                                    className="srtable-leftval bgcolor-01 val HST_CLOSE"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(hstclose, 3)}
                                </td>
                                <th
                                    className="srtable-rightlbl bgcolor-02"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    Last trade
                                </th>
                                <td
                                    className="srtable-rightval bgcolor-02 val TRDPRC_1"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(trdprc1, 3)}
                                </td>
                            </tr>
                            <tr>
                                <th className="srtable-leftlbl" style={{ border: 0, textAlign: 'left' }}>
                                    Open
                                </th>
                                <td
                                    className="srtable-leftval val OPEN_PRC"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(openprc, 3)}
                                </td>
                                <th className="srtable-rightlbl" style={{ border: 0, textAlign: 'left' }}>
                                    Traded volume ('000)
                                </th>
                                <td className="srtable-rightval val ACVOL_1_SCALED" style={{ textAlign: 'left' }}>
                                    {MQSGUtil.formatNumberDisplay(acvol1scaled)}
                                </td>
                            </tr>
                            <tr>
                                <th
                                    className="srtable-leftlbl bgcolor-01"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    High
                                </th>
                                <td
                                    className="srtable-leftval bgcolor-01 val HIGH_1"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(high1, 3)}
                                </td>
                                <th
                                    className="srtable-rightlbl bgcolor-02"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    Traded value ('000 SGD)
                                </th>
                                <td
                                    className="srtable-rightval bgcolor-02 val TURNOVER_SCALED"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(turnoverscaled)}
                                </td>
                            </tr>
                            <tr>
                                <th className="srtable-leftlbl" style={{ textAlign: 'left' }}>Low</th>
                                <td className="srtable-leftval val LOW_1" style={{ border: 0, textAlign: 'left' }}>
                                    {MQSGUtil.formatNumberDisplay(low1, 3)}
                                </td>
                                <th className="srtable-rightlbl" style={{ border: 0, textAlign: 'left' }}>
                                    Underlying price
                                </th>
                                <td
                                    className="srtable-rightval val underlying_price"
                                    style={{ border: 0, textAlign: 'left' }}
                                >
                                    {MQSGUtil.formatNumberDisplay(underlyingprice, 3)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h3>Terms</h3>
                <div id="indtable" style={{ position: "relative" }}>
                    <table className="table visible-md visible-lg table-closed table-striped indicator_table TermsTable">
                        <tbody>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="dwsymbol"
                                        data-hasqtip="0"
                                        data-tip
                                        data-for="Warrant-tooltip"
                                    >
                                        Warrant code
                                    </span>
                                    <ReactTooltip
                                        id="Warrant-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Warrant code: </b>
                                        Each warrant has an unique 4-digit identification code,
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/howarewarrantsnamed" rel="noreferrer"
                                        >
                                            &nbsp;&nbsp;Click here&nbsp;&nbsp;
                                        </a>
                                        for a more detailed explanation.
                                    </ReactTooltip>
                                </th>
                                <td className="val ticker">{ticker}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="effectivegearing"
                                        data-hasqtip="1"
                                        data-tip
                                        data-for="Effective-tooltip"
                                    >
                                        Effective gearing (x)
                                    </span>
                                    <ReactTooltip
                                        id="Effective-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Effective gearing: </b>
                                        Indicates your leveraged exposure. An effective gearing of
                                        5X tells you a 1% move in the underlying stock/index results
                                        in an approximate 5% move in your Warrant price.
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/effectivegearing" rel="noreferrer"
                                        >
                                            &nbsp;&nbsp;Click here&nbsp;&nbsp;
                                        </a>
                                        to learn more about effective gearing.
                                    </ReactTooltip>
                                </th>
                                <td className="val effective_gearing">{MQSGUtil.formatNumberDisplay(effectivegearing)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="underlying"
                                        data-hasqtip="2"
                                        data-tip
                                        data-for="Underlying-tooltip"
                                    >
                                        Underlying
                                    </span>
                                    <ReactTooltip
                                        id="Underlying-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Underlying: </b>
                                        The stock or index over which the Warrant is listed.
                                    </ReactTooltip>
                                </th>
                                <td className="val underlying_ticker">
                                    <a href={"/tools/underlying/" + underlying_ticker}>{underlyingticker}</a>
                                </td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="delta"
                                        data-hasqtip="3"
                                        aria-describedby="qtip-3"
                                        data-tip
                                        data-for="Delta-tooltip"
                                    >
                                        Delta (%)
                                    </span>
                                    <ReactTooltip
                                        id="Delta-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Delta: </b>
                                        Estimates how a warrant moves in relation to the underlying
                                        stock/index. Puts have negative deltas because their prices
                                        increase as the underlying stock/index falls. Note, if your
                                        warrant has a WPS that this will need to be taken into
                                        account.
                                    </ReactTooltip>
                                </th>
                                <td className="val delta">{MQSGUtil.formatNumberDisplay(delta)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="type"
                                        data-hasqtip="4"
                                        data-tip
                                        data-for="Type-tooltip"
                                    >
                                        Type
                                    </span>
                                    <ReactTooltip
                                        id="Type-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Type: </b>
                                        Calls increase in value as share price rises, Puts increase
                                        in value as share price falls.
                                    </ReactTooltip>
                                </th>
                                <td className="val type">{type}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="deltaperdw"
                                        data-hasqtip="5"
                                        data-tip
                                        data-for="Deltaper-tooltip"
                                    >
                                        Delta per warrant (%)
                                    </span>
                                    <ReactTooltip
                                        id="Deltaper-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Delta per warrant: </b>
                                        Delta/Warrant Per Share.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/delta"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here&nbsp;
                                        </a>
                                        to learn more about Delta per warrant.
                                    </ReactTooltip>
                                </th>
                                <td className="val delta_per_wrnt">{MQSGUtil.formatNumberDisplay(deltaperwrnt)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="issuer"
                                        data-hasqtip="6"
                                        data-tip
                                        data-for="Issuer-tooltip"
                                    >
                                        Issuer
                                    </span>
                                    <ReactTooltip
                                        id="Issuer-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Issuer: </b>
                                        The Bank or Securities company that issues the Warrant.
                                    </ReactTooltip>
                                </th>
                                <td className="val issuer_name">{issuername}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="sensitivity"
                                        data-hasqtip="7"
                                        data-tip
                                        data-for="Sensitivity-tooltip"
                                    >
                                        Sensitivity
                                    </span>
                                    <ReactTooltip
                                        id="Sensitivity-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Sensitivity: </b>
                                        Shows you how much the underlying stock or index must move
                                        for your warrant to move one "tick" or "Spread". For
                                        warrants that cost less than $0.200, one tick is $0.001.
                                    </ReactTooltip>
                                </th>
                                <td className="val sensitivity">{MQSGUtil.formatNumberDisplay(sensitivity)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="exerciseprice"
                                        data-hasqtip="8"
                                        data-tip
                                        data-for="Exercise-tooltip"
                                    >
                                        Exercise price
                                    </span>
                                    <ReactTooltip
                                        id="Exercise-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Exercise price: </b>
                                        The price at which you can buy (calls) or sell (puts) the
                                        underlying
                                        <br />
                                        share or index at expiry.
                                    </ReactTooltip>
                                </th>
                                <td className="val exercise_price">{MQSGUtil.formatNumberDisplay(exerciseprice)}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="breakevenpriceatexpiry"
                                        data-hasqtip="9"
                                        aria-describedby="qtip-9"
                                        data-tip
                                        data-for="Break-tooltip"
                                    >
                                        Break even price at expiry
                                    </span>
                                    <ReactTooltip
                                        id="Break-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Break even price at expiry: </b>
                                        If you are still holding the warrant at expiry, this is the
                                        price that the shares/index must exceed (fall below) for
                                        call (puts) for you to make a profit on your purchase price.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/breakevenprice"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here&nbsp;
                                        </a>
                                        here for a more detailed description.
                                    </ReactTooltip>
                                </th>
                                <td className="val breakeven_price">{MQSGUtil.formatNumberDisplay(breakevenprice)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="mostrecenttradedate"
                                        data-hasqtip="10"
                                        data-tip
                                        data-for="Most-tooltip"
                                    >
                                        Most recent trade date
                                    </span>
                                    <ReactTooltip
                                        id="Most-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Most recent trade date: </b>
                                        The last date that the warrant recorded a trade. Note:
                                        Warrant do not trade every day, this has implications when
                                        calculating price changes.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/howarewarrantspriced"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp; Click here &nbsp;
                                        </a>
                                        for more info.
                                    </ReactTooltip>
                                </th>
                                <td className="val TRADE_DATE">{tradedate}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="premium"
                                        data-hasqtip="11"
                                        data-tip
                                        data-for="Premium-tooltip"
                                    >
                                        Premium (%)
                                    </span>
                                    <ReactTooltip
                                        id="Premium-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Premium: </b>
                                        Also refered to as the "Time Value of the Warrant. Note a
                                        higher premium could be due to the warrant being longer
                                        dated or due to the higher gearing.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/premium"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here &nbsp;
                                        </a>
                                        to learn more about premium.
                                    </ReactTooltip>
                                </th>
                                <td className="val premium">{MQSGUtil.formatNumberDisplay(premium)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="expiry"
                                        data-hasqtip="12"
                                        data-tip
                                        data-for="Expiry-tooltip"
                                    >
                                        Expiry
                                    </span>
                                    <ReactTooltip
                                        id="Expiry-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Expiry: </b>
                                        The date at which the warrant will expire.
                                    </ReactTooltip>
                                </th>
                                <td className="val maturity">{maturity}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="impliedvolatility"
                                        data-hasqtip="13"
                                        data-tip
                                        data-for="Volatility-tooltip"
                                    >
                                        Volatility (%)
                                    </span>
                                    <ReactTooltip
                                        id="Volatility-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Volatility: </b>
                                        The higher the implied volatility, the higher the price of
                                        the Warrant. Relates to the volatility and risk of the
                                        underlying share/Index.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/impliedvolatility"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here&nbsp;
                                        </a>
                                        to learn more about implied volatility.
                                    </ReactTooltip>
                                </th>
                                <td className="val implied_volatility">{MQSGUtil.formatNumberDisplay(impliedvolatility)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="lasttradingdate"
                                        data-hasqtip="14"
                                        data-tip
                                        data-for="Last-tooltip"
                                    >
                                        Last trade date
                                    </span>
                                    <ReactTooltip
                                        id="Last-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Last trading date: </b>
                                        The last day to buy or sell the warrant. This date is always
                                        the 5th trading day prior to the expiry date.
                                    </ReactTooltip>
                                </th>
                                <td className="val last_trading_date">{lasttradingdate}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="theta"
                                        data-hasqtip="15"
                                        data-tip
                                        data-for="Theta-tooltip"
                                    >
                                        Theta (%)
                                    </span>
                                    <ReactTooltip
                                        id="Theta-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Theta: </b>
                                        The daily time decay of the warrant expressed in percentage
                                        terms.
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/timedecay"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here&nbsp;
                                        </a>
                                        to learn more about Theta.
                                    </ReactTooltip>
                                </th>
                                <td className="val theta">{MQSGUtil.formatNumberDisplay(theta)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="timetomaturity"
                                        data-hasqtip="16"
                                        data-tip
                                        data-for="Daysto-tooltip"
                                    >
                                        Days to maturity
                                    </span>
                                    <ReactTooltip
                                        id="Daysto-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Days to maturity: </b>
                                        The number of days left until the expiry date of the
                                        warrant.
                                    </ReactTooltip>
                                </th>
                                <td className="val days_to_maturity">{daystomaturity}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="intrinsicvalueperdw"
                                        data-hasqtip="17"
                                        data-tip
                                        data-for="Intrinsic-tooltip"
                                    >
                                        Intrinsic value per warrant
                                    </span>
                                    <ReactTooltip
                                        id="Intrinsic-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Intrinsic value per warrant: </b>
                                        This is the difference between the exercise price and the
                                        current share price. For call warrant, if the exercise price
                                        is below the current share price it has intrinsic value,
                                        vice versa for puts. Please
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/intrinsicvalueandtimevalue"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp;Click here
                                        </a>
                                    </ReactTooltip>
                                </th>
                                <td className="val intrinsic_value">{MQSGUtil.formatNumberDisplay(intrinsicvalue)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="warrantpershare"
                                        data-hasqtip="18"
                                        aria-describedby="qtip-18"
                                        data-tip
                                        data-for="Warrantpershare-tooltip"
                                    >
                                        Warrant per share
                                    </span>
                                    <ReactTooltip
                                        id="Warrantpershare-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Warrant per share: </b>
                                        The number of warrants that entitles you to one unit of the
                                        underlying share or index at expiry.
                                    </ReactTooltip>
                                </th>
                                <td className="val conv_ratio">{MQSGUtil.formatNumberDisplay(convratio)}</td>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="moneyness"
                                        data-hasqtip="19"
                                        data-tip
                                        data-for="Moneyness-tooltip"
                                    >
                                        Moneyness
                                    </span>
                                    <ReactTooltip
                                        id="Moneyness-tooltip"
                                        className="search-tooltip"
                                        delayHide={100}
                                        place="right"
                                        type="warning"
                                        effect="solid"
                                        backgroundColor="#F1D031"
                                        textColor="#000"
                                    >
                                        <b>Moneyness: </b>
                                        ITM (in-the-money), OTM (out-of-the-money), ATM
                                        (at-the-money).
                                        <a
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/moneyness"
                                            target="_blank" rel="noreferrer"
                                        >
                                            &nbsp; Click here&nbsp;
                                        </a>
                                        to learn more about moneyness.
                                    </ReactTooltip>
                                </th>
                                <td className={moneynessClass}>{moneynessdisplaystring}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="table hidden-md hidden-lg table-closed table-striped">
                        <tbody>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="dwsymbol"
                                        data-hasqtip="20"
                                    >
                                        Warrant code
                                    </span>
                                </th>
                                <td className="val ticker">{ticker}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="underlying"
                                        data-hasqtip="21"
                                    >
                                        Underlying
                                    </span>
                                </th>
                                <td className="val underlying_ticker">
                                    <a href="/tools/underlying/HSI">{underlyingticker}</a>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="type" data-hasqtip="22">
                                        Type
                                    </span>
                                </th>
                                <td className="val type">{type}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="issuer" data-hasqtip="23">
                                        Issuer
                                    </span>
                                </th>
                                <td className="val issuer_name">{issuername}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="" data-hasqtip="24">
                                        Exercise price
                                    </span>
                                </th>
                                <td className="val exercise_price">{MQSGUtil.formatNumberDisplay(exerciseprice)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="mostrecenttradedate"
                                        data-hasqtip="25"
                                    >
                                        Most recent trade date
                                    </span>
                                </th>
                                <td className="val TRADE_DATE">{tradedate}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="expiry" data-hasqtip="26">
                                        Expiry
                                    </span>
                                </th>
                                <td className="val maturity">{MQSGUtil.formatNumberDisplay(maturity)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="lasttradingdate"
                                        data-hasqtip="27"
                                    >
                                        Last trading date
                                    </span>
                                </th>
                                <td className="val last_trading_date">{lasttradingdate}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="timetomaturity"
                                        data-hasqtip="28"
                                    >
                                        Days to maturity
                                    </span>
                                </th>
                                <td className="val days_to_maturity">{MQSGUtil.formatNumberDisplay(daystomaturity)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="warrantpershare"
                                        data-hasqtip="29"
                                    >
                                        Warrant per share
                                    </span>
                                </th>
                                <td className="val conv_ratio">{MQSGUtil.formatNumberDisplay(convratio)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="effectivegearing"
                                        data-hasqtip="30"
                                    >
                                        Effective gearing (x)
                                    </span>
                                </th>
                                <td className="val effective_gearing">{MQSGUtil.formatNumberDisplay(effectivegearing)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="delta" data-hasqtip="31">
                                        Delta
                                    </span>
                                </th>
                                <td className="val delta">{MQSGUtil.formatNumberDisplay(delta)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="deltaperdw"
                                        data-hasqtip="32"
                                    >
                                        Delta per warrant
                                    </span>
                                </th>
                                <td className="val delta_per_wrnt">{MQSGUtil.formatNumberDisplay(deltaperwrnt)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="sensitivity"
                                        data-hasqtip="33"
                                    >
                                        Sensitivity
                                    </span>
                                </th>
                                <td className="val sensitivity">{MQSGUtil.formatNumberDisplay(sensitivity)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="breakevenpriceatexpiry"
                                        data-hasqtip="34"
                                    >
                                        Break even price at expiry
                                    </span>
                                </th>
                                <td className="val breakeven_price">{MQSGUtil.formatNumberDisplay(breakevenprice)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="premium"
                                        data-hasqtip="35"
                                    >
                                        Premium(%)
                                    </span>
                                </th>
                                <td className="val premium">{MQSGUtil.formatNumberDisplay(premium)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="impliedvolatility"
                                        data-hasqtip="36"
                                    >
                                        Volatility (%)
                                    </span>
                                </th>
                                <td className="val implied_volatility">{MQSGUtil.formatNumberDisplay(impliedvolatility)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span className="ttip" data-target="theta" data-hasqtip="37">
                                        Theta (%)
                                    </span>
                                </th>
                                <td className="val theta">{MQSGUtil.formatNumberDisplay(theta)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="intrinsicvalueperdw"
                                        data-hasqtip="38"
                                    >
                                        Intrinsic value per warrant
                                    </span>
                                </th>
                                <td className="val intrinsic_value">{MQSGUtil.formatNumberDisplay(intrinsicvalue)}</td>
                            </tr>
                            <tr>
                                <th>
                                    <span
                                        className="ttip"
                                        data-target="moneyness"
                                        data-hasqtip="39"
                                    >
                                        Moneyness
                                    </span>
                                </th>
                                <td className={moneynessClass}>{MQSGUtil.formatNumberDisplay(moneynessdisplaystring)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* 文字说明 */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',  // 两端对齐（左元素靠左，右元素靠右）
                    alignItems: 'center',
                    width: '100%',
                    padding: '8px 0',
                    boxSizing: 'border-box'
                }}>
                    <p className="small" style={{
                        margin: 0,
                        textAlign: 'left'     // 左对齐
                    }}>
                        Last updated:{" "}
                        <span id="lastupdate">{MQSGUtil.formatNumberDisplay(this.props.warrantdata?.update_time)}</span>
                    </p>
                    <button id="quickTermsSheetButton" onClick={() => this.changeTermSheetLink()}>
                        Term sheet
                    </button>
                </div>


                <div className="disclaimer hidden-xs hidden-sm">
                    <p className="small">
                        All market data is delayed 15 mins unless otherwise
                        indicated by timestamp.
                    </p>
                    <p className="small">
                        The warrant price displayed in prior, Open, High and low is
                        based on the "bid price for the warrant rather than the
                        "traded price". the intraday graph also uses the warrant bid
                        price to generate the warrant price history. We do this to
                        provide a more accurate representation of the warrant value
                        at each particular point in time and a more accurate
                        reflection of warrant price changes. Warrants do not trade
                        as frequently as shares and sometimes may not record a trade
                        for a long period of time though the bid/offer prices may
                        continue to move. Therefore using the bid price is usually
                        the best indicator of warrant value. For a more detailed
                        description&nbsp;
                        <Link
                            className="text-lowercase"
                            style={{
                                color: "#0675C2",
                                fontFamily: "HelveticaNeueMedium",
                            }}
                            target="_blank"
                            to="/WarrantsGuidebook"
                        >
                            Click here
                        </Link>
                        .
                    </p>
                    <hr className="hr-hmgbm" />
                </div>
                {/* 手机端展示 */}
                <PanelGroup />
            </div>
        );
    }
}
class PanelGroup extends Component {
    render() {
        return (
            <div
                className="panel-group visible-xs-block visible-sm-block"
                id="defination"
            >
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <a
                            data-toggle="collapse"
                            data-parent="#defination"
                            href="#collapse_dwcompare3"
                            className="collapsed"
                            aria-expanded="false"
                        >
                            <span className="glyphicon glyphicon glyphicon-question-sign pull-right"></span>
                            <div
                                id="collapse_title3"
                                className="panel-title text-center color-primary"
                            >
                                Definition &amp; disclaimer
                            </div>
                        </a>
                    </div>
                    <div
                        id="collapse_dwcompare3"
                        className="panel-collapse collapse"
                        aria-expanded="false"
                        style={{ height: "20px" }}
                    >
                        <table className="table table-striped indicator_table">
                            <tbody>
                                <tr>
                                    <td>Warrant code</td>
                                    <td>
                                        Each warrant has an unique 4-digit identification code,
                                        click{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/howarewarrantsnamed" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        for a more detailed explanation.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Underlying</td>
                                    <td>The stock or index over which the Warrant is listed.</td>
                                </tr>
                                <tr>
                                    <td>Type</td>
                                    <td>
                                        Calls increase in value as share price rises, Puts increase
                                        in value as share price falls.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Issuer</td>
                                    <td>
                                        The Bank or Securities company that issues the Warrant.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Exercise price</td>
                                    <td>
                                        The price at which you can buy (calls) or sell (puts) the
                                        underlying
                                        <br /> share or index at expiry.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Most recent trade date</td>
                                    <td>
                                        The last date that the warrant recorded a trade. Note:
                                        Warrant do not trade every day, this has implications when
                                        calculating price changes.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/howarewarrantspriced" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        for more info.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Expiry</td>
                                    <td>The date at which the warrant will expire.</td>
                                </tr>
                                <tr>
                                    <td>Last trading date</td>
                                    <td>
                                        The last day to buy or sell the warrant.  This date is always the 5th trading day prior to the expiry date.  For Hong Kong underlyings, the last trading date will be brought forward if the 5th trading day prior to expiry falls on a Hong Kong holiday.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Days to maturity</td>
                                    <td>
                                        The number of days left until the expiry date of the
                                        warrant.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Warrant per share</td>
                                    <td>
                                        The number of warrants that entitles you to one unit of the
                                        underlying share or index at expiry.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Effective gearing (x)</td>
                                    <td>
                                        Indicates your leveraged exposure. An effective gearing of
                                        5X tells you a 1% move in the underlying stock/index results
                                        in an approximate 5% move in your Warrant price.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/effectivegearing" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        to learn more about effective gearing.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Delta</td>
                                    <td>
                                        Estimates how a warrant moves in relation to the underlying
                                        stock/index. Puts have negative deltas because their prices
                                        increase as the underlying stock/index falls. Note, if your
                                        warrant has a WPS that this will need to be taken into
                                        account.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Delta per warrant</td>
                                    <td>
                                        Delta/Warrant Per Share.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/delta" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        to learn more about Delta per warrant.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Sensitivity</td>
                                    <td>
                                        Shows you how much the underlying stock or index must move
                                        for your warrant to move one "tick" or "Spread". For
                                        warrants that cost less than $0.200, one tick is $0.001.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Break even price at expiry</td>
                                    <td>
                                        If you are still holding the warrant at expiry, this is the
                                        price that the shares/index must exceed (fall below) for
                                        call (puts) for you to make a profit on your purchase price.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/breakevenprice" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        here for a more detailed description.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Premium (%)</td>
                                    <td>
                                        Also refered to as the "Time Value of the Warrant. Note a
                                        higher premium could be due to the warrant being longer
                                        dated or due to the higher gearing.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/premium" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        to learn more about premium.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Volatility (%)</td>
                                    <td>
                                        The higher the implied volatility, the higher the price of
                                        the Warrant. Relates to the volatility and risk of the
                                        underlying share/Index.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/impliedvolatility" rel="noreferrer"
                                        >
                                            &nbsp;Click here&nbsp;
                                        </a>{" "}
                                        to learn more about implied volatility.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Theta (%)</td>
                                    <td>
                                        The daily time decay of the warrant expressed in percentage
                                        terms.{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/timedecay" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        to learn more about Theta.
                                    </td>
                                </tr>
                                <tr>
                                    <td>Intrinsic value per warrant</td>
                                    <td>
                                        This is the difference between the exercise price and the
                                        current share price. For call warrant, if the exercise price
                                        is below the current share price it has intrinsic value,
                                        vice versa for puts. Please{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/intrinsicvalueandtimevalue" rel="noreferrer"
                                        >
                                            &nbsp;Click here
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Moneyness</td>
                                    <td>
                                        ITM (in-the-money), OTM (out-of-the-money), ATM
                                        (at-the-money).{" "}
                                        <a
                                            target="_blank"
                                            href="https://www.warrants.com.sg/WarrantsGuidebook/moneyness" rel="noreferrer"
                                        >
                                            click here
                                        </a>{" "}
                                        to learn more about moneyness.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p className="small">
                            All market data is delayed 15 mins unless otherwise indicated by
                            timestamp.
                        </p>
                        <p className="small">
                            The warrant price displayed in prior, Open, High and low is based
                            on the "bid price for the warrant rather than the "traded price".
                            the intraday graph also uses the warrant bid price to generate the
                            warrant price history. We do this to provide a more accurate
                            representation of the warrant value at each particular point in
                            time and a more accurate reflection of warrant price changes.
                            Warrants do not trade as frequently as shares and sometimes may
                            not record a trade for a long period of time though the bid/offer
                            prices may continue to move. Therefore using the bid price is
                            usually the best indicator of warrant value. For a more detailed
                            description&nbsp;
                            <Link
                                className="text-lowercase"
                                style={{ color: "#0675C2", fontFamily: "HelveticaNeueMedium" }}
                                target="_blank"
                                to="/WarrantsGuidebook"
                            >
                                Click here
                            </Link>
                            .
                        </p>
                        <hr className="hr-hmgbm" />
                    </div>
                </div>
            </div>
        );
    }
}
class TermsChart extends Component {
    constructor(props) {
        super(props);
        // this.chart = React.createRef();
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            minDate: new Date(),
            MaxDate: new Date(),
            chartData: null,
            warrantPrice: '-',
            Underlying: '-',
            day: '-',
            last: '-',
            last1: '-',
            from: '-',
            from1: '-',
            fixedStartDate: '-',
            fixedEndDate: '-',
            switch: false,
            lastRic: true
        };
    }
    onPeriodChange(period) {
        this.props.onPeriodChange(period);
    }
    componentDidUpdate(prevProps) {
        // 检查 props 是否发生变化
        if (
            (this.props.chartdata && this.props.warrantdata) &&
            (prevProps.chartdata !== this.props.chartdata || 
             prevProps.warrantdata !== this.props.warrantdata ||
             prevProps.period !== this.props.period ||
             prevProps.needModifyBID !== this.props.needModifyBID)
        ) {
            
            const props = this.props;
            let min = '';
            let max = ''
            this.chart.current.chartRef.current.chart.xAxis[0].update({ min: null, max: null })
            let arrMin = props.chartdata?.underlyingPrice && props.chartdata.underlyingPrice.length > 0 ? props.chartdata.underlyingPrice[0]?.time?.replace(' 00:00', '') : '';
            let arrMax = props.chartdata?.underlyingPrice && props.chartdata.underlyingPrice.length > 0 ? props.chartdata.underlyingPrice[props.chartdata.underlyingPrice.length - 1]?.time?.replace(' 00:00', '') : '';
            let arrMin2 = props.chartdata?.warrantBidPriceSgd && props.chartdata.warrantBidPriceSgd.length > 0 ? props.chartdata.warrantBidPriceSgd[0]?.time?.replace(' 00:00', '') : '';
            let arrMax2 = props.chartdata?.warrantBidPriceSgd && props.chartdata.warrantBidPriceSgd.length > 0 ? props.chartdata.warrantBidPriceSgd[props.chartdata.warrantBidPriceSgd.length - 1]?.time?.replace(' 00:00', '') : '';
            let minDate = props.warrantdata?.list_date ? new Date(props.warrantdata.list_date) : new Date();
            let maxDate = new Date();
            // 验证 minDate 是否有效
            if (isNaN(minDate.getTime())) {
                minDate = new Date();
            }
            if (!props.chartdata?.warrantBidPriceSgd || props.chartdata.warrantBidPriceSgd.length < 1) {
                min = arrMin
            } else {
                min = arrMin2
            }
            if (new Date(arrMax) < new Date(arrMax2)) {
                max = arrMax2
            } else {
                max = arrMax
            }

            let parameterSet = {}
            let lastRic = JSON.parse(sessionStorage.getItem('lastRic'))
            if (this.state.switch) {
                parameterSet = {
                    chartData: props.chartdata,
                    startDate: this.state.startDate,
                    endDate: this.state.endDate,
                }
            } else {
                if (lastRic && this.state.lastRic && lastRic.ric == props.selected?.value) {
                    parameterSet = {
                        chartData: props.chartdata,
                        startDate: new Date(lastRic.startDate),
                        endDate: new Date(lastRic.endDate),
                        lastRic: false
                    }
                } else {
                    let data1Len = props.chartdata?.oneWeekReference?.warrantBidPriceSgd?.length || 0;
                    let start = props.chartdata?.oneWeekReference?.warrantBidPriceSgd?.[data1Len - 2]?.time;
                    let startDate = props.period === "D" && start ? new Date(start) : (min ? new Date(min) : new Date());
                    // 确保日期有效
                    if (isNaN(startDate.getTime())) {
                        startDate = new Date();
                    }
                    let endDate = max ? new Date(max) : new Date();
                    if (isNaN(endDate.getTime())) {
                        endDate = new Date();
                    }
                    parameterSet = {
                        chartData: props.chartdata,
                        startDate: startDate,
                        endDate: endDate,
                        lastRic: false
                    }
                }
            }
            let date = {
                minDate: minDate,
                MaxDate: maxDate,
            }
            this.setState(Object.assign(parameterSet, date), () => {
                if (this.props.period === "D") {
                    this.changeDate(props.chartdata)
                } else {
                    this.changeDate(props.chartdata)
                }
                window.setTimeout(() => {
                    this.setState({ switch: false })
                }, 100)
            })
        }
    }
    findClosestPair(arr, n) {
        let minDiff = Infinity;
        let closestPair = [];
        for (let i = 0; i < arr.length - 1; i++) {
            if (arr[i] < n) {
                let diff = n - arr[i];
                if (diff < minDiff) {
                    minDiff = diff;
                    closestPair = arr[i];
                }
            }
        }
        return closestPair;
    }
    changeDate(chartdata) {
        if (this.props.period !== "D") {
            let dataArr = this.chart.current.chartRef.current.chart.series[0].xData;
            let dataArr2 = this.chart.current.chartRef.current.chart.series[1].xData;
            let underlyingMax = undefined;
            let underlyingMin = undefined;
            let warrantMax = undefined;
            let warrantMin = undefined;
            let minDate = null;
            let maxDate = null;
            if (dataArr.indexOf(this.state.endDate.getTime()) !== -1) {
                underlyingMax = this.chart.current.chartRef.current.chart.series[0].yData[dataArr.indexOf(this.state.endDate.getTime())]
            } else {
                underlyingMax = this.chart.current.chartRef.current.chart.series[0].yData[dataArr.indexOf(this.findClosestPair(dataArr, this.state.endDate.getTime()))];
                maxDate = this.findClosestPair(dataArr, this.state.endDate.getTime())
            }
            if (dataArr.indexOf(this.state.startDate.getTime()) !== -1) {
                underlyingMin = this.chart.current.chartRef.current.chart.series[0].yData[dataArr.indexOf(this.state.startDate.getTime())]
            } else {
                underlyingMin = this.chart.current.chartRef.current.chart.series[0].yData[dataArr.indexOf(this.findClosestPair(dataArr, this.state.startDate.getTime()))];
                minDate = this.findClosestPair(dataArr, this.state.startDate.getTime())
            }
            if (dataArr2.indexOf(this.state.endDate.getTime()) !== -1) {
                warrantMax = this.chart.current.chartRef.current.chart.series[1].yData[dataArr2.indexOf(this.state.endDate.getTime())]
            } else {
                warrantMax = this.chart.current.chartRef.current.chart.series[1].yData[dataArr2.indexOf(this.findClosestPair(dataArr2, this.state.endDate.getTime()))];
                maxDate = this.findClosestPair(dataArr2, this.state.endDate.getTime())
            }
            if (dataArr2.indexOf(this.state.startDate.getTime()) !== -1) {
                warrantMin = this.chart.current.chartRef.current.chart.series[1].yData[dataArr2.indexOf(this.state.startDate.getTime())]
            } else {
                warrantMin = this.chart.current.chartRef.current.chart.series[1].yData[dataArr2.indexOf(this.findClosestPair(dataArr2, this.state.startDate.getTime()))];
                minDate = this.findClosestPair(dataArr2, this.state.startDate.getTime())
            }
            let str = ''
            let str1 = ''
            let underlyingPctChange = ((underlyingMax - underlyingMin) / underlyingMin).toFixed(4) * 100;
            let warrantPctChange = ((warrantMax - warrantMin) / warrantMin).toFixed(4) * 100;
            
            if (((underlyingMax - underlyingMin) / underlyingMin).toFixed(2) * 100 == Infinity || isNaN(underlyingPctChange) || underlyingPctChange === 0) {
                str = '-';
            } else {
                str = this.floatMultiply(((underlyingMax - underlyingMin) / underlyingMin).toFixed(4), 100) + '%';
            }
            if (((warrantMax - warrantMin) / warrantMin).toFixed(2) * 100 == Infinity || isNaN(warrantPctChange) || warrantPctChange === 0) {
                str1 = '-';
            } else {
                str1 = this.floatMultiply(((warrantMax - warrantMin) / warrantMin).toFixed(4), 100) + '%';
            }
            let day = (this.state.endDate.getTime() - this.state.startDate.getTime()) / (1000 * 60 * 60 * 24);
            if (day < 1) {
                this.onPeriodChange("D")
                day = 1
            }
            if (this.props.needModifyBID) {
                underlyingMin = '-';
                underlyingMax = '-';
                // str='-';
            }
            this.setState({
                warrantPrice: str1,
                Underlying: str,
                last: isNaN(warrantMin) ? '-' : Number(warrantMin).toFixed(3),
                last1: isNaN(underlyingMin) ? '-' : Number(underlyingMin).toFixed(3),
                from: isNaN(warrantMax) ? '-' : Number(warrantMax).toFixed(3),
                from1: isNaN(underlyingMax) ? '-' : Number(underlyingMax).toFixed(3),
                day: Math.ceil(day)
            })
            this.chart.current.chartRef.current.chart.xAxis[0].update({ max: maxDate ? maxDate : this.state.endDate.getTime(), min: minDate ? minDate : this.state.startDate.getTime() })
        } else {
            let underlyingMax = undefined;
            let underlyingMin = undefined;
            let warrantMax = undefined;
            let warrantMin = undefined;
            underlyingMax = chartdata?.underlyingPrice?.[0]?.close;
            underlyingMin = chartdata?.underlyingPrice?.[chartdata?.underlyingPrice?.length - 1]?.close;
            warrantMax = chartdata?.warrantBidPriceSgd?.[0]?.close;
            warrantMin = chartdata?.warrantBidPriceSgd?.[chartdata?.warrantBidPriceSgd?.length - 1]?.close;
            let str = '';
            let str1 = '';
            let day = (this.state.endDate.getTime() - this.state.startDate.getTime()) / (1000 * 60 * 60 * 24)
            let lastData = warrantMax;
            let last1 = underlyingMax;
            let from1 = underlyingMin;
            if (this.props.chartdata?.oneWeekReference) {
                let data1Len = this.props.chartdata?.oneWeekReference?.warrantBidPriceSgd?.length || 0;
                let dataLen = this.props.chartdata?.oneWeekReference?.underlyingPrice?.length || 0;
                lastData = this.props.chartdata?.oneWeekReference?.warrantBidPriceSgd?.[data1Len - 2]?.close;
                last1 = this.props.chartdata?.oneWeekReference?.underlyingPrice?.[dataLen - 2]?.close;
            }
            let underlyingPctChange = ((from1 - last1) / last1).toFixed(4) * 100;
            let warrantPctChange = ((warrantMin - lastData) / lastData).toFixed(4) * 100;
            if (((from1 - last1) / last1).toFixed(2) * 100 == Infinity  || isNaN(underlyingPctChange) || underlyingPctChange === 0) {
                str = '-';
            } else {
                str = this.floatMultiply(this.toFixedTruncate((from1 - last1) / last1), 100) + '%';
            }
            if (((warrantMin - lastData) / lastData).toFixed(2) * 100 == Infinity  || isNaN(warrantPctChange) || warrantPctChange === 0) {
                str1 = '-';
            } else {
                str1 = this.floatMultiply(this.toFixedTruncate((warrantMin - lastData) / lastData), 100) + '%';
            }
            if (this.props.needModifyBID) {
                from1 = '-';
                last1 = '-';
            }
            this.setState({
                // warrantPrice: (() => {
                //     let val = chartdata?.percentageChange?.BID_PCTCHNG;
                //     if(str1 >=0.005){
                //         return this.floatMultiply(str1, 100) + '%';
                //     }
                //     if (val === undefined || val === null || val === '' || isNaN(Number(val))) return '-';
                //     return Number(val) + '%';
                // })(),
                // Underlying: (() => {
                //     let val = chartdata?.percentageChange?.underlying_pctchng;
                //     if(str >=0.005){
                //         return this.floatMultiply(str, 100) + '%';
                //     }
                //     if (val === undefined || val === null || val === '' || isNaN(Number(val))) return '-';
                //     return Number(val) + '%';
                // })(),
                warrantPrice: str1,
                Underlying: str,
                from: isNaN(warrantMin) ? '-' : Number(warrantMin).toFixed(3),
                from1: isNaN(from1) ? '-' : Number(from1).toFixed(3),
                last: isNaN(lastData) ? '-' : Number(lastData).toFixed(3),
                last1: isNaN(last1) ? '-' : Number(last1).toFixed(3),
                day: 1
            })
        }
        if (this.props.needModifyBID) {
            this.chart.current.chartRef.current.chart.series[0].update({ visible: false });
        } else {
            this.chart.current.chartRef.current.chart.series[0].update({ visible: true });
        }
    }
    toFixedTruncate(num, decimal = 4) {
        let str = num.toString();
        if (!str.includes('.')) {
            return str + '.' + '0'.repeat(decimal);
        }
        const [intPart, decPart] = str.split('.');
        const dec = decPart.padEnd(decimal, '0').slice(0, decimal);
        return `${intPart}.${dec}`;
    }
    componentDidMount() {
        this.chart = React.createRef();
    }
    setStartDate(date) {
        if (date !== null) {
            if (this.state.startDate.getTime() === date.getTime()) {
                return false;
            }
            // #143 修复修改From，获取不到数据的问题
            let boolean = false;
            let startY = date.getFullYear();
            let startM = date.getMonth() + 1;
            if (startM < 10) {
                startM = '0' + startM.toString()
            }
            let startD = date.getDate();
            if (startD < 10) {
                startD = '0' + startD.toString()
            }
            let startDate = new Date(startY + '-' + startM + '-' + startD + 'T08:00:00+08:00')

            let stateEndDate = this.state.endDate
            let endY = stateEndDate.getFullYear();
            let endM = stateEndDate.getMonth() + 1;
            if (endM < 10) {
                endM = '0' + endM.toString()
            }
            let endD = stateEndDate.getDate();
            if (endD < 10) {
                endD = '0' + endD.toString()
            }
            let endDate = new Date(endY + '-' + endM + '-' + endD + 'T08:00:00+08:00')
            if (this.props.period !== "Y") {
                this.onPeriodChange('Y')
                boolean = true
            }
            this.setState({
                startDate: startDate,
                switch: boolean,
                endDate: endDate
            }, () => {
                sessionStorage.setItem('lastRic', JSON.stringify({ ric: this.props.selected?.value, startDate: this.state.startDate, endDate: this.state.endDate }))
                this.changeDate(this.props.chartdata)

            })
        }
    }
    floatMultiply(arg1, arg2) {
        if (arg1 === null || arg2 === null) {
            return null;
        }
        let n1, n2;
        let r1, r2;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        n1 = Number(arg1.toString().replace(".", ""));
        n2 = Number(arg2.toString().replace(".", ""));
        return n1 * n2 / Math.pow(10, r1 + r2);
    }
    setEndDate(date) {
        if (date !== null) {
            let boolean = false;
            // if (this.props.period !== "Y") {
            //     this.onPeriodChange('Y')
            //     boolean = true
            // }
            // #143 修复To时区的问题
            let endY = date.getFullYear();
            let endM = date.getMonth() + 1;
            if (endM < 10) {
                endM = '0' + endM.toString()
            }
            let endD = date.getDate();
            if (endD < 10) {
                endD = '0' + endD.toString()
            }
            let endDate = new Date(endY + '-' + endM + '-' + endD + 'T08:00:00+08:00')
            this.setState({
                endDate: endDate,
                switch: boolean
            }, () => {
                sessionStorage.setItem('lastRic', JSON.stringify({ ric: this.props.selected.value, startDate: this.state.startDate, endDate: this.state.endDate }))
                this.changeDate(this.props.chartdata)
            })
        }
    }
    render() {
        return (
            <div>
                {this.props.warrantdata && <div id="dwterms">
                    <TermsSummary
                        warrantdata={this.props.warrantdata}
                        tabNum={false}
                    />
                </div>}
                <div className="termschart" style={{ marginTop: '30px' }}>
                    <table id="priceTable" style={{ fontSize: '14px' }}>
                        <tbody>
                            <tr>
                                <td colSpan="4" style={{ backgroundColor: '#DFDBCF', lineHeight: '35px' }}>Warrant vs. Underlying Performance</td>
                            </tr>
                            <tr style={{ background: '#F5F6F7' }}>
                                <td rowSpan="2" className="isShowPC">

                                    From
                                    &nbsp;
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={(date) => this.setStartDate(date)}
                                        minDate={this.state.minDate}
                                        maxDate={this.state.endDate}
                                        selectsStart
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </td>
                                <td className="isShowMobile">From</td>
                                <td>Warrant Price</td>
                                <td>Underlying</td>
                                <td>Number of days</td>
                            </tr>
                            <tr style={{ background: '#F5F6F7' }}>
                                <td className="isShowMobile">
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={(date) => this.setStartDate(date)}
                                        minDate={this.state.minDate}
                                        maxDate={this.state.endDate}
                                        selectsStart
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </td>
                                <td>{this.state.last}</td>
                                <td>{this.state.last1}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>
                                    To
                                    &nbsp;
                                    &nbsp;
                                    &nbsp;
                                    <DatePicker
                                        selectsEnd
                                        selected={this.state.endDate}
                                        onChange={(date) => this.setEndDate(date)}
                                        minDate={this.state.startDate}
                                        maxDate={this.state.MaxDate}
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </td>
                                <td>{this.state.from}</td>
                                <td>{this.state.from1}</td>
                                <td></td>
                            </tr>
                            <tr style={{ background: '#F5F6F7' }}>
                                <td style={{ width: '36%' }}>
                                </td>
                                <td style={{ color: this.state.warrantPrice.indexOf('-') !== -1 ? 'red' : '#6CC263' }}>{this.state.warrantPrice}</td>
                                <td style={{ color: this.state.Underlying.indexOf('-') !== -1 ? 'red' : '#6CC263' }}>{this.state.Underlying}</td>
                                <td style={{ color: 'red' }}>{this.state.day}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table id="periodtab" className="ctab">
                        <tbody>
                            <tr>
                                <td
                                    className={classNames(
                                        { active: this.props.period === "D" },
                                        "ctab-item"
                                    )}
                                    onClick={() => this.onPeriodChange("D")}
                                >
                                    1D
                                </td>
                                <td className="ctab-item-space">&nbsp;</td>
                                <td
                                    className={classNames(
                                        { active: this.props.period === "W" },
                                        "ctab-item"
                                    )}
                                    onClick={() => this.onPeriodChange("W")}
                                >
                                    1W
                                </td>
                                <td className="ctab-item-space">&nbsp;</td>
                                <td
                                    className={classNames(
                                        { active: this.props.period === "M" },
                                        "ctab-item"
                                    )}
                                    onClick={() => this.onPeriodChange("M")}
                                >
                                    1M
                                </td>
                                <td className="ctab-item-space">&nbsp;</td>
                                <td
                                    className={classNames(
                                        { active: this.props.period === "Y" },
                                        "ctab-item"
                                    )}
                                    onClick={() => this.onPeriodChange("Y")}
                                >
                                    MAX
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="chart-legend">
                        <div className="row hidden-xs">
                            <div className="chart-legend-left col-sm-6">
                                <div className="chart-legend-item">
                                    Warrant bid price (SGD)
                                    <span className="chart-legend-bar warrant"></span>
                                </div>
                            </div>
                            {!this.props.needModifyBID && this.props.chartdata && this.props.chartdata.underlyingPrice && this.props.chartdata.underlyingPrice.length > 0 && (
                                <div className="chart-legend-right col-sm-6">
                                    <div className="chart-legend-item">
                                        Underlying price
                                        <span className="chart-legend-bar underlying"></span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="row visible-xs">
                            <table className="chart-legend-tbl">
                                <tbody>
                                    <tr>
                                        <td>
                                            Warrant bid price (<span className="SGD"></span>)
                                        </td>
                                        <td>
                                            <span className="chart-legend-bar warrant"></span>
                                        </td>
                                    </tr>
                                    {!this.props.needModifyBID && this.props.chartdata && this.props.chartdata.underlyingPrice && this.props.chartdata.underlyingPrice.length > 0 && (
                                        <tr>
                                            <td>
                                                Underlying price (
                                                <span className="underlying_curr">HKD</span>)
                                            </td>
                                            <td>
                                                <span className="chart-legend-bar underlying"></span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div id="chartbox" className="chartbox">
                        <Chart
                            period={this.props.period}
                            data={this.props.chartdata}
                            ref={this.chart}
                        />
                    </div>
                    {/* 文字说明 */}
                    <p className="small">
                        Last updated:{" "}
                        <span id="lastupdate">{MQSGUtil.formatNumberDisplay(this.props.warrantdata?.update_time)}</span>
                    </p>
                    <div className="disclaimer hidden-xs hidden-sm">
                        <p className="small">
                            All market data is delayed 15 mins unless otherwise
                            indicated by timestamp.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}
class WrCalculatorBox extends Component {
    constructor(props) {
        super(props);
        this.state = this.init(props);
        this.timer = null;
    }
    findClosestPair(arr, n) {
        let exactMatch = null;
        let minDiff = Infinity;
        let iv = null;
        
        // 将选定日期转换为年月日字符串（YYYY-MM-DD）
        let selectedDate = new Date(n);
        let selectedDateStr = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;

        
        for (let i = 0; i < arr.length; i++) {
            // 从 trade_date 提取年月日字符串（YYYY-MM-DD）
            let tradeDateStr = arr[i].trade_date.split('T')[0];
            
            // 优先查找当天匹配（直接比较年月日字符串）
            if (tradeDateStr === selectedDateStr) {
                exactMatch = arr[i].iv;
                break;
            }
            
            // 如果没有当天匹配，查找不超过选定日期且最接近的日期
            let tradeTime = new Date(arr[i].trade_date).getTime();
            if (tradeTime < n) {
                let diff = n - tradeTime;
                if (diff < minDiff) {
                    minDiff = diff;
                    iv = arr[i].iv;
                }
            }
        }
        
        // 如果有当天匹配，返回当天的值；否则返回不超过选定日期且最接近的值
        return exactMatch !== null ? exactMatch : iv;
    }
    updateIvval(impliedvolatility, value) {
        let ivval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 150.0,
            min: 10.0,
            step: 0.1,
            initial: 0.0,
            dp: 1,
        };
        if (impliedvolatility !== null && impliedvolatility !== undefined) {
            ivval.initial = value.initial;
            let ivNum = Number(impliedvolatility);
            ivval.currentValue = isNaN(ivNum) ? '0.0' : ivNum.toFixed(ivval.dp);
            ivval.stopValue = isNaN(ivNum) ? '0.0' : ivNum.toFixed(ivval.dp);
            ivval.typing = isNaN(ivNum) ? '0.0' : ivNum.toFixed(ivval.dp);
            return ivval;
        } else {
            return value
        }

    }
    isRightPanel() {
        if (
            typeof this.props.isRightPanel !== "undefined" &&
            this.props.isRightPanel !== null
        ) {
            return this.props.isRightPanel;
        }
        return false;
    }
    initbdval(marketdata) {
        let bdval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 1.0,
            min: 0.0,
            step: 0.01,
            initial: 0.0,
            dp: 2,
        };
        let underlyingprice = MQSGUtil.getNumber(
            marketdata,
            "underlying_price",
            null
        );
        let tick = marketdata.underlying_ticker;
        if (
            tick == 'HSI' ||
            tick == 'HSTECH' ||
            tick == 'STI' ||
            tick == 'N225'
        ) {
            bdval.dp = 0;
        }
        if (underlyingprice !== null) {
            bdval.initial = underlyingprice;
            bdval.currentValue = underlyingprice;
            bdval.stopValue = underlyingprice;
            bdval.typing = this.toThousands(underlyingprice);
            let indexUnderlyingTokens = [
                ".STI",
                "HSIc",
                "SSIcv",
                "ESc"
            ];
            let maxValue = Math.ceil(underlyingprice * 3);
            for (let i = 0; i < indexUnderlyingTokens.length; i++) {
                if (marketdata.underlying_ric.indexOf(indexUnderlyingTokens[i]) !== -1) {
                    maxValue = Math.ceil(underlyingprice * 1.34);
                    break;
                }
            }
            // let maxValue = Math.ceil(underlyingprice * 3.0);
            // let maxValue = Math.ceil(underlyingprice * 1.34);
            bdval.max = maxValue;
            let arry = process.env.REACT_APP_UNDERILING?.split(",") || [];
            let needModifyBID = false;
            if (typeof marketdata.ric === 'string' && marketdata.ric.trim()) {
                for (let item of arry) {
                    if (item.trim() === marketdata.ric || marketdata.underlying_ric === item.trim()) {
                        needModifyBID = true;
                        break;
                    }
                }
            }

            if (!needModifyBID && arry.includes("HK")) {
                if (typeof marketdata.ric === 'string' && marketdata.ric.trim() && marketdata.ric.trim().toLowerCase().endsWith(".hk") || marketdata.underlying_ric.trim().toLowerCase().endsWith(".hk")) {
                    needModifyBID = true;
                }
            }
            if (!needModifyBID && arry.includes(".O")) {
                if (typeof marketdata.ric === 'string' && marketdata.ric.trim() && marketdata.ric.trim().toLowerCase().endsWith(".o") || marketdata.underlying_ric.trim().toLowerCase().endsWith(".o")) {
                    needModifyBID = true;
                }
            }
            if (needModifyBID) {
                bdval.initial = 0;
            } else {
                bdval.typing = this.toThousands(underlyingprice);
            }
        }
        return { bdval, underlyingprice };
    }

    initdateval(marketdata, iv) {
        let dateval = {
            currentValue: 0,
            stopValue: 0,
            max: 31,
            min: 0,
            step: 1,
        };
        let lasttradingdate = MQSGUtil.getData(
            marketdata,
            "last_trading_date",
            null
        );
        let fitsttradingdate = iv[0]?.trade_date || new Date();
        if (lasttradingdate !== null) {
            let lastTradeDate = Date.parse(lasttradingdate);
            let fitsTtradingdate = Date.parse(fitsttradingdate);
            let currentDate = new Date();
            let diffTime = Math.abs(lastTradeDate - currentDate);
            let diffTime1 = fitsTtradingdate - currentDate;
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let diffDays1 = Math.ceil(diffTime1 / (1000 * 60 * 60 * 24));
            dateval.min = diffDays1;
            dateval.max = diffDays;
        }
        return { dateval };
    }

    initivval(marketdata) {
        let ivval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 150.0,
            min: 10.0,
            step: 0.1,
            initial: 0.0,
            dp: 1,
        };
        let impliedvolatility = MQSGUtil.getNumber(
            marketdata,
            "implied_volatility",
            null
        );
        if (impliedvolatility !== null) {
            ivval.initial = impliedvolatility;
            ivval.currentValue = impliedvolatility;
            ivval.stopValue = impliedvolatility;
            ivval.typing = impliedvolatility.toFixed(ivval.dp);
        }
        return { ivval, impliedvolatility };
    }

    initWarrantBidPrice(marketdata, impliedvolatility, underlyingprice) {
        let warrantBidPrice = {
            currentValue: null,
            initial: null,
        };
        warrantBidPrice.initial = MQSGUtil.getData(
            marketdata,
            // "warrant_price",
            'BID',
            null
        );
        let selectedDate = this.generateDateString(0);
        this.logic.initMatrix(underlyingprice, impliedvolatility, selectedDate);
        warrantBidPrice.currentValue = warrantBidPrice.initial
        return { warrantBidPrice, selectedDate };
    }
    componentDidMount() {
        this.onReset()
    }
    init(props) {
        let initData = this.initNoData();
        if (typeof props.marketdata !== "undefined" && props.marketdata !== null) {
            this.logic = new WrCalculatorLogic(props.marketdata, props.iv);
            initData = this.initData(props.marketdata, props.iv);
        }
        return initData;
    }

    initNoData() {
        let bdval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 1.0,
            min: 0.0,
            step: 0.01,
            initial: 0.0,
            dp: 2,
        };
        let ecval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 1.0,
            min: 0.0,
            step: 0.01,
            initial: 0.0,
            dp: 2,
        };
        let edateval = {
            currentValue: 0,
            stopValue: 0,
            max: 31,
            min: 0,
            step: 1,
        };
        let eivval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 150.0,
            min: 10.0,
            step: 0.1,
            initial: 0.0,
            dp: 1,
        };
        let dateval = {
            currentValue: 0,
            stopValue: 0,
            max: 31,
            min: 0,
            step: 1,
        };
        let ivval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 150.0,
            min: 10.0,
            step: 0.1,
            initial: 0.0,
            dp: 1,
        };
        let warrantBidPrice = {
            currentValue: null,
            initial: null,
        };
        return {
            bdval,
            ecval,
            edateval,
            eivval,
            dateval,
            ivval,
            warrantBidPrice,
            delta: 0.0,
            effgearing: 0.0,
            dwpchg: 0.0,
        };
    }

    initData(marketdata, iv) {
        let initData = {
            bdval: null,
            ecval: null,
            edateval: null,
            eivval: null,
            dateval: null,
            ivval: null,
            warrantBidPrice: null,
            delta: 0.0,
            effgearing: 0.0,
            dwpchg: 0.0,
        };
        let initbdval = this.initbdval(marketdata);
        let initecval = this.initbdval(marketdata);
        let initdateval = this.initdateval(marketdata, iv);
        let initedateval = this.initdateval(marketdata, iv);
        let initivval = this.initivval(marketdata);
        let initeivval = this.initivval(marketdata);
        let initWarrantBidPrice = this.initWarrantBidPrice(
            marketdata,
            initivval.impliedvolatility,
            initbdval.underlyingprice
        );
        initData.bdval = initbdval.bdval;
        initData.ecval = initecval.bdval;
        initData.dateval = initdateval.dateval;
        initData.edateval = initedateval.dateval;
        initData.ivval = initivval.ivval;
        initData.eivval = initeivval.ivval;
        initData.warrantBidPrice = initWarrantBidPrice.warrantBidPrice;
        let deltaAndEffgearing = this.logic.getDeltaAndEffGearingAndDwpChange(
            initbdval.underlyingprice,
            initWarrantBidPrice.selectedDate
        );
        initData.delta = deltaAndEffgearing.delta;
        initData.effgearing = deltaAndEffgearing.effgearing;
        initData.dwpchg = deltaAndEffgearing.dwpchg;
        return initData;
    }

    recalculateMatrix(
        value
    ) { 
        let impliedVolatilityUse = '';
        let underlyingBidPriceUse = '';
        let selectedDateUse = '';
        if(value == 'left'){
            impliedVolatilityUse = this.state.eivval.currentValue;
            underlyingBidPriceUse = this.state.ecval.currentValue;
            selectedDateUse = this.generateDateString(this.state.edateval.currentValue);
        }else{
            impliedVolatilityUse = this.state.ivval.currentValue;
            underlyingBidPriceUse = this.state.bdval.currentValue;
            selectedDateUse = this.generateDateString(this.state.dateval.currentValue);
        }
        if (this.logic) {
            this.logic.initMatrix(
                underlyingBidPriceUse,
                impliedVolatilityUse,
                selectedDateUse
            );
        }
        let calculatedWarrantBidPrice = this.logic ? this.logic.getWarrantBidPrice() : null;
        if (!isNaN(Number(calculatedWarrantBidPrice))) {
            let warrantBidPrice = this.state.warrantBidPrice;
            if (value == 'left') {
                warrantBidPrice.initial = calculatedWarrantBidPrice;
            } else {
                warrantBidPrice.currentValue = calculatedWarrantBidPrice;
            }

            this.setState({ warrantBidPrice });
        }
        if (this.logic) {
            let deltaAndEffgearing = this.logic.getDeltaAndEffGearingAndDwpChange(
                underlyingBidPriceUse,
                selectedDateUse
            );
            this.setState({
                delta: deltaAndEffgearing.delta,
                effgearing: deltaAndEffgearing.effgearing,
                dwpchg: deltaAndEffgearing.dwpchg,
            });
        }
    }

    onReset() {
        let bdval = this.state.bdval;
        bdval.currentValue = bdval.initial;
        bdval.stopValue = bdval.initial;
        bdval.typing = bdval.initial.toFixed(bdval.dp);

        let ecval = this.state.ecval;
        ecval.currentValue = ecval.initial;
        ecval.stopValue = ecval.initial;
        ecval.typing = ecval.initial.toFixed(ecval.dp);

        let dateval = this.state.dateval;
        dateval.currentValue = 0;
        dateval.stopValue = 0;

        let edateval = this.state.edateval;
        edateval.currentValue = 0;
        edateval.stopValue = 0;

        let ivval = this.state.ivval;
        ivval.currentValue = ivval.initial;
        ivval.stopValue = ivval.initial;
        ivval.typing = ivval.initial.toFixed(ivval.dp);

        let eivval = this.state.eivval;
        eivval.currentValue = eivval.initial;
        eivval.stopValue = eivval.initial;
        eivval.typing = eivval.initial.toFixed(ivval.dp);

        this.setState({ bdval, dateval, ivval, ecval, eivval, edateval });
        this.recalculateMatrix('left');
        this.recalculateMatrix('right');
    }
    toThousands(str) {
        if ("-" == str) {
            return str
        }
        let newStr = "";
        let count = 0;
        let cpstr = str + '';
        if (cpstr.indexOf(".") === -1) {
            for (let i = cpstr.length - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr;
                }
                count++;
            }
            cpstr = newStr + ".00";

        }
        else {
            for (let i = cpstr.indexOf(".") - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr;
                }
                count++;
            }
            cpstr = newStr + (cpstr + "00").substr((cpstr + "00").indexOf("."), 3);
        }
        return cpstr
    }
    toRigitThousands(str) {
        let newStr = "";
        let count = 0;
        let cpstr = str + '';
        if (cpstr.indexOf(".") === -1) {
            for (let i = cpstr.length - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr;
                }
                count++;
            }
            cpstr = newStr;
        }
        else {
            for (let i = cpstr.indexOf(".") - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr;
                }
                count++;
            }
            cpstr = newStr + (cpstr + "00").substr((cpstr + "00").indexOf("."), 3);
        }
        return cpstr
    }
    onUnderlyingBidPriceChange(event) {
        let newValue = this.state.bdval;
        newValue.currentValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value);
        this.setState({ bdval: newValue });
    }
    onECUnderlyingBidPriceChange(event) {
        let newValue = this.state.ecval;
        newValue.currentValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value);
        this.setState({ ecval: newValue });
    }

    onUnderlyingBidPriceInputChange(event) {
        let newValue = this.state.bdval;
        newValue.typing = event.target.value;
        this.setState({ bdval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onUnderlyingBidPriceKeyDown(event, true)
            }, 1000);
        });
    }
    onECUnderlyingBidPriceInputChange(event) {
        let newValue = this.state.ecval;
        newValue.typing = event.target.value;
        this.setState({ ecval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onECUnderlyingBidPriceKeyDown(event, true)
            }, 1000);
        });
    }
    moneyDelete(num) {
        if (num && num !== undefined && num !== null) {
            let _num = num;
            _num = _num.toString();
            _num = _num.replace(/,/gi, '');
            return _num
        } else {
            return num
        }
    }
    onUnderlyingBidPriceKeyDown(event, val) {
        if (event.key === "Enter" || val === true) {
            let value = null;
            if (this.state.bdval.typing.indexOf(',') !== -1) {
                value = Number(this.moneyDelete(this.state.bdval.typing));
            } else {
                value = Number(this.state.bdval.typing);
            }
            if (this.state.bdval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.bdval.min || value > this.state.bdval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = this.state.bdval.initial;
            }
            let event = { target: { value } };
            this.onUnderlyingBidPriceChangeStop(event);
        }
    }
    onECUnderlyingBidPriceKeyDown(event, val) {
        if (event.key === "Enter" || val === true) {
            let value = null;
            if (this.state.ecval.typing.indexOf(',') !== -1) {
                value = Number(this.moneyDelete(this.state.ecval.typing));
            } else {
                value = Number(this.state.ecval.typing);
            }
            if (this.state.ecval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.ecval.min || value > this.state.ecval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = this.state.ecval.initial;
            }
            let event = { target: { value } };
            this.onECUnderlyingBidPriceChangeStop(event);
        }
    }
    onUnderlyingBidPriceChangeStop(event) {
        let newValue = this.state.bdval;
        newValue.currentValue = event.target.value;
        newValue.stopValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value.toFixed(this.state.bdval.dp));
        this.setState({ bdval: newValue },()=>{
            this.recalculateMatrix('right');
        });
    }

    onECUnderlyingBidPriceChangeStop(event) {
        let newValue = this.state.ecval;
        newValue.currentValue = event.target.value;
        newValue.stopValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value.toFixed(this.state.ecval.dp));
        this.setState({ ecval: newValue },()=>{
            this.recalculateMatrix('left');
        });
    }

    getUnderlyingBidPrice() {
        return this.state.bdval.currentValue.toFixed(this.state.bdval.dp);
    }

    getUnderlyingBidPriceLastStopValue() {
        return this.state.bdval.typing;
    }

    calculateUnderlyingBidPriceChange() {
        let diff = this.state.bdval.stopValue - this.state.ecval.stopValue;
        // let change = (diff / this.state.ecval.stopValue) * 100.0;
        let change = Number(diff) == 0 || Number(this.state.ecval.stopValue) == 0 ? 0 : (diff / this.state.ecval.stopValue) * 100.0;
        return { diff, change };
    }

    getUnderlyingBidPriceChangePercentage() {
        let result = this.calculateUnderlyingBidPriceChange();
        // let change = result.change.toFixed(1);
        let change = result.change == 0 ? '0.0' : result.change.toFixed(1);
        return <>{change}</>;
    }

    getUnderlyingBidPrice3() {
        let result = this.calculateUnderlyingBidPriceChange();
        let upDown = "";
        let upDownSign = "";
        if (result.diff > 0) {
            upDown = "up";
            upDownSign = "+";
        } else if (result.diff < 0) {
            upDown = "down";
        }
        let getChange = result.change == 0 ? '0.0' : result.change.toFixed(1);
        let change = " (" + upDownSign + getChange + "%)";
        // let change = " (" + upDownSign + result.change.toFixed(1) + "%)";
        let current = this.getUnderlyingBidPriceLastStopValue();
        return (
            <>
                {current}
                <span className={upDown}>{change}</span>
            </>
        );
    }

    onDateChange(value) {
        let newValue = { ...this.state.dateval };
        let ivval = { ...this.state.ivval };
        // 确保右侧日期不小于左侧日期
        // if (value < this.state.edateval.currentValue) {
        //     value = this.state.edateval.currentValue;
        // }
        newValue.currentValue = value;
        let currentDate = new Date();
        let noOfDay = value;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        let iv = this.findClosestPair(this.props.iv, currentDate.getTime())
        let ivData = this.updateIvval(iv, ivval)
        this.setState({ ivval: ivData }, () => {
            this.setState({ dateval: newValue });
        })
    }
    oneDateChange(value) {
        let newValue = { ...this.state.edateval };
        let eivval = { ...this.state.eivval };
        // 确保左侧日期不大于右侧日期
        // if (value > this.state.dateval.currentValue) {
        //     value = this.state.dateval.currentValue;
        // }
        newValue.currentValue = value;
        let currentDate = new Date();
        let noOfDay = value;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        let iv = this.findClosestPair(this.props.iv, currentDate.getTime())
        let ivData = this.updateIvval(iv, eivval)
        this.setState({ eivval: ivData }, () => {
            this.setState({ edateval: newValue });
        })

    }

    onDateChangeStop(value) {
        let newValue = this.state.dateval;
        let ivval = { ...this.state.ivval };
        // if (value < this.state.edateval.currentValue) {
        //     value = this.state.edateval.currentValue;
        // }
        newValue.currentValue = value;
        newValue.stopValue = value;
        let currentDate = new Date();
        let noOfDay = value;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        let iv = this.findClosestPair(this.props.iv, currentDate.getTime())
        let ivData = this.updateIvval(iv, ivval)
        this.setState({ ivval: ivData }, () => {
            this.setState({ dateval: newValue },()=>{
                this.recalculateMatrix('right');
            });
        })
    }

    oneDateChangeStop(value) {
        let newValue = this.state.edateval;
        // if (value > this.state.dateval.currentValue) {
        //     value = this.state.dateval.currentValue;
        // }
        newValue.currentValue = value;
        newValue.stopValue = value;
        let eivval = { ...this.state.eivval };
        let currentDate = new Date();
        let noOfDay = value;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        let iv = this.findClosestPair(this.props.iv, currentDate.getTime())
        let ivData = this.updateIvval(iv, eivval)
        this.setState({ eivval: ivData }, () => {
            this.setState({ edateval: newValue },()=>{
                this.recalculateMatrix('left');
            });
        })
    }

    onDatePickerChange(date) {
        let newValue = { ...this.state.dateval };
        let ivval = { ...this.state.ivval };
        let oneDayMS = 24 * 60 * 60 * 1000;
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        let noDay = 0;
        let diffMS = date.getTime() - currentDate.getTime();
        let iv= '';
        noDay = diffMS / oneDayMS;
        // if (noDay < this.state.edateval.currentValue) {
        //     noDay = this.state.edateval.currentValue;
        //     iv = this.state.eivval.currentValue;
        // }else{
            iv = this.findClosestPair(this.props.iv, date.getTime())
        // }
        let ivData = this.updateIvval(iv, ivval)
        this.setState({ ivval: ivData }, () => {
                // if (noDay < this.state.edateval.currentValue) {
                //     noDay = this.state.edateval.currentValue;
                // }
            newValue.currentValue = noDay;
            newValue.stopValue = noDay;
            this.setState({ dateval: newValue },()=>{
                this.recalculateMatrix('right');
            });
        })
    }
    oneDatePickerChange(date) {
        let newValue = { ...this.state.edateval };
        let oneDayMS = 24 * 60 * 60 * 1000;
        let currentDate = new Date();
        let eivval = { ...this.state.eivval };
        currentDate.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        let noDay = 0;
        let diffMS = date.getTime() - currentDate.getTime();
        let iv = '';
        noDay = diffMS / oneDayMS;
        // if (noDay > this.state.dateval.currentValue) {
        //     noDay = this.state.dateval.currentValue;
        //     iv = this.state.ivval.currentValue;
        // }else{
            iv = this.findClosestPair(this.props.iv, date.getTime());
        // }
        let ivData = this.updateIvval(iv, eivval)
        this.setState({ eivval: ivData }, () => {
                // if (noDay > this.state.dateval.currentValue) {
                //     noDay = this.state.dateval.currentValue;
                // }
            newValue.currentValue = noDay;
            newValue.stopValue = noDay;
            this.setState({ edateval: newValue },()=>{
                this.recalculateMatrix('left');
            });
        })
    }

    generateDateString(noOfDay) {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + noOfDay);

        let months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        let day = currentDate.getDate();
        let month = months[currentDate.getMonth()];
        let year = currentDate.getFullYear().toString().slice(2);
        let selectedDate = day + " " + month + " " + year;
        return selectedDate;
    }

    getDateMS() {
        let currentDate = new Date();
        let noOfDay = this.state.dateval?.currentValue || 0;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        // 验证日期是否有效
        if (isNaN(currentDate.getTime())) {
            return new Date();
        }
        return currentDate;
    }
    geteDateMS() {
        let currentDate = new Date();
        let noOfDay = this.state.edateval?.currentValue || 0;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        // 验证日期是否有效
        if (isNaN(currentDate.getTime())) {
            return new Date();
        }
        return currentDate;
    }

    getDate() {
        return this.generateDateString(this.state.dateval.currentValue);
    }
    geteDate() {
        return this.generateDateString(this.state.edateval.currentValue);
    }

    getDateLastStopValue() {
        return this.generateDateString(this.state.dateval.stopValue);
    }

    onVolatilityChange(value) {
        let newValue = this.state.ivval;
        newValue.currentValue = value;
        newValue.typing = Number(value).toFixed(newValue.dp);
        this.setState({ ivval: newValue });
    }
    oneVolatilityChange(value) {
        let newValue = this.state.eivval;
        newValue.currentValue = value;
        newValue.typing = Number(value).toFixed(newValue.dp);
        this.setState({ eivval: newValue });
    }

    onVolatilityInputChange(event) {
        let newValue = this.state.ivval;
        newValue.typing = event.target.value;
        this.setState({ ivval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onVolatilityKeyDown(event, true)
            }, 1000);
        });
    }
    oneVolatilityInputChange(event) {
        let newValue = this.state.eivval;
        newValue.typing = event.target.value;
        this.setState({ eivval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.oneVolatilityKeyDown(event, true)
            }, 1000);
        });
    }

    onVolatilityKeyDown(event, val) {
        if (event.key === "Enter" || val == true) {
            let value = Number(this.state.ivval.typing);
            if (this.state.ivval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.ivval.min || value > this.state.ivval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = this.state.ivval.initial;
            }
            let event = { target: { value } };
            this.onVolatilityChangeStop(event.target.value);
        }
    }
    oneVolatilityKeyDown(event, val) {
        if (event.key === "Enter" || val == true) {
            let value = Number(this.state.eivval.typing);
            if (this.state.eivval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.eivval.min || value > this.state.eivval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = this.state.eivval.initial;
            }
            let event = { target: { value } };
            this.oneVolatilityChangeStop(event.target.value);
        }
    }

    onVolatilityChangeStop(value) {
        let newValue = this.state.ivval;
        newValue.currentValue = value;
        newValue.stopValue = value;
        newValue.typing = value.toFixed(this.state.ivval.dp);
        this.setState({ ivval: newValue },()=>{
            this.recalculateMatrix('right');
        });
        
    }
    oneVolatilityChangeStop(value) {
        let newValue = this.state.eivval;
        newValue.currentValue = value;
        newValue.stopValue = value;
        newValue.typing = value.toFixed(this.state.eivval.dp);
        this.setState({ eivval: newValue },()=>{
            this.recalculateMatrix('left');
        });
    }

    getVolatility() {
        return this.state.ivval.currentValue.toFixed(this.state.ivval.dp);
    }

    getVolatilityLastStopValue() {
        return this.state.ivval.stopValue.toFixed(this.state.ivval.dp);
    }

    calculateWarrantBidPriceChange(a) {
        let  initialWarrantPrice = '';
        let  calculatedWarrantBidPrice = '';
        if (a == 1) {
             initialWarrantPrice = MQSGUtil.getData(
                this.props.marketdata,
                // "warrant_price",
                'BID',
                null
            );
             calculatedWarrantBidPrice = this.state.warrantBidPrice.initial;
        } else {
             initialWarrantPrice = this.state.warrantBidPrice.initial;
             calculatedWarrantBidPrice = this.state.warrantBidPrice.currentValue;
        }

        if (
            initialWarrantPrice !== null &&
            !isNaN(Number(calculatedWarrantBidPrice))
        ) {
            let diff = calculatedWarrantBidPrice - initialWarrantPrice;
            // let change = (diff / initialWarrantPrice) * 100.0;
            let change = Number(diff) == 0 || Number(initialWarrantPrice) == 0 ? 0 : (diff / initialWarrantPrice) * 100.0;
            return { diff, change };
        }
        return null;
    }

    getWarrantBidPrice3(a) {
        let result = this.calculateWarrantBidPriceChange(a);
        let current = '';
        if (result !== null) {
            let upDown = "";
            let upDownSign = "";
            if (result.diff > 0) {
                upDown = "up";
                upDownSign = "+";
            } else if (result.diff < 0) {
                upDown = "down";
            }
            let getChange = result.change === 0 ? '0.0' : result.change.toFixed(1);
            let change = " (" + upDownSign + getChange + "%)";
            // let change = " (" + upDownSign + result.change.toFixed(1) + "%)";
            if (a === 1) {
                 current = this.state.warrantBidPrice.initial;
            } else {
                 current = this.state.warrantBidPrice.currentValue;
            }
            return (
                <>
                    {current}
                    {a !== 1 && <span className={upDown}>{change}</span>}
                </>
            );
        }
        return (
            <>
                --<span>--</span>
            </>
        );
    }

    getDelta() {
        return this.state.delta;
    }

    getEffGearing() {
        return this.state.effgearing;
    }

    getDwpChange() {
        return this.state.dwpchg;
    }

    underlyingBidPriceControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl">
                    <td className="wcalbox-col-lbl">Underlying price target</td>
                    <td className="wcol-col-empty"></td>
                </tr>
                <tr className="wcalbox-row-ctr">
                    <td className="wcalbox-col-input">
                        <input
                            className="wcalbox-input underlying_bid_price"
                            type="text"
                            maxLength="10"
                            name="bdval"
                            value={this.state.bdval.typing}
                            // onKeyDown={(event) => this.onUnderlyingBidPriceKeyDown(event)}
                            // onBlur={(event) => this.onUnderlyingBidPriceKeyDown(event, true)}
                            onChange={(event) => this.onUnderlyingBidPriceInputChange(event)}
                        />
                    </td>
                    <td className="wcalbox-col-slider  hidden-xs hidden-sm">
                        <Slider
                            value={this.state.bdval.currentValue}
                            onChange={(value) => this.onUnderlyingBidPriceChange({ target: { value } })}
                            onChangeComplete={(value) => this.onUnderlyingBidPriceChangeStop({ target: { value } })}
                            step={this.state.bdval.step}
                            max={this.state.bdval.max}
                            min={this.state.bdval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    underlyingBidPriceControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Underlying price target</td>
                    <td className="wcol-col-empty"></td>
                </tr>
                <tr>
                    <td>
                        <input
                            type="text"
                            maxLength="10"
                            name="bdval"
                            style={{ textAlign: "center" }}
                            value={this.state.bdval.typing}
                            // onKeyDown={(event) => this.onUnderlyingBidPriceKeyDown(event)}
                            // onBlur={(event) => this.onUnderlyingBidPriceKeyDown(event, true)}
                            onChange={(event) => this.onUnderlyingBidPriceInputChange(event)}
                        />
                    </td>
                    <td className=" hidden-xs hidden-sm">
                        <Slider
                            value={this.state.bdval.currentValue}
                            onChange={(value) => this.onUnderlyingBidPriceChange({ target: { value } })}
                            onChangeComplete={(value) => this.onUnderlyingBidPriceChangeStop({ target: { value } })}
                            step={this.state.bdval.step}
                            max={this.state.bdval.max}
                            min={this.state.bdval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }
    entryCurrentUnderlyingBidPriceControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Underlying price entry</td>
                    <td className="wcol-col-empty"></td>
                </tr>
                <tr>
                    <td>
                        <input
                            type="text"
                            maxLength="10"
                            name="bdval"
                            style={{ textAlign: "center" }}
                            value={this.state.ecval.typing}
                            // onKeyDown={(event) => this.onUnderlyingBidPriceKeyDown(event)}
                            // onBlur={(event) => this.onUnderlyingBidPriceKeyDown(event, true)}
                            onChange={(event) => this.onECUnderlyingBidPriceInputChange(event)}
                        />
                    </td>
                    <td className="hidden-xs hidden-sm">
                        <Slider
                            value={this.state.ecval.currentValue}
                            onChange={(value) => this.onECUnderlyingBidPriceChange({ target: { value } })}
                            onChangeComplete={(value) => this.onECUnderlyingBidPriceChangeStop({ target: { value } })}
                            step={this.state.ecval.step}
                            max={this.state.ecval.max}
                            min={this.state.ecval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }
    entryCurrentUnderlyingBidPriceControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl">
                    <td className="wcalbox-col-lbl">Underlying price entry</td>
                    <td className="wcol-col-empty "></td>
                </tr>
                <tr className="wcalbox-row-ctr">
                    <td className="wcalbox-col-input">
                        <input
                            className="wcalbox-input underlying_bid_price"
                            type="text"
                            maxLength="10"
                            name="bdval"
                            value={this.state.ecval.typing}
                            // onKeyDown={(event) => this.onUnderlyingBidPriceKeyDown(event)}
                            // onBlur={(event) => this.onUnderlyingBidPriceKeyDown(event, true)}
                            onChange={(event) => this.onECUnderlyingBidPriceInputChange(event)}
                        />
                    </td>
                    <td className="wcalbox-col-slider hidden-xs hidden-sm">
                        <Slider
                            value={this.state.ecval.currentValue}
                            onChange={(value) => this.onECUnderlyingBidPriceChange({ target: { value } })}
                            onChangeComplete={(value) => this.onECUnderlyingBidPriceChangeStop({ target: { value } })}
                            step={this.state.ecval.step}
                            max={this.state.ecval.max}
                            min={this.state.ecval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }
    getbgDate(date) {
        let m = new Date().getMonth() + 1;
        let M = new Date(date).getMonth() + 1;
        let cls = m !== M ? "random" : undefined;
        return cls
    }

    dateControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl">
                    <td className="wcalbox-col-lbl" colSpan="2">Date ({(this.state.dateval.currentValue - this.state.edateval.currentValue)} of days from today)</td>
                    <td></td>
                </tr>
                <tr className="wcalbox-row-ctr   ">
                    <td className="wcalbox-col-input" style={{ position: "relative" }}>
                        <DatePicker
                            selected={this.getDateMS()}
                            dateFormat="dd MMM yy"
                            onChange={(date) => this.onDatePickerChange(date)}
                            minDate={this.props.iv && this.props.iv.length > 0 && this.props.iv[0]?.trade_date ? new Date(this.props.iv[0].trade_date) : new Date()}
                            maxDate={this.props.marketdata?.last_trading_date ? new Date(this.props.marketdata.last_trading_date) : new Date()}
                        />
                    </td>
                    <td className="wcalbox-col-slider  hidden-xs hidden-sm">
                        <Slider
                            value={this.state.dateval.currentValue}
                            onChange={this.onDateChange.bind(this)}
                            onChangeComplete={this.onDateChangeStop.bind(this)}
                            step={this.state.dateval.step}
                            max={this.state.dateval.max}
                            min={this.state.dateval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    edateControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl">
                    <td className="wcalbox-col-lbl">Date</td>
                    <td></td>
                </tr>
                <tr className="wcalbox-row-ctr   ">
                    <td className="wcalbox-col-input" style={{ position: "relative" }}>
                        <DatePicker
                            selected={this.geteDateMS()}
                            dateFormat="dd MMM yy"
                            onChange={(date) => this.oneDatePickerChange(date)}
                            minDate={this.props.iv && this.props.iv.length > 0 && this.props.iv[0]?.trade_date ? new Date(this.props.iv[0].trade_date) : new Date()}
                            maxDate={this.props.marketdata?.last_trading_date ? new Date(this.props.marketdata.last_trading_date) : new Date()}
                        />
                    </td>
                    <td className="wcalbox-col-slider  hidden-xs hidden-sm">
                        <Slider
                            value={this.state.edateval.currentValue}
                            onChange={this.oneDateChange.bind(this)}
                            onChangeComplete={this.oneDateChangeStop.bind(this)}
                            step={this.state.edateval.step}
                            max={this.state.edateval.max}
                            min={this.state.edateval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }
    dateControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Date</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <DatePicker
                            selected={this.getDateMS()}
                            dateFormat="dd MMM yy"
                            onChange={(date) => this.onDatePickerChange(date)}
                        />
                    </td>
                    <td className="wcalbox-col-slider hidden-xs hidden-sm">
                        <Slider
                            value={this.state.dateval.currentValue}
                            onChange={this.onDateChange.bind(this)}
                            onChangeComplete={this.onDateChangeStop.bind(this)}
                            step={this.state.dateval.step}
                            max={this.state.dateval.max}
                            min={this.state.dateval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    dateeControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Date</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <DatePicker
                            selected={this.geteDateMS()}
                            dateFormat="dd MMM yy"
                            onChange={(date) => this.oneDatePickerChange(date)}
                        />
                    </td>
                    <td className="wcalbox-col-slider hidden-xs hidden-sm">
                        <Slider
                            value={this.state.edateval.currentValue}
                            onChange={this.oneDateChange.bind(this)}
                            onChangeComplete={this.oneDateChangeStop.bind(this)}
                            step={this.state.edateval.step}
                            max={this.state.edateval.max}
                            min={this.state.edateval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    volatilityControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl iv-slider-top">
                    <td className="wcalbox-col-lbl">Volatility (%)</td>
                    <td></td>
                </tr>
                <tr className="wcalbox-row-ctr iv-slider-bottom">
                    <td className="wcalbox-col-input">
                        <input
                            className="wcalbox-input implied_volatility"
                            type="text"
                            name="ivval"
                            maxLength="6"
                            value={this.state.ivval.typing}
                            // onKeyDown={this.onVolatilityKeyDown.bind(this)}
                            // onBlur={(e) => { this.onVolatilityKeyDown(e, true) }}
                            onChange={this.onVolatilityInputChange.bind(this)}
                        />
                    </td>
                    <td className="wcalbox-col-slider  hidden-xs hidden-sm">
                        <Slider
                            value={this.state.ivval.currentValue}
                            onChange={this.onVolatilityChange.bind(this)}
                            onChangeComplete={this.onVolatilityChangeStop.bind(this)}
                            step={this.state.ivval.step}
                            max={this.state.ivval.max}
                            min={this.state.ivval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    evolatilityControl() {
        return (
            <>
                <tr className="wcalbox-row-lbl iv-slider-top">
                    <td className="wcalbox-col-lbl">Volatility (%)</td>
                    <td></td>
                </tr>
                <tr className="wcalbox-row-ctr iv-slider-bottom">
                    <td className="wcalbox-col-input">
                        <input
                            className="wcalbox-input implied_volatility"
                            type="text"
                            name="ivval"
                            maxLength="6"
                            value={this.state.eivval.typing}
                            // onKeyDown={this.onVolatilityKeyDown.bind(this)}
                            // onBlur={(e) => { this.onVolatilityKeyDown(e, true) }}
                            onChange={this.oneVolatilityInputChange.bind(this)}
                        />
                    </td>
                    <td className="wcalbox-col-slider  hidden-xs hidden-sm">
                        <Slider
                            value={this.state.eivval.currentValue}
                            onChange={this.oneVolatilityChange.bind(this)}
                            onChangeComplete={this.oneVolatilityChangeStop.bind(this)}
                            step={this.state.eivval.step}
                            max={this.state.eivval.max}
                            min={this.state.eivval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }
    volatilityControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Volatility (%)</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <input
                            type="text"
                            maxLength="10"
                            name="bdval"
                            style={{ textAlign: "center" }}
                            value={this.state.ivval.typing}
                            // onKeyDown={this.onVolatilityKeyDown.bind(this)}
                            // onBlur={(e) => { this.onVolatilityKeyDown(e, true) }}
                            onChange={this.onVolatilityInputChange.bind(this)}
                        />
                    </td>
                    <td className=" hidden-xs hidden-sm">
                        <Slider
                            value={this.state.ivval.currentValue}
                            onChange={this.onVolatilityChange.bind(this)}
                            onChangeComplete={this.onVolatilityChangeStop.bind(this)}
                            step={this.state.ivval.step}
                            max={this.state.ivval.max}
                            min={this.state.ivval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    volatilityeControlRightPanel() {
        return (
            <>
                <tr>
                    <td>Volatility (%)</td>
                    <td></td>
                </tr>
                <tr>
                    <td>
                        <input
                            type="text"
                            maxLength="10"
                            name="bdval"
                            style={{ textAlign: "center" }}
                            value={this.state.eivval.typing}
                            // onKeyDown={this.onVolatilityKeyDown.bind(this)}
                            // onBlur={(e) => { this.onVolatilityKeyDown(e, true) }}
                            onChange={this.oneVolatilityInputChange.bind(this)}
                        />
                    </td>
                    <td className=" hidden-xs hidden-sm">
                        <Slider
                            value={this.state.eivval.currentValue}
                            onChange={this.oneVolatilityChange.bind(this)}
                            onChangeComplete={this.oneVolatilityChangeStop.bind(this)}
                            step={this.state.eivval.step}
                            max={this.state.eivval.max}
                            min={this.state.eivval.min}
                            reverse={false}
                        />
                    </td>
                </tr>
            </>
        );
    }

    xssmInput() {
        return (
            <div className="row">
                <div className="wcalbox-row col-xs-12 col-sm-4">
                    <div className="wcalbox-col">Underlying bid price</div>
                    <div className="wcalbox-col">
                        <input
                            className="wcalbox-input underlying_bid_price"
                            type="text"
                            name="bdval"
                            maxLength="10"
                        />
                    </div>
                </div>
                <div className="wcalbox-row col-xs-12 col-sm-4">
                    <div className="wcalbox-col">Date</div>
                    <div className="wcalbox-col">
                        <div id="datepicker-xs">
                            <input
                                className="wcalbox-input today_date"
                                type="text"
                                name="dateval"
                            />
                        </div>
                    </div>
                </div>
                <div className="wcalbox-row col-xs-12 col-sm-4 iv-slider-full">
                    <div className="wcalbox-col">Volatility (%)</div>
                    <div className="wcalbox-col">
                        <input
                            className="wcalbox-input implied_volatility"
                            type="text"
                            name="ivval"
                            maxLength="6"
                        />
                    </div>
                </div>
            </div>
        );
    }

    simulatedResultsUpperTable(i) {
        let value = i === 1 ? "Estimated Warrant bid price" : "Warrant bid price";
        let style = {};
        let style1 = {};
        if (i === 1) {
            style = {
                borderBottom: "1px solid #FECC0A",
                backgroundColor: "#fff",
                textAlign: "left",
            };
            style1 = {
                backgroundColor: "#F5F6F7",
            };
        } else {
            style = {
                backgroundColor: "#F5F6F7",
            };
            style1 = {
                backgroundColor: "#fff",
            };
        }
        return (
            <div className="row" style={{ overflowX: 'auto' }}>
                <div className="col-md-6 col-xs-12 col-sm-12">
                    Warrant Entry Price
                    <table id="ivtable" className="table table-striped-inverse">
                        <thead>
                            <tr className="row_0">
                                <th style={style}>{value}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="wprice_3 active" style={style1}>
                                    {this.getWarrantBidPrice3(1)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-md-6 col-xs-12 col-sm-12 border_none" style={{ borderLeft: '1px solid #000' }}>
                    Warrant Exit Price
                    <table id="ivtable" className="table table-striped-inverse">
                        <thead>
                            <tr className="row_0">
                                <th style={style}>Underlying bid price</th>
                                <th style={style}>{value}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="uprice_3 active" style={style1}>
                                    {this.getUnderlyingBidPrice3()}
                                </td>
                                <td className="wprice_3 active" style={style1}>
                                    {this.getWarrantBidPrice3()}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
           
        );
    }

    simulatedResultsLowerTable() {
        let marketdata = this.props.marketdata;
        let exerciseprice = MQSGUtil.getData(marketdata, "exercise_price");
        let currency = MQSGUtil.getData(marketdata, "currency");
        let underlyingcurr = MQSGUtil.getData(marketdata, "underlying_curr");
        let lasttradingdate = MQSGUtil.getData(marketdata, "last_trading_date");

        return (
            <div id="srtable" style={{ overflowX: 'auto' }}>
                <table className="table">
                    <tbody>
                        <tr>
                            <th className="srtable-leftlbl bgcolor-01">
                                Warrant bid price (<span className="currency">{currency}</span>)
                            </th>
                            <td className="srtable-leftval bgcolor-01 BID">
                                {this.state.warrantBidPrice.currentValue}
                            </td>
                            <th className="srtable-rightlbl bgcolor-02">
                                Exercise price (
                                <span className="underlying_curr">{underlyingcurr}</span>)
                            </th>
                            <td className="srtable-rightval bgcolor-02 exercise_price">
                                {exerciseprice}
                            </td>
                        </tr>
                        <tr>
                            <th className="srtable-leftlbl">Underlying change (%)</th>
                            <td className="srtable-leftval upchg">
                                {this.getUnderlyingBidPriceChangePercentage()}
                            </td>
                            <th className="srtable-rightlbl">Delta (%)</th>
                            <td className="sttable-rightlbl delta">{this.getDelta()}</td>
                        </tr>
                        <tr>
                            <th className="srtable-leftlbl bgcolor-01">
                                Underlying price (
                                <span className="underlying_curr">{underlyingcurr}</span>)
                            </th>
                            <td className="srtable-leftval bgcolor-01 underlying_price">
                                {this.getUnderlyingBidPriceLastStopValue()}
                            </td>
                            <th className="srtable-rightlbl bgcolor-02">
                                Effective gearing (X)
                            </th>
                            <td className="srtable-rightval bgcolor-02 effective_gearing">
                                {this.getEffGearing()}
                            </td>
                        </tr>
                        <tr style={{ display: "none" }}>
                            <th className="srtable-leftlbl">Change (%)</th>
                            <td className="srtable-leftval dwpchg">{this.getDwpChange()}</td>
                            <th className="srtable-rightlbl">Expiry</th>
                            <td className="srtable-rightval last_trading_date">
                                {lasttradingdate}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderAtRightPanel() {
        let marketdata = this.props.marketdata;
        let ticker = MQSGUtil.getData(marketdata, "ticker");
        return (
            <div
                className="section qlink-section"
                id="minidwcalc"
                style={{ position: "relative", padding: '0px' }}
            >
                <div className="page-header">
                    {/* <h2 className="small">{"Warrant Calculator (" + ticker + ")"}</h2> */}
                    <h2 className="small">{"Warrant Calculator"}</h2>
                </div>
                <p>Move the sliders to estimate the bid price of the warrant.</p>
              
                <div className="row" id="wcalbox_right_tb">
                    <div className="col-md-6  col-xs-6 col-sm-6" style={{}}>
                        <div style={{ fontSize: '20px', fontWeight: '500' }}>Target entry variables</div>
                        <table className="wcalbox_table">
                            <tbody>
                                {this.entryCurrentUnderlyingBidPriceControlRightPanel()}
                                {this.dateeControlRightPanel()}
                                {this.volatilityeControlRightPanel()}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6  col-xs-6 col-sm-6" style={{ borderLeft: '1px solid #000' }}>
                        <div style={{ fontSize: '20px', fontWeight: '500' }}>Target exit variables</div>
                        <table className="wcalbox_table">
                            <tbody>
                                {this.underlyingBidPriceControlRightPanel()}
                                {this.dateControlRightPanel()}
                                {this.volatilityControlRightPanel()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <h3
                    className="bold_title"
                    style={{ fontFamily: "inherit", fontWeight: 500 }}
                >
                    Results
                </h3>
                {this.simulatedResultsUpperTable(1)}
                <div className="section-btn-wapper" style={{ textAlign: "left" }}>
                    <a
                        href="/tools/warrantcalculator"
                        className="btn btn-primary"
                        style={{ minWidth: "190px", whiteSpace: 'pre-wrap' }}
                        type="button"
                    >
                        Visit the Warrant calculator for more info!
                    </a>
                </div>
            </div>
        );
    }

    render() {
        let warrantdata = this.props.marketdata;
        let bid = MQSGUtil.getData(warrantdata, "BID");
        let ask = MQSGUtil.getData(warrantdata, "ASK");
        //#1365
        let underlyingprice = MQSGUtil.getData(warrantdata, "showUnderlying_price");
        let ticker =
            MQSGUtil.getData(warrantdata, "dsply_nmll") +
            " (" +
            MQSGUtil.getData(warrantdata, "ticker") +
            ")";
        return (
            <div>
                {this.props.marketdata && <div id="dwterms">
                    <TermsSummary
                        warrantdata={this.props.marketdata}
                        tabNum={true}
                    />
                </div>}
                <div id="initloadingbox" style={{ position: "relative", }}>
                    <div id="ticker" className="ricbar bgcolor-03">
                        {ticker}
                    </div>
                    <div id="pstable">
                        <table className="table table-striped tableSize">
                            <tbody>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>Underlying bid price</th>
                                    <td className="left underlying_bid_price" style={{ textAlign: 'left' }}>
                                        {this.toThousands(underlyingprice)}
                                    </td>
                                </tr>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>Warrant bid</th>
                                    <td className="left BID" style={{ textAlign: 'left' }}>{bid}</td>
                                </tr>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>Warrant ask</th>
                                    <td className="left ASK" style={{ textAlign: 'left' }}>{ask}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h3 className="bold_title">Input field</h3>
                    <p style={{ marginBottom: "10px" }}>
                        Either type in or move the sliders to estimate the price of the warrant (shown under “Simulated results”) based on:
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                        1. your intended underlying entry price in the left table, and see what the warrant price will be  (the default entry price shows the current underlying price. keep unchanged if you intend to enter at current levels)
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                        2. the underlying target exit price in the right table (keep unchanged if you wish only to see what the time decay impact on a future date is)
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                        3. the date until which you intend to hold the warrant, and
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                        4. your view of the warrant’s implied volatility (keep unchanged if you dont have any view on this)
                    </p>
                    <p style={{ marginBottom: "5px" }}>
                        5. in the simulated results table, find out how the warrant will perform alongside the underlying price changes
                    </p>
                    <p className="tip_box">
                        Tip: Change only the date, and keep the underlying bid price
                        and implied volatility unchanged to estimate time decay.
                    </p>
                </div>
                <div id="wcalbox">
                    {/* <div className="container-fluid"> */}
                    <div className="row">
                        <div className="col-md-6  col-xs-6 col-sm-6">
                            <div style={{ fontSize: '20px', fontWeight: '500' }}>Target entry variables</div>
                            <table className="wcalbox_table">
                                <tbody>
                                    {this.entryCurrentUnderlyingBidPriceControl()}
                                    {this.edateControl()}
                                    {this.evolatilityControl()}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-6  col-xs-6 col-sm-6" style={{ borderLeft: '1px solid #000' }}>
                            <div style={{ fontSize: '20px', fontWeight: '500' }}>Target exit variables</div>
                            <table className="wcalbox_table">
                                <tbody>
                                    {this.underlyingBidPriceControl()}
                                    {this.dateControl()}
                                    {this.volatilityControl()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                 

                    {/* <div className="visible-xs visible-sm">{this.xssmInput()}</div> */}
                    <p style={{ margin: "10px 0" }}>
                        Note that the warrant’s&nbsp;
                        <a href="/WarrantsGuidebook/impliedvolatility" target="_blank" style={{ color: '#0675C2' }}>
                            volatility{" "}
                        </a>
                        is affected by market related events and/or demand for the warrant.
                    </p>
                    <div className="resetbtn">
                        {/* javascript:location.reload() */}
                        {/* <a href="#" type="button" className="btn btn-primary">Reset</a> */}
                        <input
                            className="btn btn-primary"
                            value="Reset"
                            type="button"
                            style={{ minWidth: "100px" }}
                            onClick={this.onReset.bind(this)}
                        />
                    </div>
                </div>
                <h3 className="bold_title">Simulated results</h3>
                {this.simulatedResultsUpperTable()}
                {this.simulatedResultsLowerTable()}
                {/* <p className="small">The price above is only indicative.</p>
                <hr className="hr-hmgbm" /> */}
                <p style={{ fontSize: '12px' }}>*The warrant prices and values are only indicative</p>
                <p style={{ fontSize: '12px' }}>Note: The estimated returns are only valid on the date of usage, and may change from day to day</p>
            </div>
        );
    }
}

class WrCalculatorLogic {
    constructor(marketdata) {
        this.marketdata = marketdata;
        this.uric = MQSGUtil.getData(this.marketdata, "underlying_ric");
        this.uname = MQSGUtil.getData(this.marketdata, "underlying_name");
        this.ivMatrix = null;
        this.ivMatrixDisp = null;
        this.unpricenum = 6; //n + 1 to ease calculation
        this.ivnum = 6; //n + 1 to ease calculatio
        this.fxRate = 1;
        this.upmax = null;
        this.upmin = null;
        this.unmax = null;
        this.unmin = null;
        this.unstep = 1;
        this.udp = null;
        this.wdp = null;
        this.riskFreeRate = 0.015;
        this.unPriceProps = { spread: 0.01, dp: 2 };
        this.setUnpricePropertiesByUname();
        this.setupDecimalPlace();
        this.setupMaxMinStep();
        this.setupFxRate();
    }

    setUnpricePropertiesByUname() {
        switch (this.uname) {
            case "N225":
                this.unPriceProps.spread = 5;
                this.unPriceProps.dp = 0;
                break;
            case "HSI":
            case "STI":
                this.unPriceProps.spread = 1;
                this.unPriceProps.dp = 0;
                break;
            case "SiMSCI":
                this.unPriceProps.spread = 0.05;
                this.unPriceProps.dp = 2;
                break;
            case "S&P500":
                this.unPriceProps.spread = 0.25;
                this.unPriceProps.dp = 2;
                break;
            default:
                break;
        }
    }

    setupDecimalPlace() {
        let underlyingPrice = MQSGUtil.getNumber(
            this.marketdata,
            "underlying_price",
            null
        );
        let bid = MQSGUtil.getNumber(this.marketdata, "BID", null);
        this.udp =
            underlyingPrice !== null ? MQSGUtil.getDecimalPlace(underlyingPrice) : 0;
        this.wdp = bid !== null ? MQSGUtil.getDecimalPlace(bid) : 0;
    }

    setupMaxMinStep() {
        let upmax = null;
        let upmin = null;
        let underlyingRic = MQSGUtil.getData(this.marketdata, "underlying_ric");
        let underlyingPrice = MQSGUtil.getNumber(
            this.marketdata,
            "underlying_price",
            null
        );
        if (underlyingPrice !== null) {
            if (this.isIndexUnderlying(underlyingRic)) {
                upmax = Number((underlyingPrice * 1.35).toFixed());
                upmin = Math.max(0, Number((underlyingPrice * 0.65).toFixed()));
            } else {
                upmax = 3 * underlyingPrice;
                upmin = 0;
            }
        }
        this.unmax = upmax;
        this.unmin = upmin;
        if (this.uname === "HSI" || this.uname === "STI" || this.uname === "N225") {
            if (upmax !== null) {
                this.upmax = upmax.toFixed(0);
            }
            if (upmin !== null) {
                this.upmin = upmin.toFixed(0);
            }
        } else {
            // this.upmax = upmax.toFixed(2);
            // this.upmin = upmin.toFixed(2);
            if (upmax !== null) {
                this.upmax = upmax.toFixed(2);
            }
            if (upmin !== null) {
                this.upmin = upmin.toFixed(2);
            }
        }
        if (this.uname === "HSI" || this.uname === "STI" || this.uname === "N225") {
            this.unstep = 1;
            if (this.uname === "N225") {
                this.unstep = 5;
            }
        } else {
            this.unstep = 0.01;
            if (this.uname === "SiMSCI") this.unstep = 0.05;
            else if (this.uname === "S&P500") this.unstep = 0.25;
        }
        if (this.upmax !== null) {
            this.upmax = Number(this.upmax);
        }
        if (this.upmin !== null) {
            this.upmin = Number(this.upmin);
        }
    }

    setupFxRate() {
        let rHstClose = MQSGUtil.getData(this.marketdata, "r_hst_close", null);
        if (rHstClose !== null) {
            this.fxRate = rHstClose;
        }
    }

    isIndexUnderlying(underlyingRic) {
        let indexUnderlyingTokens = [".STI", "HSIc", "SSIcv", "ESc"];
        let isIndexUnderlying = false;
        if (underlyingRic) {
            indexUnderlyingTokens.forEach((token) => {
                if (underlyingRic.startsWith(token)) {
                    isIndexUnderlying = true;
                }
            });
        }
        return isIndexUnderlying;
    }

    getDecimalPlace(value) {
        let decimalIndex = value.indexOf(".");
        if (decimalIndex > -1) {
            return value.length - (decimalIndex + 1);
        }
        return 0;
    }

  

    caldateDiffInDays(numberOfSecondA, numberOfSecondB) {
        if (!isNaN(numberOfSecondA) && !isNaN(numberOfSecondB)) {
            let MS_PER_DAY = 1000 * 60 * 60 * 24;
            return Math.floor((numberOfSecondB - numberOfSecondA) / MS_PER_DAY);
        }
        return 0; // should not come to here
    }

    sign(x) {
        return x ? (x < 0 ? -1 : 1) : 0;
    }

    calCND(x) {
        let a1 = 0.254829592;
        let a2 = 0.284496736;
        let a3 = 1.421413741;
        let a4 = 1.453152027;
        let a5 = 1.061405429;
        let p = 0.3275911;
        let t = 1 / (1 + (p * Math.abs(x)) / Math.sqrt(2));
        let value =
            (1 / 2) *
            (1 +
                this.sign(x) *
                (1 -
                    (a1 * t -
                        a2 * Math.pow(t, 2) +
                        a3 * Math.pow(t, 3) -
                        a4 * Math.pow(t, 4) +
                        a5 * Math.pow(t, 5)) *
                    Math.exp((-x * x) / 2)));
        return value;
    }

    calDWPriceWithDividen(
        unprice,
        exercisePrice,
        riskFreeRate,
        sigma,
        TDays,
        warrantsPerShare,
        type,
        divYield
    ) {
        if (
            unprice !== null &&
            exercisePrice !== null &&
            warrantsPerShare !== null &&
            type !== null &&
            divYield !== null
        ) {
            let S = Number(unprice).toPrecision(10); //underlying price
            let X = Number(exercisePrice).toPrecision(10); //exercise price
            let c = 0;
            let T = TDays / 365;
            let F = S * Math.exp((riskFreeRate - divYield / 100) * T);

            let d1 =
                (Math.log(F / X) + ((sigma * sigma) / 2) * T) / (sigma * Math.sqrt(T));
            d1 = Number(d1).toPrecision(10);
            let d2 = d1 - sigma * Math.sqrt(T);
            d2 = Number(d2).toPrecision(10);

            if (type === "CALL") {
                c =
                    Math.exp(-riskFreeRate * T) *
                    (F * this.calCND(d1) - X * this.calCND(d2));
            } else if (type === "PUT") {
                c =
                    Math.exp(-riskFreeRate * T) *
                    (X * this.calCND(-d2) - F * this.calCND(-d1));
            }
            c = Number(c).toPrecision(10);
            return c / warrantsPerShare;
        }
        return 0; // should not come to here
    }

    calDelta(unprice, exercisePrice, riskFreeRate, sigma, TDays, type, divYield) {
        // let divYield = parseFloat(this.marketdata.div_yield/100);
        let S = unprice;
        let X = exercisePrice;
        let r = riskFreeRate;
        let T = TDays / 365;
        let F = S * Math.exp((r - divYield) * T);
        let d1 =
            (Math.log(F / X) + ((sigma * sigma) / 2) * T) / (sigma * Math.sqrt(T));
        let result = 0;
        if (type === "CALL") {
            result = this.calCND(d1) * Math.exp(-divYield * T);
        } else if (type === "PUT") {
            result = -1 * this.calCND(-d1) * Math.exp(-divYield * T);
        }
        return result;
    }

    calEffGearing(unprice, dwprice, wps, delta) {
        // let S = unprice;
        // let wp = dwprice;
        // return Math.abs(delta) * (S / (wp / wps));
        let S = Number(unprice);
        let wp = Number(dwprice);
        let getWP = wp == 0 || wps == 0 ? 0 : wp / wps;
        let getSwp = S == 0 || getWP == 0 ? 0 : S / getWP;
        return Math.abs(delta) * getSwp;
    }

    initMatrix(underlyingBidPrice, impliedVolatility, selectedDate) {
        this.initIVMatrix(underlyingBidPrice, impliedVolatility);
        this.calIVMatrix(underlyingBidPrice, selectedDate);
    }

    initIVMatrix(underlyingBidPrice, impliedVolatility) {
        let initIV =
            impliedVolatility === "N/A" ||
                impliedVolatility === "" ||
                impliedVolatility === "-" ||
                impliedVolatility === null
                ? 0
                : Number(impliedVolatility);
        let initUP = underlyingBidPrice * this.fxRate;

        if (this.ivMatrix === null) {
            this.ivMatrix = [];
            for (let i = 0; i < this.unpricenum; i++) {
                this.ivMatrix[i] = [];
                for (let j = 0; j < this.ivnum; j++) {
                    this.ivMatrix[i][j] = "";
                }
            }
        }

        for (let i = 1; i < this.ivnum; i++) {
            let iv = (i - this.ivnum / 2) * 1 + initIV;
            if (iv < 0) iv = 0;
           
            this.ivMatrix[0][i] = iv.toFixed(1);
        }
        for (let i = 1; i < this.unpricenum; i++) {
            var p = initUP + (-this.unpricenum / 2 + i) * this.unPriceProps.spread;
        
            this.ivMatrix[i][0] = p.toFixed(this.unPriceProps.dp);
        }
        this.initIVMatrixDisp(underlyingBidPrice, impliedVolatility);
    }

    initIVMatrixDisp(underlyingBidPrice, impliedVolatility) {
        let initIV =
            impliedVolatility === "N/A" ||
                impliedVolatility === "" ||
                impliedVolatility === "-" ||
                impliedVolatility === null
                ? 0
                : Number(impliedVolatility);
        let initUP = underlyingBidPrice;

        if (this.ivMatrixDisp === null) {
            this.ivMatrixDisp = [];
            for (let i = 0; i < this.unpricenum; i++) {
                this.ivMatrixDisp[i] = [];
                for (let j = 0; j < this.ivnum; j++) {
                    this.ivMatrixDisp[i][j] = "";
                }
            }
        }

        for (let i = 1; i < this.ivnum; i++) {
            let iv = (i - this.ivnum / 2) * 1 + initIV;
            if (iv < 0) iv = 0;
            
            this.ivMatrixDisp[0][i] = iv.toFixed(1);
        }
        for (var i = 1; i < this.unpricenum; i++) {
            var p = initUP + (-this.unpricenum / 2 + i) * this.unPriceProps.spread;
           
            this.ivMatrixDisp[i][0] = p.toFixed(this.unPriceProps.dp);
        }
    }

    calIVMatrix(underlyingBidPrice, selectedDate) {
        let unprice = underlyingBidPrice * this.fxRate;
        let exercisePrice = MQSGUtil.getNumber(
            this.marketdata,
            "exercise_price_cal",
            null
        );
        if (exercisePrice !== null) {
            exercisePrice = exercisePrice * this.fxRate;
        }
        let divYield = MQSGUtil.getNumber(this.marketdata, "div_yield", null);
        let type = MQSGUtil.getData(this.marketdata, "type", null);
        let maturity = Date.parse(MQSGUtil.getData(this.marketdata, "maturity"));
        let tddate = Date.parse(selectedDate); // selectedDate is date string from user input
        let TDays = this.caldateDiffInDays(tddate, maturity);
        let warrantsPerShare = MQSGUtil.getNumber(
            this.marketdata,
            "conv_ratio",
            null
        );
        for (let i = 1; i < this.unpricenum; i++) {
            for (let j = 1; j < this.ivnum; j++) {
                unprice = Number(this.ivMatrix[i][0].replace(",", ""));
                if (TDays < 0) {
                    this.ivMatrix[i][j] = "-";
                } else {
                    let sigma = Number(this.ivMatrix[0][j]) / 100;
                    let result = this.calDWPriceWithDividen(
                        unprice,
                        exercisePrice,
                        this.riskFreeRate,
                        sigma,
                        TDays,
                        warrantsPerShare,
                        type,
                        divYield
                    );
                    this.ivMatrix[i][j] = result.toFixed(3);
                }
            }
        }
    }

    getWarrantBidPrice(matrixIndex = 3) {
        return this.ivMatrix[matrixIndex][this.ivnum / 2];
    }

    getDeltaAndEffGearingAndDwpChange(underlyingBidPrice, selectedDate) {
        let uprice = underlyingBidPrice;
        let dwprice = this.ivMatrix[this.unpricenum / 2][this.ivnum / 2];
        let exercisePrice = MQSGUtil.getData(
            this.marketdata,
            "exercise_price_cal"
        );
        let type = MQSGUtil.getData(this.marketdata, "type");
        let divYield = MQSGUtil.getNumber(this.marketdata, "div_yield");
        if (divYield !== null) {
            divYield = divYield / 100;
        }
        let maturity = Date.parse(MQSGUtil.getData(this.marketdata, "maturity"));
        let tddate = Date.parse(selectedDate); // selectedDate is date string from user input
        let TDays = this.caldateDiffInDays(tddate, maturity);
        let conv_ratio = MQSGUtil.getNumber(
            this.marketdata,
            "conv_ratio_cal",
            null
        );
        let bidFromMD = MQSGUtil.getNumber(this.marketdata, "BID");
        let realDWprice = bidFromMD !== null ? bidFromMD * this.fxRate : 0;
        let dwpchg =
            (100 *
                ((!isNaN(dwprice) ? Number(dwprice).toFixed(2) : 0) - realDWprice)) /
            realDWprice;
        let result = { delta: null, effgearing: null, dwpchg: dwpchg };

        if (TDays >= 0 && conv_ratio !== null && conv_ratio !== 0) {
            let sigma = this.ivMatrix[0][this.ivnum / 2] / 100;
            let delta = this.calDelta(
                uprice * this.fxRate,
                exercisePrice * this.fxRate,
                this.riskFreeRate,
                sigma,
                TDays,
                type,
                divYield
            );
            let wps = 1 / conv_ratio;
            let effgearing = this.calEffGearing(
                uprice * this.fxRate,
                dwprice,
                wps,
                delta
            );
         
            result.delta = (delta * 100).toFixed(1);
            result.effgearing = effgearing.toFixed(1);
        }
        return result;
    }
}
class Chart extends Component {
    getData(data) {
        let chartData = {
            data1: [],
            data2: [],
            data1Axis: {
                min: null,
                max: null,
            },
            data2Axis: {
                min: null,
                max: null,
            },
        };
        if (data) {
            let arr1 = [];
            let arr2 = [];
            for (let i = 0; i < data.underlyingPrice.length; i++) {
                chartData.data1.push([
                    this.props.period === "D"
                        ? new Date(data.underlyingPrice[i]["time"].replace(' 00:00', '')).getTime() + 28800000
                        : new Date(data.underlyingPrice[i]["time"].replace(' 00:00', '')).getTime(),
                    Number(data.underlyingPrice[i]["close"]),
                ]);
                arr1.push(Number(data.underlyingPrice[i]["close"]));
            }
            for (var j = 0; j < data.warrantBidPriceSgd.length; j++) {
               
                chartData.data2.push([
                    this.props.period === "D"
                        ? new Date(data.warrantBidPriceSgd[j]["time"].replace(' 00:00', '')).getTime() + 28800000
                        : new Date(data.warrantBidPriceSgd[j]["time"].replace(' 00:00', '')).getTime(),
                    Number(data.warrantBidPriceSgd[j]["close"]),
                ]);
                arr2.push(Number(data.warrantBidPriceSgd[j]["close"]));
            }
            chartData.data1Axis.min = Math.min.apply(Math, arr1);
            chartData.data1Axis.max = Math.max.apply(Math, arr1);
            chartData.data2Axis.min = Math.min.apply(Math, arr2);
            chartData.data2Axis.max = Math.max.apply(Math, arr2);
            return chartData;
        } else {
            return chartData;
        }
    }
    floatMultiply(arg1, arg2) {
        if (arg1 == null || arg2 == null) {
            return null;
        }
        let n1, n2;
        let r1, r2; // 小数位数
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        n1 = Number(arg1.toString().replace(".", ""));
        n2 = Number(arg2.toString().replace(".", ""));
        return n1 * n2 / Math.pow(10, r1 + r2);
    }
    componentDidMount() {
        this.chartRef = React.createRef();
    }
    render() {
        let chartdata = this.getData(this.props.data);
        let that = this;
        let chartOption = {
            lang: {
                noData: "no-data-to-display",
            },
            chart: {
                type: "area",
               
            },
            title: {
                text: "",
            },
            subtitle: {
                text: "",
            },
            credits: {
                text: "",
            },
            xAxis: {
                // allowDecimals: false,
                gridLineColor: "#FAFAFA",
                crosshair: {
                    width: 1,
                    color: 'red'
                },
                gridLineWidth: 1,
                type: "datetime",
                title: {
                    text: "",
                },
                labels: {
                    // formatter: function () {
                    //   return Highcharts.dateFormat('%y/%m', this.value)
                    // }
                    formatter: function () {
                        let date = '';
                        if (that.props.period == 'D') {
                            date = Highcharts.dateFormat('%H:%M', this.value)
                        } else {
                            date = Highcharts.dateFormat('%d/%m', this.value)
                        }
                        return date
                    }
                },
                // tickInterval: 7 * 24 * 3600 * 1000,// one day,
                dateTimeLabelFormats: {
                    // day: '%d/%m/%y',
                    day: '%y/%m',
                }
            },
            yAxis: [
                {
                    // crosshair: true,
                    opposite: true,
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                    },
                    title: {
                        text: "",
                    },
                    lineWidth: 1,
                    tickWidth: 1,
                    gridLineColor: "#FAFAFA",
                    min: chartdata.data2Axis.min,
                    max: chartdata.data2Axis.max,
                },
                {
                    // crosshair: true,
                    labels: {
                        formatter: function () {
                            return this.value;
                        },
                    },
                    title: {
                        text: "",
                    },
                    lineWidth: 1,
                    tickWidth: 1,
                    gridLineColor: "#FAFAFA",
                    min: chartdata.data1Axis.min,
                    max: chartdata.data1Axis.max,
                },
            ],
            exporting: {
                enabled: false,
            },
            legend: {
                enabled: false,
            },
            tooltip: {
                split: true,
            },
            plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                        symbol: "circle",
                        radius: 2,
                        states: {
                            hover: {
                                enabled: false,
                            },
                        },
                    },
                },
                // series: {
                //   pointInterval: 24 * 3600 * 1000 * 60// one day
                // }
            },
            series: [
                {
                    name: "Underlying price",
                    yAxis: 1,
                    data: chartdata.data1,
                    tooltip: {
                        pointFormat: "Underlying price : <b>{point.y}</b>",
                        split: true,
                    },
                },
                {
                    name: "Warrant bid price (SGD)",
                    data: chartdata.data2,
                    color: "#DFC49F",
                    tooltip: {
                        pointFormat: "Warrant price (SGD) : <b>{point.y}</b>",
                        split: true,
                    },
                },
            ],
        };
        let style = {
            width: "100%",
            height: "370px",
        };
        return (
            <HighchartsReact
                highcharts={highcharts}
                options={chartOption}
                style={style}
                ref={this.chartRef}
            />
        );
        // return <div style={style} ref="charts"></div>;
    }
}
class LivematrixLogic {
    constructor(livematrix, ricdata) {
        this.livematrix = livematrix;
        this.ricdata = ricdata;

        this.isMacq = false;
        if (ricdata && "issuer_name" in ricdata) {
            if (ricdata.issuer_name?.indexOf("Macquarie") > -1) {
                this.isMacq = true;
            }
        }
        this.isSTI = false;
        this.isXIAOMI = false;
        this.isSP = false;
        this.isHKStock = false;
        if (ricdata?.underlying_ric) {
            if (ricdata.underlying_ric === ".STI") {
                this.isSTI = true;
            } else if (ricdata.underlying_ric.indexOf("ESc") > -1) {
                this.isSP = true;
            } else if (ricdata.underlying_ric.indexOf(".HK") > -1) {
                this.isHKStock = true;
            }
            if (ricdata.underlying_ric === "1810.HK") {
                this.isXIAOMI = true;
            }
        }
        this.isPut = false;
        if (ricdata?.type) {
            if (ricdata.type === "PUT") {
                this.isPut = true;
            }
        }
        this.isCompressed = false;
        if (this.livematrix !== null) {
            if (this.livematrix.length > 0) {
                if ("is_compressed" in this.livematrix[0]) {
                    if (this.livematrix[0].is_compressed) {
                        this.isCompressed = true;
                    }
                }
            }
        }
    }

    findMidPoint(iscompress, isfiveday) {
        let lmdata = this.livematrix;
        let type = this.ricdata.type;
        let lmprice = this.ricdata.underlying_bid_lm; // Number from source
        let mp = {
            price: -1,
            diff: -1,
            index: -1,
            price2: -1,
            diff2: -1,
            index2: -1,
        };
        if (lmdata !== null) {
            for (let i = 0; i < lmdata.length; i++) {
                if (iscompress && !(i % 2 === 0)) {
                    //for compressed data, process only even data
                    continue;
                }
                let ubid;
                if (isfiveday && !iscompress) {
                    ubid = Object.keys(lmdata[i])[0]; // ?
                } else {
                    ubid =
                        lmdata[i][type === "PUT" ? "underlying_ask" : "underlying_bid"];
                }
                let diff = Math.abs(lmprice - ubid);
                if (mp.index === -1 || mp.diff > diff) {
                    mp.diff2 = mp.diff;
                    mp.price2 = mp.price;
                    mp.index2 = mp.index;
                    mp.diff = diff;
                    mp.price = ubid;
                    mp.index = i;
                }
                if (lmprice < ubid && mp.index === i - 1) {
                    mp.diff2 = diff;
                    mp.price2 = ubid;
                    mp.index2 = i;
                }
            }
        }
        return mp;
    }

    findBIDMidPoint(iscompress, isfiveday) {
        let lmdata = this.livematrix;
        let lmprice = this.ricdata.BID;
        let type = this.ricdata.type;
        let mp = {
            price: -1,
            diff: -1,
            index: -1,
            price2: -1,
            diff2: -1,
            index2: -1,
        };
        for (let i = 0; i < lmdata.length; i++) {
            if (iscompress && !(i % 2 === 0)) {
                //for compressed data, process only even data
                continue;
            }
            let ubid;
            if (isfiveday && !iscompress) {
                ubid = Object.keys(lmdata[i])[0];
            } else {
                ubid = lmdata[i][type === "PUT" ? "bid" : "bid"];
            }
            let diff = Math.abs(lmprice - ubid);
            if (mp.index === -1 || mp.diff > diff) {
                mp.diff2 = mp.diff;
                mp.price2 = mp.price;
                mp.index2 = mp.index;
                mp.diff = diff;
                mp.price = ubid;
                mp.index = i;
            }
            if (lmprice < ubid && mp.index === i - 1) {
                mp.diff2 = diff;
                mp.price2 = ubid;
                mp.index2 = i;
            }
        }
        return mp;
    }

    getTableContent(page) {
        if (page) {
            return this.getHomeData();
        } else {
            if (this.livematrix.length == 0) {
                return;
            }
            if (this.isHKStock === false && this.isSP === false) {
                return this.case1();
            }
            return this.case2();
        }
    }
    getHomeData() {
        let ubidask = this.isPut ? "underlying_ask" : "underlying_bid";
        //update quote data and description
        let tablecontent = [];
        if (this.livematrix && this.livematrix.length > 4 && !this.isSTI) {
            let midpoint;
            if (this.ricdata) {
                if (!this.isXIAOMI) {
                    if (this.isCompressed) {
                        midpoint = this.findMidPoint(
                            this.livematrix,
                            this.ricdata.underlying_bid_lm,
                            true,
                            false,
                            this.ricdata.type
                        );
                        let rowShow = this.case1_1_show(ubidask, midpoint);
                        let hrow, trow;
                        let scount = 1;
                        let lcount = 1;
                        let showcount = -1;
                        let startIndex, endIndex;
                        if (midpoint.index > this.livematrix.length - 3) {
                            startIndex = midpoint.index - 4;
                            endIndex = midpoint.index + 1;
                        } else if (midpoint.index < 2) {
                            startIndex = 0;
                            endIndex = 5;
                        } else {
                            startIndex = midpoint.index - 2;
                            endIndex = midpoint.index + 3;
                        }
                        for (let i = startIndex; i < endIndex + 1; i++) {
                            hrow = this.livematrix[i];
                            trow = this.livematrix[i + 1];

                            if (!isNaN(hrow[ubidask])) {
                                hrow[ubidask] = Number(hrow[ubidask]);
                            }
                            if (hrow.head_tail_id === trow.head_tail_id) {
                                let classrow = "";
                                let isShow = false;
                                if (hrow[ubidask] === midpoint.price) {
                                    classrow += "midpoint";
                                    isShow = true;
                                } else if (hrow[ubidask] < midpoint.price) {
                                    classrow += "srow srow" + scount;
                                    if (rowShow.sShow.length > scount) {
                                        isShow = rowShow.sShow[scount];
                                    }
                                    scount++;
                                } else if (hrow[ubidask] > midpoint.price) {
                                    classrow += "lrow lrow" + lcount;
                                    if (rowShow.lShow.length > lcount) {
                                        isShow = rowShow.lShow[lcount];
                                    }
                                    lcount++;
                                }
                                // let showStyle = { display: "none" }; 有修改
                                let showStyle = {};
                                if (isShow) {
                                    showcount += 1;
                                    showStyle = {};
                                    if (showcount % 2 === 0) {
                                        classrow += " bgcolor-08";
                                    }
                                }
                                let hRow = (
                                    <tr key={i} className={classrow} style={showStyle}>
                                        <td>
                                            {MQSGUtil.formatNumberDisplay(
                                                this.isPut ? hrow.underlying_ask : hrow.underlying_bid,
                                                3, "-", true, true
                                            )}
                                        </td>
                                        <td>{MQSGUtil.formatNumberDisplay(hrow.bid, 3, "-", true, true)}</td>
                                        <td>{MQSGUtil.formatNumberDisplay(hrow.ask, 3, "-", true, true)}</td>
                                        <td>
                                            {MQSGUtil.formatNumberDisplay(
                                                this.isPut ? hrow.underlying_bid : hrow.underlying_ask,
                                                3, "-", true, true
                                            )}
                                        </td>
                                    </tr>
                                );
                                tablecontent.push(hRow);
                                let tRow = (
                                    <tr key={i + 1} className={classrow} style={showStyle}>
                                        <td>
                                            {MQSGUtil.formatNumberDisplay(
                                                this.isPut ? trow.underlying_ask : trow.underlying_bid,
                                                3, "-", true, true
                                            )}
                                        </td>
                                        <td>{MQSGUtil.formatNumberDisplay(trow.bid, 3, "-", true, true)}</td>
                                        <td>{MQSGUtil.formatNumberDisplay(trow.ask, 3, "-", true, true)}</td>
                                        <td>
                                            {MQSGUtil.formatNumberDisplay(
                                                this.isPut ? trow.underlying_bid : trow.underlying_ask,
                                                3, "-", true, true
                                            )}
                                        </td>
                                    </tr>
                                );
                                tablecontent.push(tRow);
                                i++;
                            }
                        }
                    } else {
                        midpoint = this.findMidPoint(
                            this.livematrix,
                            this.ricdata.underlying_bid_lm,
                            false,
                            false,
                            this.ricdata.type
                        );
                        let livematrixindex = 0;
                        let livematrixlimit = 9;
                        livematrixindex = midpoint.index;
                        if (livematrixindex === 0) {
                            livematrixindex = Math.ceil(this.livematrix.length / 2);
                        }
                        let startIndex, endIndex;
                        if (midpoint.index === this.livematrix.length - 1) {
                            startIndex = midpoint.index - 4;
                            endIndex = midpoint.index;
                        } else if (midpoint.index < 2) {
                            startIndex = 0;
                            endIndex = 4;
                        } else {
                            startIndex = midpoint.index - 2;
                            endIndex = midpoint.index + 2;
                        }
                        for (let i = startIndex; i < endIndex + 1; i++) {
                            let livematrixdata = this.livematrix[i];
                            let isMidPoint =
                            MQSGUtil.formatNumberDisplay(livematrixdata.underlying_bid, 3, "-", true, true) ===
                                MQSGUtil.formatNumberDisplay(midpoint.price, 3, "-", true, true)
                                ? true
                                : false;
                            let rowClassName = isMidPoint ? "midpoint" : "";
                            rowClassName += i % 2 === 0 ? " bgcolor-08" : "";
                            let row = (
                                <tr key={i} className={rowClassName}>
                                    <td>
                                        {MQSGUtil.formatNumberDisplay(
                                            this.isPut
                                                ? livematrixdata.underlying_ask
                                                : livematrixdata.underlying_bid,
                                            3, "-", true, true
                                        )}
                                    </td>
                                    <td>{MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true)}</td>
                                    <td>{MQSGUtil.formatNumberDisplay(livematrixdata.ask, 3, "-", true, true)}</td>
                                    <td>
                                        {MQSGUtil.formatNumberDisplay(
                                            this.isPut
                                                ? livematrixdata.underlying_bid
                                                : livematrixdata.underlying_ask,
                                            3, "-", true, true
                                        )}
                                    </td>
                                </tr>
                            );
                            tablecontent.push(row);
                        }
                    }
                } else {
                    for (let i = 0; i < this.livematrix.length; i++) {
                        let livematrixdata = this.livematrix[i];
                        let rowClassName = i % 2 === 0 ? " bgcolor-08" : "";
                        let row = (
                            <tr key={i} className={rowClassName}>
                                <td>
                                    {MQSGUtil.formatNumberDisplay(
                                        this.isPut
                                            ? livematrixdata.underlying_ask
                                            : livematrixdata.underlying_bid,
                                        3, "-", true, true
                                    )}
                                </td>
                                <td>{MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true)}</td>
                                <td>{MQSGUtil.formatNumberDisplay(livematrixdata.ask, 3, "-", true, true)}</td>
                                <td>
                                    {MQSGUtil.formatNumberDisplay(
                                        this.isPut
                                            ? livematrixdata.underlying_bid
                                            : livematrixdata.underlying_ask,
                                        3, "-", true, true
                                    )}
                                </td>
                            </tr>
                        );
                        tablecontent.push(row);
                    }
                }
            }
        }
        return tablecontent;
    }
    //Case 1: isHKStock === false && isSP === false
    case1() {
        if (this.isCompressed) {
            return this.case1_1();
        }
        return this.case1_2();
    }

    //Case 1.1: isHKStock === false && isSP === false && is_compressed === true
    case1_1_show(ubidask, midpoint) {
        let hrow, trow;
        let scount = 1,
            lcount = 1;
        for (let i = 0; i < this.livematrix.length; i++) {
            hrow = this.livematrix[i];
            trow = this.livematrix[i + 1];
            let hrowUbidask = null;
            if (ubidask in hrow) {
                hrowUbidask = Number(hrow[ubidask]);
            }
            let midpointPrice = Number(midpoint.price);
            if (
                hrowUbidask !== null &&
                !isNaN(hrowUbidask) &&
                !isNaN(midpointPrice)
            ) {
                if (hrowUbidask < midpointPrice) {
                    scount++;
                } else if (hrowUbidask > midpointPrice) {
                    lcount++;
                }
            }
            i++;
        }
        let sShow = new Array(scount).fill(false);
        let lShow = new Array(lcount).fill(false);

        // if ("BID" in this.ricdata && Number(this.ricdata.BID) === 0.04) {
        //   for (let i = lcount; i >= lcount - 8; i--) {
        //     lShow[i] = true;
        //   }
        // } else {
        for (let i = lcount; i >= lcount - 8; i--) {
            lShow[i] = true;
        }
        for (let i = 1; i <= 8; i++) {
            sShow[i] = true;
        }
        // }
        return { sShow, lShow };
    }

    case1_1() {
        let ubidask = this.isPut ? "underlying_ask" : "underlying_bid";
        let midpoint = this.findMidPoint(true, false);
        let lm = this.ricdata.underlying_bid_lm;
        let hrow, trow;
        let scount = 1,
            lcount = 1,
            showcount = -1;
        let rowShow = this.case1_1_show(ubidask, midpoint);
        let tablecontent = [];
        let midpointPrice = Number(midpoint.price2);
        for (let i = 0; i < this.livematrix.length - 1; i++) {
            hrow = this.livematrix[i];
            trow = this.livematrix[i + 1];
            let hrowUbidask = null;
            let trowUbidask = null;
            if (ubidask in hrow) {
                hrowUbidask = Number(hrow[ubidask]);
            }
            if (ubidask in trow) {
                trowUbidask = Number(trow[ubidask]);
            }
            if (hrowUbidask === midpointPrice) {
                if (hrowUbidask > lm) {
                    if (trowUbidask > lm) {
                        midpointPrice = Number(midpoint.price)
                    }
                } else {
                    if (trowUbidask < lm) {
                        midpointPrice = Number(midpoint.price)
                    }
                }
            }
            if (
                hrowUbidask !== null &&
                !isNaN(hrowUbidask) &&
                !isNaN(midpointPrice)
            ) {
                if (hrow.head_tail_id === trow.head_tail_id) {
                    let rowClassName = "";
                    let isShow = false;
                    if (hrowUbidask === midpointPrice) {
                        rowClassName += "midpoint";
                        isShow = true;
                    } else if (hrowUbidask < midpointPrice) {
                        rowClassName += "srow srow" + scount;
                        if (rowShow.sShow.length > scount) {
                            isShow = rowShow.sShow[scount];
                        }
                        scount++;
                    } else if (hrowUbidask > midpointPrice) {
                        rowClassName += "lrow lrow" + lcount;
                        if (rowShow.lShow.length > lcount) {
                            isShow = rowShow.lShow[lcount];
                        }
                        lcount++;
                    }
                    let showStyle = { display: "none" };
                    if (isShow) {
                        showcount += 1;
                        showStyle = {};
                        if (showcount % 2 === 0) {
                            rowClassName += " bgcolor-08";
                        }
                    }
                    let hRow = (
                        <tr key={i} className={rowClassName} style={showStyle}>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? hrow.underlying_ask : hrow.underlying_bid, 3, "-", true, true
                                )}
                            </td>
                            <td>{MQSGUtil.formatNumberDisplay(hrow.bid, 3, "-", true, true)}</td>
                            <td>{MQSGUtil.formatNumberDisplay(hrow.ask, 3, "-", true, true)}</td>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? hrow.underlying_bid : hrow.underlying_ask,
                                     3, "-", true, true
                                )}
                            </td>
                        </tr>
                    );
                    tablecontent.push(hRow);
                    let tRow = (
                        <tr key={i + 1} className={rowClassName} style={showStyle}>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? trow.underlying_ask : trow.underlying_bid,
                                     3, "-", true, true
                                )}
                            </td>
                            <td>{MQSGUtil.formatNumberDisplay(trow.bid, 3, "-", true, true)}</td>
                            <td>{MQSGUtil.formatNumberDisplay(trow.ask, 3, "-", true, true)}</td>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? trow.underlying_bid : trow.underlying_ask,
                                     3, "-", true, true
                                )}
                            </td>
                        </tr>
                    );
                    tablecontent.push(tRow);
                    i++;
                }
            }
        }
      
        return tablecontent;
    }

    //Case 1.2: isHKStock === false && isSP === false && is_compressed === false
    case1_2() {
        let midpoint = this.findMidPoint(false, false);
        let livematrixindex = 0;
        let livematrixlimit = 9;
        if (this.isSP) {
            livematrixlimit = 14;
        }
        livematrixindex = midpoint.index;
        if (livematrixindex === 0) {
            livematrixindex = Math.ceil(this.livematrix.length / 2);
        }
        let tablecontent = [];
        for (let i = 0; i < this.livematrix.length; i++) {
            if (
                i > livematrixindex - livematrixlimit &&
                i < livematrixindex + livematrixlimit
            ) {
                let livematrixdata = this.livematrix[i];
                let isMidPoint =
                    MQSGUtil.formatNumberDisplay(livematrixdata.underlying_bid, 3, "-", true, true) === MQSGUtil.formatNumberDisplay(midpoint.price, 3, "-", true, true)
                        ? true
                        : false;
                if (!isMidPoint && midpoint.diff !== 0) {
                    isMidPoint =
                        MQSGUtil.formatNumberDisplay(livematrixdata.underlying_bid, 3, "-", true, true) ===
                            MQSGUtil.formatNumberDisplay(midpoint.price2, 3, "-", true, true)
                            ? true
                            : false;
                }
               
                let rowClassName = isMidPoint ? "midpoint" : "";
                rowClassName += i % 2 === 0 ? " bgcolor-08" : "";
                let row = (
                    <tr key={i} className={rowClassName}>
                        <td>
                            {MQSGUtil.formatNumberDisplay(
                                this.isPut
                                    ? livematrixdata.underlying_ask
                                    : livematrixdata.underlying_bid,
                                3, "-", true, true
                            )}
                        </td>
                        <td>{MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true)}</td>
                                    <td>{MQSGUtil.formatNumberDisplay(livematrixdata.ask, 3, "-", true, true)}</td>
                        <td>
                            {MQSGUtil.formatNumberDisplay(
                                this.isPut
                                    ? livematrixdata.underlying_bid
                                    : livematrixdata.underlying_ask,
                                3, "-", true, true
                            )}
                        </td>
                    </tr>
                );
                tablecontent.push(row);
            }
        }
        
        return tablecontent;
    }

    //Case 2: !(isHKStock === false && isSP === false)
    case2() {
        if (this.isCompressed) {
            return this.case2_1();
        }
        return this.case2_2();
    }

    // Case 2.1: !(isHKStock === false && isSP === false) && is_compressed === true
    case2_1_show(ubidask, midpoint) {
        let hrow, trow;
        let scount = 1,
            lcount = 1;
        for (let i = 0; i < this.livematrix.length; i++) {
            hrow = this.livematrix[i];
            trow = this.livematrix[i + 1];
            let hrowUbidask = null;
            if (ubidask in hrow) {
                hrowUbidask = Number(hrow[ubidask]);
            }
            let midpointPrice = Number(midpoint.price);
            if (
                hrowUbidask !== null &&
                !isNaN(hrowUbidask) &&
                !isNaN(midpointPrice)
            ) {
                if (hrowUbidask < midpointPrice) {
                    scount++;
                } else if (hrowUbidask > midpointPrice) {
                    lcount++;
                }
            }
            i++;
        }
        let sShow = new Array(scount).fill(false);
        let lShow = new Array(lcount).fill(false);
        if (this.livematrix[0].bid < this.livematrix[this.livematrix.length - 1].bid) {
            for (let i = 0; i <= 8; i++) {
                lShow[i] = true;
            }
            // i=0
            for (let i = scount; i >= scount - 8; i--) {
                sShow[i] = true;
            }
        } else {
            for (let i = lcount; i >= lcount - 8; i--) {
                lShow[i] = true;
            }
            for (let i = 1; i <= 8; i++) {
                sShow[i] = true;
            }
        }
    
        return { sShow, lShow };
    }

    case2_1() {
        let ubidask = "bid";
        let midpoint = this.findBIDMidPoint(true, false);
        let hrow = null;
        let trow = null;
        let scount = 1,
            lcount = 1,
            showcount = -1;
        let rowShow = this.case2_1_show(ubidask, midpoint);
        let tablecontent = [];
        for (let i = 0; i < this.livematrix.length - 1; i++) {
            hrow = this.livematrix[i];
            trow = this.livematrix[i + 1];
            let hrowUbidask = null;
            if (ubidask in hrow) {
                hrowUbidask = Number(hrow[ubidask]);
            }
            let midpointPrice = Number(midpoint.price);
            if (
                hrowUbidask !== null &&
                !isNaN(hrowUbidask) &&
                !isNaN(midpointPrice)
            ) {
                if (hrow.head_tail_id === trow.head_tail_id) {
                    let rowClassName = "";
                    let isShow = false;
                    if (hrowUbidask === midpointPrice) {
                        rowClassName += "midpoint";
                        isShow = true;
                    } else if (hrowUbidask < midpointPrice) {
                        rowClassName += "srow srow" + scount;
                        if (rowShow.sShow.length > scount) {
                            isShow = rowShow.sShow[scount];
                        }
                        scount++;
                    } else if (hrowUbidask > midpointPrice) {
                        rowClassName += "lrow lrow" + lcount;
                        if (rowShow.lShow.length > lcount) {
                            isShow = rowShow.lShow[lcount];
                        }
                        lcount++;
                    }

                    
                    let showStyle = { display: "none" };
                    if (isShow) {
                        showcount += 1;
                        showStyle = {};
                        if (showcount % 2 === 0) {
                            rowClassName += " bgcolor-08";
                        }
                    }
                    let hRow = (
                        <tr key={i} className={rowClassName} style={showStyle}>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? hrow.underlying_ask : hrow.underlying_bid,
                                    3, "-", true, true
                                )}
                            </td>
                            <td>{MQSGUtil.formatNumberDisplay(hrow.bid, 3, "-", true, true)}</td>
                            <td>{MQSGUtil.formatNumberDisplay(hrow.ask, 3, "-", true, true)}</td>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? hrow.underlying_bid : hrow.underlying_ask,
                                    3, "-", true, true
                                )}
                            </td>
                        </tr>
                    );
                    tablecontent.push(hRow);
                    let tRow = (
                        <tr key={i + 1} className={rowClassName} style={showStyle}>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? trow.underlying_ask : trow.underlying_bid,
                                    3, "-", true, true
                                )}
                            </td>
                            <td>{MQSGUtil.formatNumberDisplay(trow.bid, 3, "-", true, true)}</td>
                            <td>{MQSGUtil.formatNumberDisplay(trow.ask, 3, "-", true, true)}</td>
                            <td>
                                {MQSGUtil.formatNumberDisplay(
                                    this.isPut ? trow.underlying_bid : trow.underlying_ask,
                                    3, "-", true, true
                                )}
                            </td>
                        </tr>
                    );
                    tablecontent.push(tRow);
                    i++;
                }
            }
        }
      
        return tablecontent;
    }

    // Case 2.2: !(isHKStock === false && isSP === false) && is_compressed === false
    case2_2() {
        let midpoint = this.findBIDMidPoint(false, false);
        let tick = 0.001;
        let midprice = Number(midpoint.price);
        if (midprice >= 0.2) tick = 0.005;
        let minvalue = Number((midprice - 5 * tick).toFixed(4));
        let macvalue = Number((midprice + 5 * tick).toFixed(4));
        let tablecontent = [];
        for (let i = 0; i < this.livematrix.length; i++) {
            let livematrixdata = this.livematrix[i];
            let lmdatabid = Number(livematrixdata.bid);
            if (lmdatabid >= minvalue && lmdatabid <= macvalue) {
                let isMidPoint =
                    MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true) === MQSGUtil.formatNumberDisplay(midpoint.price, 3, "-", true, true)
                        ? true
                        : false;
                if (!isMidPoint && midpoint.diff !== 0) {
                    isMidPoint =
                        MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true) === MQSGUtil.formatNumberDisplay(midpoint.price2, 3, "-", true, true)
                            ? true
                            : false;
                }
                let rowClassName = i % 2 === 0 ? " bgcolor-08" : "";
                let row = (
                    <tr key={i} className={rowClassName}>
                        <td>
                            {MQSGUtil.formatNumberDisplay(
                                this.isPut
                                    ? livematrixdata.underlying_ask
                                    : livematrixdata.underlying_bid,
                                3, "-", true, true
                            )}
                        </td>
                        <td>{MQSGUtil.formatNumberDisplay(livematrixdata.bid, 3, "-", true, true)}</td>
                                    <td>{MQSGUtil.formatNumberDisplay(livematrixdata.ask, 3, "-", true, true)}</td>
                        <td>
                            {MQSGUtil.formatNumberDisplay(
                                this.isPut
                                    ? livematrixdata.underlying_bid
                                    : livematrixdata.underlying_ask,
                                3, "-", true, true
                            )}
                        </td>
                    </tr>
                );
                tablecontent.push(row);
            }
        }
        // tableElement.html(tablecontent);
        // tableElement.find('tr:visible').filter(':even').addClass('bgcolor-08');
        return tablecontent;
    }
}
class WarrantHedget extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initData(props);
    }
    initData(props) {
        let initData = {
            sharesOwned: 100,
            underlyingprice: null,
            bidPrice: null,
            warrantBidPrice: null,
            effgearing: 0.0,
            delta: 0.0,
            effgearing2: 0.0,
            dwpchg: 0.0,
            portfolioValueChg: 0,
            warrantValueChg: 0
        };
        this.logic = new WrCalculatorLogic(props.warrantdata);
        let underlyingprice = MQSGUtil.getNumber(
            props.warrantdata,
            "underlying_price",
            null
        );
        // if(null == underlyingprice && "-" === props.warrantdata.underlying_price){
        //     underlyingprice=0;
        // }
        let bidPrice = this.getData("BID");
        let effectivegearing = this.getData("effective_gearing");
        let impliedvolatility = MQSGUtil.getNumber(
            props.warrantdata,
            "implied_volatility",
            null
        );

        let initWarrantBidPrice = this.initWarrantBidPrice(
            props.warrantdata,
            impliedvolatility,
            underlyingprice
        );
        let deltaAndEffgearing = this.logic.getDeltaAndEffGearingAndDwpChange(
            underlyingprice,
            initWarrantBidPrice.selectedDate
        );
        initData.bidPrice = bidPrice;
        initData.underlyingprice = underlyingprice;
        initData.warrantBidPrice = initWarrantBidPrice.warrantBidPrice;
        initData.effgearing = deltaAndEffgearing.effgearing;
        initData.effgearing2 = deltaAndEffgearing.effgearing;
        initData.effectivegearing = effectivegearing;
        let bdval = this.initbdval(props.warrantdata)
        let dateval = this.initdateval(props.warrantdata)
        let initecval = this.initbdval(props.warrantdata);
        let initedateval = this.initdateval(props.warrantdata);
        initData.bdval = bdval.bdval;
        initData.dateval = dateval.dateval;
        initData.ecval = initecval.bdval;
        initData.edateval = initedateval.dateval;
       
        initData.chartata = []
        if ("-" == props.warrantdata.showUnderlying_price) {
            initData.bdval.currentValue = 0;
            initData.ecval.currentValue = 0;
            initData.effgearing = 0;
            initData.effgearing2 = 0;
            initData.effectivegearing = 0;
        }
        return initData
    }
    componentDidMount() {
        this.recalculateMatrix('left');
        this.recalculateMatrix('right');
    }
    initdateval(marketdata) {
        let dateval = {
            currentValue: 0,
            stopValue: 0,
            max: 31,
            min: 0,
            step: 1,
        };
        let lasttradingdate = MQSGUtil.getData(
            marketdata,
            "last_trading_date",
            null
        );
        if (lasttradingdate !== null) {
            let lastTradeDate = Date.parse(lasttradingdate);
            let currentDate = new Date();
            let diffTime = Math.abs(lastTradeDate - currentDate);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            dateval.max = diffDays;
        }
        return { dateval };
    }
    initbdval(marketdata) {
        let bdval = {
            currentValue: 0,
            stopValue: 0,
            typing: "",
            max: 1.0,
            min: 0.0,
            step: 0.01,
            initial: 0.0,
            dp: 2,
        };
        let underlyingprice = MQSGUtil.getNumber(
            marketdata,
            "underlying_price",
            null
        );
      
        const tick = marketdata.underlying_ticker;
        if (
            tick == 'HSI' ||
            tick == 'HSTECH' ||
            tick == 'STI' ||
            tick == 'N225'
        ) {
            bdval.dp = 0;
        }
        if (underlyingprice !== null) {
            bdval.initial = underlyingprice;
            bdval.currentValue = underlyingprice;
            bdval.stopValue = underlyingprice;
            bdval.typing = this.toThousands(underlyingprice);
            let indexUnderlyingTokens = [
                ".STI",
                "HSIc",
                "SSIcv",
                "ESc"
            ];
            let maxValue = Math.ceil(underlyingprice * 3);
            for (let i = 0; i < indexUnderlyingTokens.length; i++) {
                if (marketdata.underlying_ric.indexOf(indexUnderlyingTokens[i]) !== -1) {
                    maxValue = Math.ceil(underlyingprice * 1.34);
                    break;
                }
            }
            bdval.max = maxValue;
        }
        return { bdval, underlyingprice };
    }
    generateDateString(noOfDay) {
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + noOfDay);

        let months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        let day = currentDate.getDate();
        let month = months[currentDate.getMonth()];
        let year = currentDate.getFullYear().toString().slice(2);
        let selectedDate = day + " " + month + " " + year;
        return selectedDate;
    }
    initWarrantBidPrice(marketdata, impliedvolatility, underlyingprice) {
        let warrantBidPrice = {
            currentValue: null,
            initial: null,
        };
        warrantBidPrice.initial = MQSGUtil.getData(
            marketdata,
            // "warrant_price",
            'BID',
            null
        );
        let selectedDate = this.generateDateString(0);
        this.logic.initMatrix(underlyingprice, impliedvolatility, selectedDate);
        warrantBidPrice.currentValue = warrantBidPrice.initial;
        return { warrantBidPrice, selectedDate };
    }
    getData(fieldName, dp = null) {
        if (
            this.props.warrantdata !== null &&
            fieldName in this.props.warrantdata
        ) {
            let value = this.props.warrantdata[fieldName];
            if (dp !== null) {
                return Number(value).toFixed(dp);
            }
            return value;
        }
        return "";
    }

    getTheta() {
        // "last_trading_date": "23 Feb 21"
        let lasttradingdate = this.getData("last_trading_date");
        let currDate = new Date();
        let currDateMS = currDate.getTime();
        if (lasttradingdate.length > 0) {
            let lasttradingdateMS = Date.parse(lasttradingdate);
            let diff = currDateMS - lasttradingdateMS;
            // check if expired
            if (diff <= 24 * 60 * 60 * 1000) {
                return this.getData("theta", 4);
            }
        }
        return "-";
    }

    getMoneynessClass(nc) {
        let cnm = "";
        let value = Number(nc);
        if (!isNaN(value)) {
            if (value === 1) {
                cnm = "val mny up";
            } else if (value === 2) {
                cnm = "val mny down";
            }
        }
        return cnm;
    }

    getMoneynessName(nc) {
        let nm = "";
        let value = Number(nc);
        if (!isNaN(value)) {
            if (value === 1) {
                return "ITM";
            } else if (value === 2) {
                return "OTM";
            } else {
                return "ATM";
            }
        }
        return nm;
    }
    toThousands(str) {
        if (str == Infinity || str == -Infinity || isNaN(str)) {
            return '-'
        }
        let newStr = "";
        let count = 0;
        let cpstr = Number(str).toFixed(0) + '';
        let last = ''
        if (cpstr.charAt(0) === '-') {
            last = '-';
            cpstr = cpstr.slice(1)
        }
        if (cpstr.indexOf(".") === -1) {
            for (let i = cpstr.length - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;    
                } else {
                    newStr = cpstr.charAt(i) + newStr;  
                }
                count++;
            }
            cpstr = newStr;
        }
        else {
            for (let i = cpstr.indexOf(".") - 1; i >= 0; i--) {
                if (count % 3 == 0 && count != 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr; //逐个字符相接起来
                }
                count++;
            }
            cpstr = newStr + (cpstr + "00").substr((cpstr + "00").indexOf("."), 3);
        }
        return last + cpstr
    }
    toThousand(str) {
        if (str == Infinity || str == -Infinity || isNaN(str)) {
            return '-'
        }
        let newStr = "";
        let count = 0;
        let cpstr = Number(str) + '';
        let last = ''
        if (cpstr.charAt(0) === '-') {
            last = '-';
            cpstr = cpstr.slice(1)
        }
        if (cpstr.indexOf(".") === -1) {
            for (let i = cpstr.length - 1; i >= 0; i--) {
                if (count % 3 === 0 && count !== 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr;
                }
                count++;
            }
            cpstr = newStr;
        }
        else {
            for (let i = cpstr.indexOf(".") - 1; i >= 0; i--) {
                if (count % 3 == 0 && count != 0) {
                    newStr = cpstr.charAt(i) + "," + newStr;
                } else {
                    newStr = cpstr.charAt(i) + newStr; //逐个字符相接起来
                }
                count++;
            }
            cpstr = newStr + (cpstr + "00").substr((cpstr + "00").indexOf("."), 3);
        }
        return last + cpstr
    }
    onLastPriceInputChange(event) {
        if (event.target.value.indexOf('-') != -1) {
            this.setState({ sharesOwned: 0 });
        } else {
            this.setState({ sharesOwned: event.target.value });
        }
        this.recalculateMatrix('right');
    }
    onLastPriceKeyDown(event) {
        if (event.key === "Enter" || event.type == "blur") {
            this.recalculateMatrix('right');
        }
    }
    onUnderlyingBidPriceInputChange(event) {
        let newValue = this.state.bdval;
        newValue.typing = event.target.value;
        newValue.currentValue = event.target.value;
        this.setState({ bdval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onUnderlyingBidPriceKeyDown(event, true)
            }, 1000);
        });
    }
    moneyDelete(num) {
        if (num && num !== undefined && num !== null) {
            let _num = num;
            _num = _num.toString();
            _num = _num.replace(/,/gi, '');
            return _num
        } else {
            return num
        }
    }
    onUnderlyingBidPriceKeyDown(event, val) {
        if (event.key === "Enter" || val === true) {
            let value = null;
            if (this.state.bdval.typing.indexOf(',') !== -1) {
                value = Number(this.moneyDelete(this.state.bdval.typing));
            } else {
                value = Number(this.state.bdval.typing);
            }
            if (this.state.bdval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.bdval.min || value > this.state.bdval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = this.state.bdval.initial;
            }
            let event = { target: { value } };
            this.onUnderlyingBidPriceChangeStop(event);
        }
    }
    onECUnderlyingBidPriceKeyDown(event, val) {
        if (event.key === "Enter" || val === true) {
            let value = null;
            if (this.state.ecval.typing.indexOf(',') !== -1) {
                value = Number(this.moneyDelete(this.state.ecval.typing));
            } else {
                value = Number(this.state.ecval.typing);
            }
            if (this.state.ecval.typing.length > 0 && !isNaN(value)) {
                if (value < this.state.ecval.min || value > this.state.ecval.max) {
                    value = null;
                }
            } else {
                value = null;
            }
            if (value === null) {
                value = 0;
            }
            let event = { target: { value } };
            this.onECUnderlyingBidPriceChangeStop(event);
        }
    }
    onUnderlyingBidPriceChangeStop(event) {
        let newValue = this.state.bdval;
        newValue.currentValue = event.target.value;
        newValue.stopValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value.toFixed(this.state.bdval.dp));
        this.setState({ bdval: newValue }, () => {
            this.recalculateMatrix('right');
        });
    }
    onUnderlyingBidPriceChange(event) {
        let newValue = this.state.bdval;
        newValue.currentValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value);
        this.setState({ bdval: newValue });
    }
    getDate() {
        return this.generateDateString(this.state.dateval.currentValue);
    }
    recalculateMatrix(
        n
    ) {
        let impliedVolatilityUse = MQSGUtil.getNumber(
            this.props.warrantdata,
            "implied_volatility",
            null
        );
        let underlyingBidPriceUse = '';
        let selectedDateUse = '';
        let effgearingLeftValue = 0;
        let effgearingRightValue = 0;
        if (n == 'left') {
            underlyingBidPriceUse = this.state.ecval.currentValue;
            selectedDateUse = this.generateDateString(this.state.edateval.currentValue);
        } else {
            underlyingBidPriceUse = this.state.bdval.currentValue;
            selectedDateUse = this.generateDateString(this.state.dateval.currentValue);
        }
        this.logic.initMatrix(
            underlyingBidPriceUse,
            impliedVolatilityUse,
            selectedDateUse
        );
        let calculatedWarrantBidPrice = this.logic.getWarrantBidPrice();

        if (!isNaN(Number(calculatedWarrantBidPrice))) {
            let warrantBidPrice = this.state.warrantBidPrice;
            if (n == 'left') {
                warrantBidPrice.initial = calculatedWarrantBidPrice;
            } else {
                warrantBidPrice.currentValue = calculatedWarrantBidPrice;
            }
            this.setState({ warrantBidPrice });
        }
        let deltaAndEffgearing = this.logic.getDeltaAndEffGearingAndDwpChange(
            underlyingBidPriceUse,
            selectedDateUse
        );
        let sharesOwned = this.state.sharesOwned || 0;
        let bdvalCurrent = this.state.bdval?.currentValue || 0;
        let ecvalCurrent = this.state.ecval?.currentValue || 0;
        let effectivegearing = this.state.effectivegearing || 0;
        let warrantBidPriceInitial = this.state.warrantBidPrice?.initial || 1;
        let warrantBidPriceCurrent = this.state.warrantBidPrice?.currentValue || 0;
        
        let portfolioValue = ((sharesOwned * bdvalCurrent) - (ecvalCurrent * sharesOwned));
        let warrantValue = (((ecvalCurrent * sharesOwned) / effectivegearing / warrantBidPriceInitial * warrantBidPriceCurrent) - ((ecvalCurrent * sharesOwned) / effectivegearing));
        let denominator = ecvalCurrent * sharesOwned;
        let portfolioValueChg = denominator !== 0 ? ((portfolioValue / denominator) * 100).toFixed(1) : "0";
        let warrantValueChg = denominator !== 0 ? ((warrantValue / (denominator / effectivegearing)) * 100).toFixed(1) : "0";
        let fx = this.getData("fx");
        let underlying_curr = this.getData("underlying_curr");
        if ("NaN" == portfolioValueChg || "Infinity" == portfolioValueChg) {
            portfolioValueChg = 0;
        }
        if(n == 'left'){
            effgearingLeftValue = deltaAndEffgearing.effgearing;
            effgearingRightValue = this.state.effgearing2 || 0;
        }else{
            effgearingRightValue = deltaAndEffgearing.effgearing;
            effgearingLeftValue = this.state.effectivegearing || 0;
        }
        this.setState({
            delta: deltaAndEffgearing.delta,
            effectivegearing:effgearingLeftValue,
            effgearing2: effgearingRightValue,
            dwpchg: deltaAndEffgearing.dwpchg,
            chartata: [Number(this.getexchangeRate(portfolioValue, underlying_curr, fx)), Number(this.getexchangeRate(warrantValue, underlying_curr, fx))],
            portfolioValueChg: portfolioValueChg,
            warrantValueChg: warrantValueChg
        });

    }
    getDateMS() {
        let currentDate = new Date();
        let noOfDay = this.state.dateval?.currentValue || 0;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        // 验证日期是否有效
        if (isNaN(currentDate.getTime())) {
            return new Date();
        }
        return currentDate;
    }
    getbgDate(date) {
        let m = new Date().getMonth() + 1;
        let M = new Date(date).getMonth() + 1;
        let cls = m !== M ? "random" : undefined;
        return cls
    }
    onDateChange(value) {
        let newValue = { ...this.state.dateval };
        let newValue2 = { ...this.state.edateval };
        newValue.currentValue = Number(value)
        if (newValue.currentValue <= newValue2.currentValue) {
            newValue2.currentValue = Number(value)
            this.setState({ edateval: newValue2 }, () => {
                this.recalculateMatrix('left');
            });
        }
        this.setState({ dateval: newValue }, () => {
            this.recalculateMatrix('right');
        });
    }
    onDateChangeStop(value) {
        let newValue = this.state.dateval;
        let newValue2 = { ...this.state.edateval };
        newValue.currentValue = Number(value)
        newValue.stopValue = Number(value)
        if (newValue.currentValue <= newValue2.currentValue) {
            newValue2.currentValue = Number(value)
            this.setState({ edateval: newValue2 }, () => {
                this.recalculateMatrix('left');
            });
        }
        this.setState({ dateval: newValue }, () => {
            this.recalculateMatrix('right');
        });
    }
    onDatePickerChange(date) {
        let newValue = { ...this.state.dateval };
        let newValue2 = { ...this.state.edateval };
        let oneDayMS = 24 * 60 * 60 * 1000;
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        let noDay = 0;
        let diffMS = date.getTime() - currentDate.getTime();
        if (diffMS >= 0) {
            noDay = diffMS / oneDayMS;
            if (noDay >= newValue.max) {
                noDay = newValue.max;
            }
        }
        newValue.currentValue = noDay;
        newValue.stopValue = noDay;
        if (newValue.currentValue < newValue2.currentValue) {
            newValue2.currentValue = noDay;
            this.setState({ edateval: newValue2 }, () => {
                this.recalculateMatrix('left');
            });
        }
        this.setState({ dateval: newValue }, () => {
            this.recalculateMatrix('right');
        });
    }
    onLastDatePriceInputChange(event) {
        let newValue = { ...this.state.dateval };
        let newEValue = { ...this.state.edateval };
        if (isNaN(event.target.value)) {

        } else {
            if (event.target.value < 0) {
                newValue.currentValue = Number(newValue.currentValue);
                newValue.stopValue = Number(newValue.stopValue);
            } else if (Number(event.target.value) + Number(newEValue.currentValue) > newValue.max) {
                newValue.currentValue = Number(newValue.max);
                newValue.stopValue = Number(newValue.max);
            } else {
                newValue.currentValue = Number(newEValue.currentValue) + Number(event.target.value);
                newValue.stopValue = Number(newEValue.currentValue) + Number(event.target.value);
            }
        }
        this.setState({ dateval: newValue }, () => {
            this.recalculateMatrix('right');
        });

    }
    onLastDatePriceKeyDown(event) {
        if (event.key === "Enter" || event.type == "blur") {
            this.recalculateMatrix('right');
        }
    }
    onECUnderlyingBidPriceInputChange(event) {
        let newValue = this.state.ecval;
        newValue.typing = event.target.value;
        newValue.currentValue = event.target.value;
        this.setState({ ecval: newValue }, () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onECUnderlyingBidPriceKeyDown(event, true)
            }, 1000);
        });
    }
    oneDateChange(value) {
        let newValue = { ...this.state.edateval };
        let newValue2 = { ...this.state.dateval };
        newValue.currentValue = Number(value)
        if (newValue.currentValue >= newValue2.currentValue) {
            newValue2.currentValue = Number(value)
            this.setState({ dateval: newValue2 }, () => {
                this.recalculateMatrix('right');
            });
        }
        this.setState({ edateval: newValue }, () => {
            this.recalculateMatrix('left');
        });
    }
    oneDateChangeStop(value) {
        let newValue = { ...this.state.edateval };
        let newValue2 = { ...this.state.dateval };
        newValue.currentValue = Number(value)
        newValue.stopValue = Number(value)
        if (newValue.currentValue >= newValue2.currentValue) {
            newValue2.currentValue = Number(value)
            this.setState({ dateval: newValue2 }, () => {
                this.recalculateMatrix('right');
            });
        }
        this.setState({ edateval: newValue }, () => {
            this.recalculateMatrix('left');
        });
    }
    oneDatePickerChange(date) {
        let newValue = { ...this.state.edateval };
        let newValue2 = { ...this.state.dateval };
        let oneDayMS = 24 * 60 * 60 * 1000;
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
        let noDay = 0;
        let diffMS = date.getTime() - currentDate.getTime();
        if (diffMS >= 0) {
            noDay = diffMS / oneDayMS;
            if (noDay >= newValue.max) {
                noDay = newValue.max;
            }
        }
        newValue.currentValue = noDay;
        newValue.stopValue = noDay;
        if (newValue.currentValue > newValue2.currentValue) {
            newValue2.currentValue = noDay;
            this.setState({ dateval: newValue2 }, () => {
                this.recalculateMatrix('right');
            });
        }
        this.setState({ edateval: newValue }, () => {
            this.recalculateMatrix('left');
        });
    }
    geteDateMS() {
        let currentDate = new Date();
        let noOfDay = this.state.edateval?.currentValue || 0;
        currentDate.setDate(currentDate.getDate() + noOfDay);
        // 验证日期是否有效
        if (isNaN(currentDate.getTime())) {
            return new Date();
        }
        return currentDate;
    }
    onECUnderlyingBidPriceChange(event) {
        let newValue = this.state.ecval;
        newValue.currentValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value);
        this.setState({ ecval: newValue });
    }
    onECUnderlyingBidPriceChangeStop(event) {
        let newValue = this.state.ecval;
        newValue.currentValue = event.target.value;
        newValue.stopValue = event.target.value;
        newValue.typing = this.toThousands(event.target.value.toFixed(this.state.ecval.dp));
        this.setState({ ecval: newValue }, () => {
            this.recalculateMatrix('left');
        });
    }
    isStrictlyInfinity(number) {
        return number == Infinity || number == -Infinity || isNaN(number);
    }
    getNumberValue(v) {
        if (v == Infinity || v == -Infinity || isNaN(v)) {
            return '-';
        } else {
            return v;
        }
    }
    getexchangeRate(value, underlying_curr, fx = 1) {
        if (underlying_curr == 'HKD') {
            return (value * fx).toFixed(0)
        } else if (underlying_curr == 'JPY') {
            return (value / fx).toFixed(0)
        } else if (underlying_curr == 'USD') {
            return (value * fx).toFixed(0)
        } else if (underlying_curr == 'SGD') {
            return value.toFixed(0)
        } else {
            return value.toFixed(0)
        }
    }
    getIncreaseRate() {
        if (0 == this.state.ecval.currentValue) {
            return 0;
        }
        let data = ((this.state.bdval.currentValue - this.state.ecval.currentValue) / this.state.ecval.currentValue) * 100
        return data.toFixed(1);
    }
    roundToNearestHundred(num) {
        return Math.round(num / 100) * 100;
    }
    render() {
        let hstclose = this.getData("HST_CLOSE");
        let trdprc1 = this.getData("TRDPRC_1");
        let openprc = this.getData("OPEN_PRC");
        let acvol1scaled = this.getData("ACVOL_1_SCALED");
        let high1 = this.getData("HIGH_1");
        let turnoverscaled = this.getData("TURNOVER_SCALED");
        let low1 = this.getData("LOW_1");
        let currency = this.getData("currency");
        let underlying_curr = this.getData("underlying_curr");
        let underlyingprice = this.getData("underlying_price");
        let fx = this.getData("fx");
        let that = this;
        let displayName = this.getData("dsply_name");

        if (this.props.warrantdata && displayName && displayName.indexOf('Tencent') !== -1) {
            let conv_ratio_cal = this.getData("conv_ratio_cal");
            let exercise_price_cal = this.getData("exercise_price_cal");
            let convratio = conv_ratio_cal ? Number(conv_ratio_cal).toFixed(3) : '-';
            let exerciseprice = exercise_price_cal ? Number(exercise_price_cal).toFixed(3) : '-';
        } else if (
            this.props.warrantdata &&
            displayName &&
            (displayName.indexOf('SembInd') !== -1 ||
                displayName.indexOf('CityDev') !== -1 ||
                displayName.indexOf('KepCorp') !== -1 ||
                displayName.indexOf('Singtel') !== -1
            )
        ) {
            let conv_ratio_cal = this.getData("conv_ratio_cal");
            let convratio = conv_ratio_cal ? Math.floor(Number(conv_ratio_cal) * 100) / 100 : '-';

        }
        let style = {
            width: "100%",
            height: "370px",
        };
        let finalData = [];
        for (let i = 0; i < this.state.chartata.length; i++) {
            let d = this.state.chartata[i];
            finalData.push({
                y: Math.abs(d),
                color: d > 0 ? 'green' : d < 0 ? 'red' : 'yellow'
            })
        }
        let chartOption = {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: ['Change in underlying portfolio value', 'Change in warrant value']
            },
            yAxis: {
                // min: 0,
                title: {
                    text: ''
                },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return `<span style="color:${this.color}">${this.color == 'red' ? '-' + that.toThousands(this.y) : '+' + that.toThousands(this.y)}</span>`
                        },
                    }

                }
            },
            tooltip: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            series: [{
                name: '',
                data: finalData
            }]
        }
        return (
            <div>
                {this.props.warrantdata && <div id="dwterms">
                    <TermsSummary
                        warrantdata={this.props.warrantdata}
                        tabNum={true}
                    />
                </div>}
                <p style={{ margin: '15px 0px' }}>Note: index warrants will not perfectly hedge one’s underlying portfolio</p>
                <div id="indtable" style={{ position: "relative" }}>
                    {/* visible-md visible-lg */}
                    <table className="table  table-closed table-striped indicator_table TermsTable" id="hedging_tool" style={{ tableLayout: 'fixed' }}>
                        <tbody>
                            {/* style={{ borderBottom: '1px solid #FECC0A', borderTop: '0px' }} */}
                            <tr >
                                <th style={{ color: '#000', fontWeight: 'bold' }}>Starting position</th>
                                <th></th>
                                <th style={{ color: '#000', fontWeight: 'bold' }}>Target exit</th>
                                <th></th>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: '0px' }}>Number of shares owned</th>
                                <th style={{ paddingBottom: '0px' }}>
                                    <input
                                        type="number"
                                        className="hedging_tool_inpu"
                                        min="0"
                                        style={{
                                            width: '80%'
                                        }}
                                        value={this.state.sharesOwned}
                                        onKeyDown={(event) => this.onLastPriceKeyDown(event)}
                                        onChange={(event) =>
                                            this.onLastPriceInputChange(event)
                                        }
                                        onBlur={
                                            (event) =>
                                                this.onLastPriceKeyDown(event)
                                        } />
                                </th>
                                <th colSpan="2" >
                                    <div style={{marginBottom:"5px"}}>
                                        Where you think the share price will head to
                                    </div>
                                    <div className="flex">
                                        <div className="w50">
                                            <input
                                                className="wcalbox-input underlying_bid_price"
                                                type="number"
                                                maxLength="10"
                                                name="bdval"
                                                value={this.state.bdval.currentValue}
                                                onChange={(event) => this.onUnderlyingBidPriceInputChange(event)}
                                                style={{ width: '50%', textAlign: 'center' }}
                                            />
                                            <span style={{ color: this.getIncreaseRate() > 0 ? 'green' : 'red', marginLeft: '5px' }}>{this.getIncreaseRate() > 0 ? '+' + this.getIncreaseRate() + '%' : this.getIncreaseRate() + '%'}</span>
                                        </div>
                                        <div  className="w50">
                                            <Slider
                                                value={this.state.bdval.currentValue}
                                                onChange={(value) => this.onUnderlyingBidPriceChange({ target: { value } })}
                                                onChangeComplete={(value) => this.onUnderlyingBidPriceChangeStop({ target: { value } })}
                                                step={this.state.bdval.step}
                                                max={this.state.bdval.max}
                                                min={this.state.bdval.min}
                                                reverse={false}
                                            />
                                        </div>
                                    </div>
                                </th>
                                {/* <th>
                                </th> */}
                            </tr>
                            <tr>
                                <th style={{ paddingTop: '0px' }} className="tool_Picker">
                                    <div style={{ marginBottom: '5px' }}>Date</div>
                                    <DatePicker
                                        selected={this.geteDateMS()}
                                        dateFormat="dd MMM yy"
                                        onChange={(date) => this.oneDatePickerChange(date)}
                                        minDate={new Date()}
                                        maxDate={this.props.warrantdata?.last_trading_date ? new Date(this.props.warrantdata.last_trading_date) : new Date()}
                                    />

                                </th>
                                <th className="tool_Slider" style={{ paddingTop: '0px' }}>
                                    <Slider
                                        value={this.state.edateval.currentValue}
                                        onChange={this.oneDateChange.bind(this)}
                                        onChangeComplete={this.oneDateChangeStop.bind(this)}
                                        step={this.state.edateval.step}
                                        max={this.state.edateval.max}
                                        min={this.state.edateval.min}
                                        reverse={false}
                                        style={{ width: '100%' }}
                                    />
                                </th>
                                <th colSpan="2">
                                    <div style={{marginBottom:"5px"}}>
                                        Number of days warrant is held
                                    </div>
                                    <div className="flex">
                                        <div className="w50">
                                        <DatePicker
                                            // selected={this.state.startDate}
                                            selected={this.getDateMS()}
                                            dateFormat="dd MMM yy"
                                            onChange={(date) => this.onDatePickerChange(date)}
                                            // minDate={new Date()}
                                            minDate={this.geteDateMS()}
                                            maxDate={this.props.warrantdata?.last_trading_date ? new Date(this.props.warrantdata.last_trading_date) : new Date()}
                                        />
                                        <input
                                            type="number"
                                            className="hedging_tool_inpu"
                                            style={{
                                                width: '32%',
                                                marginLeft: '21px'
                                            }}
                                            value={Math.abs(this.state.dateval.currentValue - this.state.edateval.currentValue)}
                                            onKeyDown={(event) => this.onLastDatePriceKeyDown(event)}
                                            onChange={(event) =>
                                                this.onLastDatePriceInputChange(event)
                                            }
                                            onBlur={
                                                (event) =>
                                                    this.onLastDatePriceKeyDown(event)
                                            } />
                                            </div>
                                            <div  className="w50">
                                        <Slider
                                            value={this.state.dateval.currentValue}
                                            onChange={this.onDateChange.bind(this)}
                                            onChangeComplete={this.onDateChangeStop.bind(this)}
                                            step={this.state.dateval.step}
                                            max={this.state.dateval.max}
                                            min={this.state.dateval.min}
                                            reverse={false}
                                        />
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th colSpan="2">
                                    <div >Current underlying price</div>
                                </th>
                                <th style={{ borderRight: '0px', borderLeft: '1px solid #000' }}></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th>
                                    <input
                                        className="wcalbox-input underlying_bid_price"
                                        type="number"
                                        maxLength="10"
                                        name="bdval"
                                        value={this.state.ecval.currentValue}
                                        onChange={(event) => this.onECUnderlyingBidPriceInputChange(event)}
                                        style={{ width: '80%', textAlign: 'center' }}
                                    />

                                </th>
                                <th className="tool_Slider2">
                                    <Slider
                                        value={this.state.ecval.currentValue}
                                        onChange={(value) => this.onECUnderlyingBidPriceChange({ target: { value } })}
                                        onChangeComplete={(value) => this.onECUnderlyingBidPriceChangeStop({ target: { value } })}
                                        step={this.state.ecval.step}
                                        max={this.state.ecval.max}
                                        min={this.state.ecval.min}
                                        reverse={false}
                                    />
                                </th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th>Underlying portfolio value</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.toThousands(this.getexchangeRate(this.state.ecval.currentValue * this.state.sharesOwned, underlying_curr, fx)))}</th>
                                <th>Underlying portfolio value</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.toThousands(this.getexchangeRate(this.state.sharesOwned * this.state.bdval.currentValue, underlying_curr, fx)))}</th>
                            </tr>
                            <tr>
                                <th>Currency coversion rate</th>
                                {/* <th>{`${underlying_curr == 'SGD' ? '1.0 SGD' : underlying_curr == 'JPY' ? fx + '(' + currency + '/' + underlying_curr + ')' : fx + '(' + underlying_curr + '/' + currency + ')'}`}</th> */}
                                <th>
                                    <span>{underlying_curr == 'SGD' ? '1.0 ' : MQSGUtil.formatNumberDisplay(fx) + ' '}</span>
                                    <span className="hidden-xs">{`${underlying_curr == 'SGD' ? 'SGD' : underlying_curr == 'JPY' ? '(' + currency + '/' + underlying_curr + ')' : '(' + underlying_curr + '/' + currency + ')'}`}</span>
                                    <div className="visible-xs">{`${underlying_curr == 'SGD' ? 'SGD' : underlying_curr == 'JPY' ? '(' + currency + '/' + underlying_curr + ')' : '(' + underlying_curr + '/' + currency + ')'}`}</div>
                                </th>
                                <th>Warrant price</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.state.warrantBidPrice?.currentValue)}</th>
                            </tr>
                            <tr>
                                <th>Warrant price</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.state.warrantBidPrice?.initial)}</th>
                                <th>Warrant effective gearing</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.state.effgearing2)}</th>
                            </tr>

                            <tr>
                                <th>Warrant effective gearing</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.state.effectivegearing)}</th>
                                <th>Warrant value</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.toThousands(this.roundToNearestHundred(this.getNumberValue((this.getexchangeRate((this.state.ecval?.currentValue || 0) * (this.state.sharesOwned || 0), underlying_curr, fx) / (this.state.effectivegearing || 1) / (this.state.warrantBidPrice?.initial || 1))) * (this.state.warrantBidPrice?.currentValue || 0))))}</th>
                            </tr>
                            <tr>
                                <th>Warrant value</th>
                                <th>{MQSGUtil.formatNumberDisplay(this.toThousands((this.getexchangeRate((this.state.ecval?.currentValue || 0) * (this.state.sharesOwned || 0), underlying_curr, fx) / (this.state.effectivegearing || 1))))}</th>
                                <th></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th style={{ border: 'dashed 2px #FECC0A', borderRight: '0px' }}>Number of warrants to hedge with</th>
                                <th style={{ border: 'dashed 2px #FECC0A', borderLeft: '0px' }}>{MQSGUtil.formatNumberDisplay(this.toThousands(this.roundToNearestHundred(this.getNumberValue((this.getexchangeRate((this.state.ecval?.currentValue || 0) * (this.state.sharesOwned || 0), underlying_curr, fx) / (this.state.effectivegearing || 1) / (this.state.warrantBidPrice?.initial || 1))))))}</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h3>Simulated breakeven</h3>
                <div className="row" style={{ overflowX: 'auto' }}>
                    <div className="col-md-6 col-xs-6 col-sm-6">
                        <table id="ivtable" className="table table-striped-inverse">
                            <thead>
                                <tr className="row_0">
                                    <th >Change in underlying portfolio value (SGD)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="wprice_3 active" style={{ color: this.state.chartata[0] < 0 ? 'red' : 'green' }}>
                                        {MQSGUtil.formatNumberDisplay(this.state.chartata[0] > 0 ? '+' + this.toThousands(this.state.chartata[0]) : this.toThousands(this.state.chartata[0]))}
                                        &nbsp;
                                        <span style={{ color: Number(this.state.portfolioValueChg) == 0 ? '' : Number(this.state.portfolioValueChg) < 0 ? 'red' : 'green', marginLeft: '2px' }}>{'(' + (Number(this.state.portfolioValueChg) > 0 ? '+' : '') + MQSGUtil.formatNumberDisplay(this.state.portfolioValueChg) + '%)'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6 col-xs-6 col-sm-6" style={{ borderLeft: '1px solid #000' }}>
                        <table id="ivtable" className="table table-striped-inverse">
                            <thead>
                                <tr className="row_0">
                                    <th >Change in warrant value (SGD)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="uprice_3 active" style={{ color: this.state.chartata[1] < 0 ? 'red' : 'green' }}>
                                        {MQSGUtil.formatNumberDisplay(this.isStrictlyInfinity(this.state.chartata[1]) ? '0' : this.state.chartata[1] > 0 ? '+' + this.toThousands(this.state.chartata[1]) : this.toThousands(this.state.chartata[1]))}
                                        &nbsp;
                                        <span style={{ color: Number(this.state.warrantValueChg) == 0 ? '' : Number(this.state.warrantValueChg) < 0 ? 'red' : 'green', marginLeft: '2px' }}>{this.isStrictlyInfinity(this.state.warrantValueChg) ? '(0.0%)' : '(' + (Number(this.state.warrantValueChg) > 0 ? '+' : '') + MQSGUtil.formatNumberDisplay(this.state.warrantValueChg) + '%)'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row" id="hedging_tool_breakeven" >
                    <div className="col-md-6 col-xs-6 col-sm-6">
                        <table id="ivtable" className="table table-striped-inverse" style={{ tableLayout: 'fixed' }}>
                            <tbody>
                                <tr>
                                    <td className="wprice_3 active" style={{ textAlign: 'left' }}>
                                        Share price
                                    </td>
                                    <td className="wprice_3 active" style={{ textAlign: 'right' }}>
                                        <input
                                            className="wcalbox-input underlying_bid_price"
                                            type="number"
                                            maxLength="10"
                                            name="bdval"
                                            value={this.state.bdval.currentValue}
                                            onChange={(event) => this.onUnderlyingBidPriceInputChange(event)}
                                            style={{ width: '70%', float: 'left' }}
                                        />
                                        <span className="" style={{ float: 'left', color: this.getIncreaseRate() > 0 ? 'green' : 'red', marginLeft: '2px' }}>{(this.getIncreaseRate() > 0 ? '+' : '') + MQSGUtil.formatNumberDisplay(this.getIncreaseRate()) + '%'}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="wprice_3 active" style={{ textAlign: 'left' }}>
                                        Number of days
                                    </td>
                                    <td className="wprice_3 active" style={{ textAlign: 'right' }}>
                                        {/* <DatePicker
                                            selected={this.getDateMS()}
                                            dateFormat="dd MMM yy"
                                            onChange={(date) => this.onDatePickerChange(date)}
                                            minDate={new Date()}
                                            dayClassName={(date) =>
                                                this.getbgDate(date)
                                            }
                                            style={{ width: '100%' }}
                                        /> */}
                                        <input
                                            type="number"
                                            className="hedging_tool_inpu"
                                            style={{
                                                width: '100%',
                                            }}
                                            value={Math.abs(this.state.dateval.currentValue - this.state.edateval.currentValue)}
                                            onKeyDown={(event) => this.onLastDatePriceKeyDown(event)}
                                            onChange={(event) =>
                                                this.onLastDatePriceInputChange(event)
                                            }
                                            onBlur={
                                                (event) =>
                                                    this.onLastDatePriceKeyDown(event)
                                            } />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6 col-xs-6 col-sm-6" >
                        <table id="ivtable" className="table table-striped-inverse" style={{ tableLayout: 'fixed' }}>
                            <tbody>
                                <tr>
                                    <td className="uprice_3 active" style={{ textAlign: 'left',height:'39px' }}>
                                        <Slider
                                            value={this.state.bdval.currentValue}
                                            onChange={(value) => this.onUnderlyingBidPriceChange({ target: { value } })}
                                            onChangeComplete={(value) => this.onUnderlyingBidPriceChangeStop({ target: { value } })}
                                            step={this.state.bdval.step}
                                            max={this.state.bdval.max}
                                            min={this.state.bdval.min}
                                            reverse={false}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="uprice_3 active" style={{ textAlign: 'left',height:'39px' }}>
                                        <Slider
                                            value={this.state.dateval.currentValue}
                                            onChange={this.onDateChange.bind(this)}
                                            onChangeComplete={this.onDateChangeStop.bind(this)}
                                            step={this.state.dateval.step}
                                            max={this.state.dateval.max}
                                            min={this.state.dateval.min}
                                            reverse={false}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    <HighchartsReact
                        highcharts={highcharts}
                        options={chartOption}
                        style={style}
                        ref={this.chartRef}
                    />
                    <p style={{ fontSize: '12px' }}>*The warrant prices and values are only indicative</p>
                    <p style={{ fontSize: '12px' }}>**The warrant price are provided for your personal use and is intended for information purpose only and does not constitute an offer, a solicitation, an advice, a recommendation or an indication to buy or sell the underlying securities or warrant. Macquarie shall not be liable for the accuracy or completeness of any information or for any loss or damage however caused arising in connection with any information, including without limitation any direct, indirect, special or consequential loss and loss of profits whether in part or in full.</p>
                    <p style={{ fontSize: '12px' }}>Note: The estimated returns are only valid on the date of usage, and may change from day to day</p>
                </div >
            </div >
        );
    }
}

export { LiveMatrixTodayTable, IndtableShow, TermsChart, WrCalculatorBox, LivematrixLogic, WarrantHedget }